var __defProp = Object.defineProperty,
  __defNormalProp = (e, t, i) =>
    t in e
      ? __defProp(e, t, {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: i,
        })
      : (e[t] = i),
  __publicField = (e, t, i) => (
    __defNormalProp(e, "symbol" != typeof t ? t + "" : t, i), i
  );

function Delegate(e) {
  (this.listenerMap = [{}, {}]),
    e && this.root(e),
    (this.handle = Delegate.prototype.handle.bind(this)),
    (this._removedListeners = []);
}

function matchesTag(e, t) {
  return e.toLowerCase() === t.tagName.toLowerCase();
}

function matchesRoot(e, t) {
  return this.rootElement === window
    ? t === document || t === document.documentElement || t === window
    : this.rootElement === t;
}

function matchesId(e, t) {
  return e === t.id;
}
(Delegate.prototype.root = function (e) {
  const t = this.listenerMap;
  let i;
  if (this.rootElement) {
    for (i in t[1])
      t[1].hasOwnProperty(i) &&
        this.rootElement.removeEventListener(i, this.handle, !0);
    for (i in t[0])
      t[0].hasOwnProperty(i) &&
        this.rootElement.removeEventListener(i, this.handle, !1);
  }
  if (!e || !e.addEventListener)
    return this.rootElement && delete this.rootElement, this;
  for (i in ((this.rootElement = e), t[1]))
    t[1].hasOwnProperty(i) &&
      this.rootElement.addEventListener(i, this.handle, !0);
  for (i in t[0])
    t[0].hasOwnProperty(i) &&
      this.rootElement.addEventListener(i, this.handle, !1);
  return this;
}),
  (Delegate.prototype.captureForType = function (e) {
    return (
      -1 !== ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(e)
    );
  }),
  (Delegate.prototype.on = function (e, t, i, n) {
    let s, a, r, o;
    if (!e) throw new TypeError("Invalid event type: " + e);
    if (
      ("function" == typeof t && ((n = i), (i = t), (t = null)),
      void 0 === n && (n = this.captureForType(e)),
      "function" != typeof i)
    )
      throw new TypeError("Handler must be a type of Function");
    return (
      (s = this.rootElement),
      (a = this.listenerMap[n ? 1 : 0]),
      a[e] || (s && s.addEventListener(e, this.handle, n), (a[e] = [])),
      t
        ? /^[a-z]+$/i.test(t)
          ? ((o = t), (r = matchesTag))
          : /^#[a-z0-9\-_]+$/i.test(t)
          ? ((o = t.slice(1)), (r = matchesId))
          : ((o = t), (r = Element.prototype.matches))
        : ((o = null), (r = matchesRoot.bind(this))),
      a[e].push({
        selector: t,
        handler: i,
        matcher: r,
        matcherParam: o,
      }),
      this
    );
  }),
  (Delegate.prototype.off = function (e, t, i, n) {
    let s, a, r, o, l;
    if (
      ("function" == typeof t && ((n = i), (i = t), (t = null)), void 0 === n)
    )
      return this.off(e, t, i, !0), this.off(e, t, i, !1), this;
    if (((r = this.listenerMap[n ? 1 : 0]), !e)) {
      for (l in r) r.hasOwnProperty(l) && this.off(l, t, i);
      return this;
    }
    if (((o = r[e]), !o || !o.length)) return this;
    for (s = o.length - 1; s >= 0; s--)
      (a = o[s]),
        (t && t !== a.selector) ||
          (i && i !== a.handler) ||
          (this._removedListeners.push(a), o.splice(s, 1));
    return (
      o.length ||
        (delete r[e],
        this.rootElement &&
          this.rootElement.removeEventListener(e, this.handle, n)),
      this
    );
  }),
  (Delegate.prototype.handle = function (e) {
    let t, i;
    const n = e.type;
    let s,
      a,
      r,
      o,
      l,
      c = [];
    const d = "ftLabsDelegateIgnore";
    if (!0 === e[d]) return;
    switch (
      ((l = e.target),
      3 === l.nodeType && (l = l.parentNode),
      l.correspondingUseElement && (l = l.correspondingUseElement),
      (s = this.rootElement),
      (a = e.eventPhase || (e.target !== e.currentTarget ? 3 : 2)),
      a)
    ) {
      case 1:
        c = this.listenerMap[1][n];
        break;
      case 2:
        this.listenerMap[0] &&
          this.listenerMap[0][n] &&
          (c = c.concat(this.listenerMap[0][n])),
          this.listenerMap[1] &&
            this.listenerMap[1][n] &&
            (c = c.concat(this.listenerMap[1][n]));
        break;
      case 3:
        c = this.listenerMap[0][n];
    }
    let h,
      u = [];
    for (i = c.length; l && i; ) {
      for (t = 0; t < i && ((r = c[t]), r); t++)
        l.tagName &&
        ["button", "input", "select", "textarea"].indexOf(
          l.tagName.toLowerCase()
        ) > -1 &&
        l.hasAttribute("disabled")
          ? (u = [])
          : r.matcher.call(l, r.matcherParam, l) && u.push([e, l, r]);
      if (l === s) break;
      if (
        ((i = c.length),
        (l = l.parentElement || l.parentNode),
        l instanceof HTMLDocument)
      )
        break;
    }
    for (t = 0; t < u.length; t++)
      if (
        !(this._removedListeners.indexOf(u[t][2]) > -1) &&
        ((o = this.fire.apply(this, u[t])), !1 === o)
      ) {
        (u[t][0][d] = !0), u[t][0].preventDefault(), (h = !1);
        break;
      }
    return h;
  }),
  (Delegate.prototype.fire = function (e, t, i) {
    return i.handler.call(t, e, t);
  }),
  (Delegate.prototype.destroy = function () {
    this.off(), this.root();
  });
var main_default = Delegate,
  InputBindingManager = class {
    constructor() {
      (this.delegateElement = new main_default(document.body)),
        this.delegateElement.on(
          "change",
          "[data-bind-value]",
          this._onValueChanged.bind(this)
        );
    }
    _onValueChanged(e, t) {
      const i = document.getElementById(t.getAttribute("data-bind-value"));
      i &&
        ("SELECT" === t.tagName && (t = t.options[t.selectedIndex]),
        (i.innerHTML = t.hasAttribute("title")
          ? t.getAttribute("title")
          : t.value));
    }
  };

function triggerEvent(e, t, i = {}) {
  e.dispatchEvent(
    new CustomEvent(t, {
      bubbles: !0,
      detail: i,
    })
  );
}

function triggerNonBubblingEvent(e, t, i = {}) {
  e.dispatchEvent(
    new CustomEvent(t, {
      bubbles: !1,
      detail: i,
    })
  );
}
var CustomHTMLElement = class extends HTMLElement {
    constructor() {
      super(),
        (this._hasSectionReloaded = !1),
        Shopify.designMode &&
          this.rootDelegate.on("shopify:section:select", (e) => {
            const t = this.closest(".shopify-section");
            e.target === t && e.detail.load && (this._hasSectionReloaded = !0);
          });
    }
    get rootDelegate() {
      return (this._rootDelegate =
        this._rootDelegate || new main_default(document.documentElement));
    }
    get delegate() {
      return (this._delegate = this._delegate || new main_default(this));
    }
    showLoadingBar() {
      triggerEvent(document.documentElement, "theme:loading:start");
    }
    hideLoadingBar() {
      triggerEvent(document.documentElement, "theme:loading:end");
    }
    untilVisible(
      e = {
        rootMargin: "30px 0px",
        threshold: 0,
      }
    ) {
      const t = () => {
        this.classList.add("became-visible"), (this.style.opacity = "1");
      };
      return new Promise((i) => {
        window.IntersectionObserver
          ? ((this.intersectionObserver = new IntersectionObserver((e) => {
              e[0].isIntersecting &&
                (this.intersectionObserver.disconnect(),
                requestAnimationFrame(() => {
                  i(), t();
                }));
            }, e)),
            this.intersectionObserver.observe(this))
          : (i(), t());
      });
    }
    disconnectedCallback() {
      this.delegate.destroy(),
        this.rootDelegate.destroy(),
        this.intersectionObserver?.disconnect(),
        delete this._delegate,
        delete this._rootDelegate;
    }
  },
  candidateSelectors = [
    "input:not([inert])",
    "select:not([inert])",
    "textarea:not([inert])",
    "a[href]:not([inert])",
    "button:not([inert])",
    "[tabindex]:not(slot):not([inert])",
    "audio[controls]:not([inert])",
    "video[controls]:not([inert])",
    '[contenteditable]:not([contenteditable="false"]):not([inert])',
    "details>summary:first-of-type:not([inert])",
    "details:not([inert])",
  ],
  candidateSelector = candidateSelectors.join(","),
  NoElement = "undefined" == typeof Element,
  matches = NoElement
    ? function () {}
    : Element.prototype.matches ||
      Element.prototype.msMatchesSelector ||
      Element.prototype.webkitMatchesSelector,
  getRootNode =
    !NoElement && Element.prototype.getRootNode
      ? function (e) {
          var t;
          return null == e || null === (t = e.getRootNode) || void 0 === t
            ? void 0
            : t.call(e);
        }
      : function (e) {
          return null == e ? void 0 : e.ownerDocument;
        },
  isInert = function e(t, i) {
    var n;
    void 0 === i && (i = !0);
    var s =
      null == t || null === (n = t.getAttribute) || void 0 === n
        ? void 0
        : n.call(t, "inert");
    return "" === s || "true" === s || (i && t && e(t.parentNode));
  },
  isContentEditable = function (e) {
    var t,
      i =
        null == e || null === (t = e.getAttribute) || void 0 === t
          ? void 0
          : t.call(e, "contenteditable");
    return "" === i || "true" === i;
  },
  getCandidates = function (e, t, i) {
    if (isInert(e)) return [];
    var n = Array.prototype.slice.apply(e.querySelectorAll(candidateSelector));
    return t && matches.call(e, candidateSelector) && n.unshift(e), n.filter(i);
  },
  getCandidatesIteratively = function e(t, i, n) {
    for (var s = [], a = Array.from(t); a.length; ) {
      var r = a.shift();
      if (!isInert(r, !1))
        if ("SLOT" === r.tagName) {
          var o = r.assignedElements(),
            l = e(o.length ? o : r.children, !0, n);
          n.flatten
            ? s.push.apply(s, l)
            : s.push({
                scopeParent: r,
                candidates: l,
              });
        } else {
          matches.call(r, candidateSelector) &&
            n.filter(r) &&
            (i || !t.includes(r)) &&
            s.push(r);
          var c =
              r.shadowRoot ||
              ("function" == typeof n.getShadowRoot && n.getShadowRoot(r)),
            d =
              !isInert(c, !1) && (!n.shadowRootFilter || n.shadowRootFilter(r));
          if (c && d) {
            var h = e(!0 === c ? r.children : c.children, !0, n);
            n.flatten
              ? s.push.apply(s, h)
              : s.push({
                  scopeParent: r,
                  candidates: h,
                });
          } else a.unshift.apply(a, r.children);
        }
    }
    return s;
  },
  hasTabIndex = function (e) {
    return !isNaN(parseInt(e.getAttribute("tabindex"), 10));
  },
  getTabIndex = function (e) {
    if (!e) throw new Error("No node provided");
    return e.tabIndex < 0 &&
      (/^(AUDIO|VIDEO|DETAILS)$/.test(e.tagName) || isContentEditable(e)) &&
      !hasTabIndex(e)
      ? 0
      : e.tabIndex;
  },
  getSortOrderTabIndex = function (e, t) {
    var i = getTabIndex(e);
    return i < 0 && t && !hasTabIndex(e) ? 0 : i;
  },
  sortOrderedTabbables = function (e, t) {
    return e.tabIndex === t.tabIndex
      ? e.documentOrder - t.documentOrder
      : e.tabIndex - t.tabIndex;
  },
  isInput = function (e) {
    return "INPUT" === e.tagName;
  },
  isHiddenInput = function (e) {
    return isInput(e) && "hidden" === e.type;
  },
  isDetailsWithSummary = function (e) {
    return (
      "DETAILS" === e.tagName &&
      Array.prototype.slice.apply(e.children).some(function (e) {
        return "SUMMARY" === e.tagName;
      })
    );
  },
  getCheckedRadio = function (e, t) {
    for (var i = 0; i < e.length; i++)
      if (e[i].checked && e[i].form === t) return e[i];
  },
  isTabbableRadio = function (e) {
    if (!e.name) return !0;
    var t,
      i = e.form || getRootNode(e),
      n = function (e) {
        return i.querySelectorAll('input[type="radio"][name="' + e + '"]');
      };
    if (
      "undefined" != typeof window &&
      void 0 !== window.CSS &&
      "function" == typeof window.CSS.escape
    )
      t = n(window.CSS.escape(e.name));
    else
      try {
        t = n(e.name);
      } catch (e) {
        return (
          console.error(
            "Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s",
            e.message
          ),
          !1
        );
      }
    var s = getCheckedRadio(t, e.form);
    return !s || s === e;
  },
  isRadio = function (e) {
    return isInput(e) && "radio" === e.type;
  },
  isNonTabbableRadio = function (e) {
    return isRadio(e) && !isTabbableRadio(e);
  },
  isNodeAttached = function (e) {
    var t,
      i,
      n,
      s,
      a = e && getRootNode(e),
      r = null === (t = a) || void 0 === t ? void 0 : t.host,
      o = !1;
    if (a && a !== e)
      for (
        o = !!(
          (null !== (i = r) &&
            void 0 !== i &&
            null !== (n = i.ownerDocument) &&
            void 0 !== n &&
            n.contains(r)) ||
          (null != e &&
            null !== (s = e.ownerDocument) &&
            void 0 !== s &&
            s.contains(e))
        );
        !o && r;

      ) {
        var l, c, d;
        o = !(
          null ===
            (c = r =
              null === (l = a = getRootNode(r)) || void 0 === l
                ? void 0
                : l.host) ||
          void 0 === c ||
          null === (d = c.ownerDocument) ||
          void 0 === d ||
          !d.contains(r)
        );
      }
    return o;
  },
  isZeroArea = function (e) {
    var t = e.getBoundingClientRect(),
      i = t.width,
      n = t.height;
    return 0 === i && 0 === n;
  },
  isHidden = function (e, t) {
    var i = t.displayCheck,
      n = t.getShadowRoot;
    if ("hidden" === getComputedStyle(e).visibility) return !0;
    var s = matches.call(e, "details>summary:first-of-type")
      ? e.parentElement
      : e;
    if (matches.call(s, "details:not([open]) *")) return !0;
    if (i && "full" !== i && "legacy-full" !== i) {
      if ("non-zero-area" === i) return isZeroArea(e);
    } else {
      if ("function" == typeof n) {
        for (var a = e; e; ) {
          var r = e.parentElement,
            o = getRootNode(e);
          if (r && !r.shadowRoot && !0 === n(r)) return isZeroArea(e);
          e = e.assignedSlot
            ? e.assignedSlot
            : r || o === e.ownerDocument
            ? r
            : o.host;
        }
        e = a;
      }
      if (isNodeAttached(e)) return !e.getClientRects().length;
      if ("legacy-full" !== i) return !0;
    }
    return !1;
  },
  isDisabledFromFieldset = function (e) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(e.tagName))
      for (var t = e.parentElement; t; ) {
        if ("FIELDSET" === t.tagName && t.disabled) {
          for (var i = 0; i < t.children.length; i++) {
            var n = t.children.item(i);
            if ("LEGEND" === n.tagName)
              return (
                !!matches.call(t, "fieldset[disabled] *") || !n.contains(e)
              );
          }
          return !0;
        }
        t = t.parentElement;
      }
    return !1;
  },
  isNodeMatchingSelectorFocusable = function (e, t) {
    return !(
      t.disabled ||
      isInert(t) ||
      isHiddenInput(t) ||
      isHidden(t, e) ||
      isDetailsWithSummary(t) ||
      isDisabledFromFieldset(t)
    );
  },
  isNodeMatchingSelectorTabbable = function (e, t) {
    return !(
      isNonTabbableRadio(t) ||
      getTabIndex(t) < 0 ||
      !isNodeMatchingSelectorFocusable(e, t)
    );
  },
  isValidShadowRootTabbable = function (e) {
    var t = parseInt(e.getAttribute("tabindex"), 10);
    return !!(isNaN(t) || t >= 0);
  },
  sortByOrder = function e(t) {
    var i = [],
      n = [];
    return (
      t.forEach(function (t, s) {
        var a = !!t.scopeParent,
          r = a ? t.scopeParent : t,
          o = getSortOrderTabIndex(r, a),
          l = a ? e(t.candidates) : r;
        0 === o
          ? a
            ? i.push.apply(i, l)
            : i.push(r)
          : n.push({
              documentOrder: s,
              tabIndex: o,
              item: t,
              isScope: a,
              content: l,
            });
      }),
      n
        .sort(sortOrderedTabbables)
        .reduce(function (e, t) {
          return t.isScope ? e.push.apply(e, t.content) : e.push(t.content), e;
        }, [])
        .concat(i)
    );
  },
  tabbable = function (e, t) {
    var i;
    return (
      (i = (t = t || {}).getShadowRoot
        ? getCandidatesIteratively([e], t.includeContainer, {
            filter: isNodeMatchingSelectorTabbable.bind(null, t),
            flatten: !1,
            getShadowRoot: t.getShadowRoot,
            shadowRootFilter: isValidShadowRootTabbable,
          })
        : getCandidates(
            e,
            t.includeContainer,
            isNodeMatchingSelectorTabbable.bind(null, t)
          )),
      sortByOrder(i)
    );
  },
  focusable = function (e, t) {
    return (t = t || {}).getShadowRoot
      ? getCandidatesIteratively([e], t.includeContainer, {
          filter: isNodeMatchingSelectorFocusable.bind(null, t),
          flatten: !0,
          getShadowRoot: t.getShadowRoot,
        })
      : getCandidates(
          e,
          t.includeContainer,
          isNodeMatchingSelectorFocusable.bind(null, t)
        );
  },
  isTabbable = function (e, t) {
    if (((t = t || {}), !e)) throw new Error("No node provided");
    return (
      !1 !== matches.call(e, candidateSelector) &&
      isNodeMatchingSelectorTabbable(t, e)
    );
  },
  focusableCandidateSelector = candidateSelectors.concat("iframe").join(","),
  isFocusable = function (e, t) {
    if (((t = t || {}), !e)) throw new Error("No node provided");
    return (
      !1 !== matches.call(e, focusableCandidateSelector) &&
      isNodeMatchingSelectorFocusable(t, e)
    );
  };

function ownKeys(e, t) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t &&
      (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })),
      i.push.apply(i, n);
  }
  return i;
}

function _objectSpread2(e) {
  for (var t = 1; t < arguments.length; t++) {
    var i = null != arguments[t] ? arguments[t] : {};
    t % 2
      ? ownKeys(Object(i), !0).forEach(function (t) {
          _defineProperty(e, t, i[t]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i))
      : ownKeys(Object(i)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
        });
  }
  return e;
}

function _defineProperty(e, t, i) {
  return (
    (t = _toPropertyKey(t)) in e
      ? Object.defineProperty(e, t, {
          value: i,
          enumerable: !0,
          configurable: !0,
          writable: !0,
        })
      : (e[t] = i),
    e
  );
}

function _toPrimitive(e, t) {
  if ("object" != typeof e || null === e) return e;
  var i = e[Symbol.toPrimitive];
  if (void 0 !== i) {
    var n = i.call(e, t || "default");
    if ("object" != typeof n) return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === t ? String : Number)(e);
}

function _toPropertyKey(e) {
  var t = _toPrimitive(e, "string");
  return "symbol" == typeof t ? t : String(t);
}
var activeFocusTraps = {
    activateTrap: function (e, t) {
      if (e.length > 0) {
        var i = e[e.length - 1];
        i !== t && i.pause();
      }
      var n = e.indexOf(t);
      -1 === n || e.splice(n, 1), e.push(t);
    },
    deactivateTrap: function (e, t) {
      var i = e.indexOf(t);
      -1 !== i && e.splice(i, 1), e.length > 0 && e[e.length - 1].unpause();
    },
  },
  isSelectableInput = function (e) {
    return (
      e.tagName &&
      "input" === e.tagName.toLowerCase() &&
      "function" == typeof e.select
    );
  },
  isEscapeEvent = function (e) {
    return (
      "Escape" === (null == e ? void 0 : e.key) ||
      "Esc" === (null == e ? void 0 : e.key) ||
      27 === (null == e ? void 0 : e.keyCode)
    );
  },
  isTabEvent = function (e) {
    return (
      "Tab" === (null == e ? void 0 : e.key) ||
      9 === (null == e ? void 0 : e.keyCode)
    );
  },
  isKeyForward = function (e) {
    return isTabEvent(e) && !e.shiftKey;
  },
  isKeyBackward = function (e) {
    return isTabEvent(e) && e.shiftKey;
  },
  delay = function (e) {
    return setTimeout(e, 0);
  },
  findIndex = function (e, t) {
    var i = -1;
    return (
      e.every(function (e, n) {
        return !t(e) || ((i = n), !1);
      }),
      i
    );
  },
  valueOrHandler = function (e) {
    for (
      var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), n = 1;
      n < t;
      n++
    )
      i[n - 1] = arguments[n];
    return "function" == typeof e ? e.apply(void 0, i) : e;
  },
  getActualTarget = function (e) {
    return e.target.shadowRoot && "function" == typeof e.composedPath
      ? e.composedPath()[0]
      : e.target;
  },
  internalTrapStack = [],
  createFocusTrap = function (e, t) {
    var i,
      n = (null == t ? void 0 : t.document) || document,
      s = (null == t ? void 0 : t.trapStack) || internalTrapStack,
      a = _objectSpread2(
        {
          returnFocusOnDeactivate: !0,
          escapeDeactivates: !0,
          delayInitialFocus: !0,
          isKeyForward: isKeyForward,
          isKeyBackward: isKeyBackward,
        },
        t
      ),
      r = {
        containers: [],
        containerGroups: [],
        tabbableGroups: [],
        nodeFocusedBeforeActivation: null,
        mostRecentlyFocusedNode: null,
        active: !1,
        paused: !1,
        delayInitialFocusTimer: void 0,
        recentNavEvent: void 0,
      },
      o = function (e, t, i) {
        return e && void 0 !== e[t] ? e[t] : a[i || t];
      },
      l = function (e, t) {
        var i =
          "function" == typeof (null == t ? void 0 : t.composedPath)
            ? t.composedPath()
            : void 0;
        return r.containerGroups.findIndex(function (t) {
          var n = t.container,
            s = t.tabbableNodes;
          return (
            n.contains(e) ||
            (null == i ? void 0 : i.includes(n)) ||
            s.find(function (t) {
              return t === e;
            })
          );
        });
      },
      c = function (e) {
        var t = a[e];
        if ("function" == typeof t) {
          for (
            var i = arguments.length, s = new Array(i > 1 ? i - 1 : 0), r = 1;
            r < i;
            r++
          )
            s[r - 1] = arguments[r];
          t = t.apply(void 0, s);
        }
        if ((!0 === t && (t = void 0), !t)) {
          if (void 0 === t || !1 === t) return t;
          throw new Error(
            "`".concat(
              e,
              "` was specified but was not a node, or did not return a node"
            )
          );
        }
        var o = t;
        if ("string" == typeof t && !(o = n.querySelector(t)))
          throw new Error(
            "`".concat(e, "` as selector refers to no known node")
          );
        return o;
      },
      d = function () {
        var e = c("initialFocus");
        if (!1 === e) return !1;
        if (void 0 === e || !isFocusable(e, a.tabbableOptions))
          if (l(n.activeElement) >= 0) e = n.activeElement;
          else {
            var t = r.tabbableGroups[0];
            e = (t && t.firstTabbableNode) || c("fallbackFocus");
          }
        if (!e)
          throw new Error(
            "Your focus-trap needs to have at least one focusable element"
          );
        return e;
      },
      h = function () {
        if (
          ((r.containerGroups = r.containers.map(function (e) {
            var t = tabbable(e, a.tabbableOptions),
              i = focusable(e, a.tabbableOptions),
              n = t.length > 0 ? t[0] : void 0,
              s = t.length > 0 ? t[t.length - 1] : void 0,
              r = i.find(function (e) {
                return isTabbable(e);
              }),
              o = i
                .slice()
                .reverse()
                .find(function (e) {
                  return isTabbable(e);
                }),
              l = !!t.find(function (e) {
                return getTabIndex(e) > 0;
              });
            return {
              container: e,
              tabbableNodes: t,
              focusableNodes: i,
              posTabIndexesFound: l,
              firstTabbableNode: n,
              lastTabbableNode: s,
              firstDomTabbableNode: r,
              lastDomTabbableNode: o,
              nextTabbableNode: function (e) {
                var n =
                    !(arguments.length > 1 && void 0 !== arguments[1]) ||
                    arguments[1],
                  s = t.indexOf(e);
                return s < 0
                  ? n
                    ? i.slice(i.indexOf(e) + 1).find(function (e) {
                        return isTabbable(e);
                      })
                    : i
                        .slice(0, i.indexOf(e))
                        .reverse()
                        .find(function (e) {
                          return isTabbable(e);
                        })
                  : t[s + (n ? 1 : -1)];
              },
            };
          })),
          (r.tabbableGroups = r.containerGroups.filter(function (e) {
            return e.tabbableNodes.length > 0;
          })),
          r.tabbableGroups.length <= 0 && !c("fallbackFocus"))
        )
          throw new Error(
            "Your focus-trap must have at least one container with at least one tabbable node in it at all times"
          );
        if (
          r.containerGroups.find(function (e) {
            return e.posTabIndexesFound;
          }) &&
          r.containerGroups.length > 1
        )
          throw new Error(
            "At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps."
          );
      },
      u = function e(t) {
        var i = t.activeElement;
        if (i)
          return i.shadowRoot && null !== i.shadowRoot.activeElement
            ? e(i.shadowRoot)
            : i;
      },
      m = function e(t) {
        !1 !== t &&
          t !== u(document) &&
          (t && t.focus
            ? (t.focus({
                preventScroll: !!a.preventScroll,
              }),
              (r.mostRecentlyFocusedNode = t),
              isSelectableInput(t) && t.select())
            : e(d()));
      },
      p = function (e) {
        var t = c("setReturnFocus", e);
        return t || (!1 !== t && e);
      },
      b = function (e) {
        var t = e.target,
          i = e.event,
          n = e.isBackward,
          s = void 0 !== n && n;
        (t = t || getActualTarget(i)), h();
        var o = null;
        if (r.tabbableGroups.length > 0) {
          var d = l(t, i),
            u = d >= 0 ? r.containerGroups[d] : void 0;
          if (d < 0)
            o = s
              ? r.tabbableGroups[r.tabbableGroups.length - 1].lastTabbableNode
              : r.tabbableGroups[0].firstTabbableNode;
          else if (s) {
            var m = findIndex(r.tabbableGroups, function (e) {
              var i = e.firstTabbableNode;
              return t === i;
            });
            if (
              (m < 0 &&
                (u.container === t ||
                  (isFocusable(t, a.tabbableOptions) &&
                    !isTabbable(t, a.tabbableOptions) &&
                    !u.nextTabbableNode(t, !1))) &&
                (m = d),
              m >= 0)
            ) {
              var p = 0 === m ? r.tabbableGroups.length - 1 : m - 1,
                b = r.tabbableGroups[p];
              o =
                getTabIndex(t) >= 0
                  ? b.lastTabbableNode
                  : b.lastDomTabbableNode;
            } else isTabEvent(i) || (o = u.nextTabbableNode(t, !1));
          } else {
            var f = findIndex(r.tabbableGroups, function (e) {
              var i = e.lastTabbableNode;
              return t === i;
            });
            if (
              (f < 0 &&
                (u.container === t ||
                  (isFocusable(t, a.tabbableOptions) &&
                    !isTabbable(t, a.tabbableOptions) &&
                    !u.nextTabbableNode(t))) &&
                (f = d),
              f >= 0)
            ) {
              var g = f === r.tabbableGroups.length - 1 ? 0 : f + 1,
                y = r.tabbableGroups[g];
              o =
                getTabIndex(t) >= 0
                  ? y.firstTabbableNode
                  : y.firstDomTabbableNode;
            } else isTabEvent(i) || (o = u.nextTabbableNode(t));
          }
        } else o = c("fallbackFocus");
        return o;
      },
      f = function (e) {
        var t = getActualTarget(e);
        l(t, e) >= 0 ||
          (valueOrHandler(a.clickOutsideDeactivates, e)
            ? i.deactivate({
                returnFocus: a.returnFocusOnDeactivate,
              })
            : valueOrHandler(a.allowOutsideClick, e) || e.preventDefault());
      },
      g = function (e) {
        var t = getActualTarget(e),
          i = l(t, e) >= 0;
        if (i || t instanceof Document) i && (r.mostRecentlyFocusedNode = t);
        else {
          var n;
          e.stopImmediatePropagation();
          var s = !0;
          if (r.mostRecentlyFocusedNode)
            if (getTabIndex(r.mostRecentlyFocusedNode) > 0) {
              var o = l(r.mostRecentlyFocusedNode),
                c = r.containerGroups[o].tabbableNodes;
              if (c.length > 0) {
                var h = c.findIndex(function (e) {
                  return e === r.mostRecentlyFocusedNode;
                });
                h >= 0 &&
                  (a.isKeyForward(r.recentNavEvent)
                    ? h + 1 < c.length && ((n = c[h + 1]), (s = !1))
                    : h - 1 >= 0 && ((n = c[h - 1]), (s = !1)));
              }
            } else
              r.containerGroups.some(function (e) {
                return e.tabbableNodes.some(function (e) {
                  return getTabIndex(e) > 0;
                });
              }) || (s = !1);
          else s = !1;
          s &&
            (n = b({
              target: r.mostRecentlyFocusedNode,
              isBackward: a.isKeyBackward(r.recentNavEvent),
            })),
            m(n || r.mostRecentlyFocusedNode || d());
        }
        r.recentNavEvent = void 0;
      },
      y = function (e) {
        if (isEscapeEvent(e) && !1 !== valueOrHandler(a.escapeDeactivates, e))
          return e.preventDefault(), void i.deactivate();
        (a.isKeyForward(e) || a.isKeyBackward(e)) &&
          (function (e) {
            var t =
              arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
            r.recentNavEvent = e;
            var i = b({
              event: e,
              isBackward: t,
            });
            i && (isTabEvent(e) && e.preventDefault(), m(i));
          })(e, a.isKeyBackward(e));
      },
      v = function (e) {
        var t = getActualTarget(e);
        l(t, e) >= 0 ||
          valueOrHandler(a.clickOutsideDeactivates, e) ||
          valueOrHandler(a.allowOutsideClick, e) ||
          (e.preventDefault(), e.stopImmediatePropagation());
      },
      w = function () {
        if (r.active)
          return (
            activeFocusTraps.activateTrap(s, i),
            (r.delayInitialFocusTimer = a.delayInitialFocus
              ? delay(function () {
                  m(d());
                })
              : m(d())),
            n.addEventListener("focusin", g, !0),
            n.addEventListener("mousedown", f, {
              capture: !0,
              passive: !1,
            }),
            n.addEventListener("touchstart", f, {
              capture: !0,
              passive: !1,
            }),
            n.addEventListener("click", v, {
              capture: !0,
              passive: !1,
            }),
            n.addEventListener("keydown", y, {
              capture: !0,
              passive: !1,
            }),
            i
          );
      },
      E = function () {
        if (r.active)
          return (
            n.removeEventListener("focusin", g, !0),
            n.removeEventListener("mousedown", f, !0),
            n.removeEventListener("touchstart", f, !0),
            n.removeEventListener("click", v, !0),
            n.removeEventListener("keydown", y, !0),
            i
          );
      },
      _ =
        "undefined" != typeof window && "MutationObserver" in window
          ? new MutationObserver(function (e) {
              e.some(function (e) {
                return Array.from(e.removedNodes).some(function (e) {
                  return e === r.mostRecentlyFocusedNode;
                });
              }) && m(d());
            })
          : void 0,
      S = function () {
        _ &&
          (_.disconnect(),
          r.active &&
            !r.paused &&
            r.containers.map(function (e) {
              _.observe(e, {
                subtree: !0,
                childList: !0,
              });
            }));
      };
    return (
      (i = {
        get active() {
          return r.active;
        },
        get paused() {
          return r.paused;
        },
        activate: function (e) {
          if (r.active) return this;
          var t = o(e, "onActivate"),
            i = o(e, "onPostActivate"),
            s = o(e, "checkCanFocusTrap");
          s || h(),
            (r.active = !0),
            (r.paused = !1),
            (r.nodeFocusedBeforeActivation = n.activeElement),
            null == t || t();
          var a = function () {
            s && h(), w(), S(), null == i || i();
          };
          return s ? (s(r.containers.concat()).then(a, a), this) : (a(), this);
        },
        deactivate: function (e) {
          if (!r.active) return this;
          var t = _objectSpread2(
            {
              onDeactivate: a.onDeactivate,
              onPostDeactivate: a.onPostDeactivate,
              checkCanReturnFocus: a.checkCanReturnFocus,
            },
            e
          );
          clearTimeout(r.delayInitialFocusTimer),
            (r.delayInitialFocusTimer = void 0),
            E(),
            (r.active = !1),
            (r.paused = !1),
            S(),
            activeFocusTraps.deactivateTrap(s, i);
          var n = o(t, "onDeactivate"),
            l = o(t, "onPostDeactivate"),
            c = o(t, "checkCanReturnFocus"),
            d = o(t, "returnFocus", "returnFocusOnDeactivate");
          null == n || n();
          var h = function () {
            delay(function () {
              d && m(p(r.nodeFocusedBeforeActivation)), null == l || l();
            });
          };
          return d && c
            ? (c(p(r.nodeFocusedBeforeActivation)).then(h, h), this)
            : (h(), this);
        },
        pause: function (e) {
          if (r.paused || !r.active) return this;
          var t = o(e, "onPause"),
            i = o(e, "onPostPause");
          return (
            (r.paused = !0), null == t || t(), E(), S(), null == i || i(), this
          );
        },
        unpause: function (e) {
          if (!r.paused || !r.active) return this;
          var t = o(e, "onUnpause"),
            i = o(e, "onPostUnpause");
          return (
            (r.paused = !1),
            null == t || t(),
            h(),
            w(),
            S(),
            null == i || i(),
            this
          );
        },
        updateContainerElements: function (e) {
          var t = [].concat(e).filter(Boolean);
          return (
            (r.containers = t.map(function (e) {
              return "string" == typeof e ? n.querySelector(e) : e;
            })),
            r.active && h(),
            S(),
            this
          );
        },
      }).updateContainerElements(e),
      i
    );
  };

function filterShopifyEvent(e, t, i) {
  let n = !1;
  e.type.includes("shopify:section")
    ? t.hasAttribute("section") &&
      t.getAttribute("section") === e.detail.sectionId &&
      (n = !0)
    : e.type.includes("shopify:block") && e.target === t && (n = !0),
    n && i(e);
}
var OpenableElement = class extends CustomHTMLElement {
  static get observedAttributes() {
    return ["open"];
  }
  constructor() {
    if (
      (super(),
      Shopify.designMode &&
        (this.rootDelegate.on("shopify:section:select", (e) =>
          filterShopifyEvent(e, this, () => (this.open = !0))
        ),
        this.rootDelegate.on("shopify:section:deselect", (e) =>
          filterShopifyEvent(e, this, () => (this.open = !1))
        )),
      this.hasAttribute("append-body"))
    ) {
      const e = document.getElementById(this.id);
      this.removeAttribute("append-body"),
        e && e !== this
          ? (e.replaceWith(this.cloneNode(!0)), this.remove())
          : document.body.appendChild(this);
    }
  }
  connectedCallback() {
    this.delegate.on("click", ".openable__overlay", () => (this.open = !1)),
      this.delegate.on("click", '[data-action="close"]', (e) => {
        e.stopPropagation(), (this.open = !1);
      });
  }
  get requiresLoading() {
    return this.hasAttribute("href");
  }
  get open() {
    return this.hasAttribute("open");
  }
  set open(e) {
    e
      ? (async () => {
          await this._load(), this.clientWidth, this.setAttribute("open", "");
        })()
      : this.removeAttribute("open");
  }
  get shouldTrapFocus() {
    return !0;
  }
  get returnFocusOnDeactivate() {
    return (
      !this.hasAttribute("return-focus") ||
      "true" === this.getAttribute("return-focus")
    );
  }
  get focusTrap() {
    return (this._focusTrap =
      this._focusTrap ||
      createFocusTrap(this, {
        fallbackFocus: this,
        initialFocus: this.hasAttribute("initial-focus-selector")
          ? this.getAttribute("initial-focus-selector")
          : void 0,
        clickOutsideDeactivates: (e) =>
          !(
            e.target.hasAttribute("aria-controls") &&
            e.target.getAttribute("aria-controls") === this.id
          ),
        allowOutsideClick: (e) =>
          e.target.hasAttribute("aria-controls") &&
          e.target.getAttribute("aria-controls") === this.id,
        returnFocusOnDeactivate: this.returnFocusOnDeactivate,
        onDeactivate: () => (this.open = !1),
        preventScroll: !0,
      }));
  }
  attributeChangedCallback(e, t, i) {
    "open" === e &&
      (null === t && "" === i
        ? (this.shouldTrapFocus &&
            setTimeout(() => this.focusTrap.activate(), 150),
          triggerEvent(this, "openable-element:open"))
        : null === i &&
          (this.shouldTrapFocus && this.focusTrap.deactivate(),
          triggerEvent(this, "openable-element:close")));
  }
  async _load() {
    if (!this.requiresLoading) return;
    triggerNonBubblingEvent(this, "openable-element:load:start");
    const e = await fetch(this.getAttribute("href")),
      t = document.createElement("div");
    (t.innerHTML = await e.text()),
      (this.innerHTML = t.querySelector(this.tagName.toLowerCase()).innerHTML),
      this.removeAttribute("href"),
      triggerNonBubblingEvent(this, "openable-element:load:end");
  }
};
window.customElements.define("openable-element", OpenableElement);
var CollapsibleContent = class extends OpenableElement {
  constructor() {
    super(),
      (this.ignoreNextTransition = this.open),
      this.addEventListener("shopify:block:select", () => (this.open = !0)),
      this.addEventListener("shopify:block:deselect", () => (this.open = !1));
  }
  get animateItems() {
    return this.hasAttribute("animate-items");
  }
  attributeChangedCallback(e) {
    if (this.ignoreNextTransition) return (this.ignoreNextTransition = !1);
    if ("open" === e) {
      this.style.overflow = "hidden";
      const e = {
        height: ["0px", `${this.scrollHeight}px`],
        visibility: ["hidden", "visible"],
      };
      this.animateItems && (e.opacity = this.open ? [0, 0] : [0, 1]),
        (this.animate(e, {
          duration: 500,
          direction: this.open ? "normal" : "reverse",
          easing: "cubic-bezier(0.75, 0, 0.175, 1)",
        }).onfinish = () => {
          this.style.overflow = this.open ? "visible" : "hidden";
        }),
        this.animateItems &&
          this.open &&
          this.animate(
            {
              opacity: [0, 1],
              transform: ["translateY(10px)", "translateY(0)"],
            },
            {
              duration: 250,
              delay: 250,
              easing: "cubic-bezier(0.75, 0, 0.175, 1)",
            }
          ),
        triggerEvent(
          this,
          this.open ? "openable-element:open" : "openable-element:close"
        );
    }
  }
};
window.customElements.define("collapsible-content", CollapsibleContent);
var ConfirmButton = class extends HTMLButtonElement {
  connectedCallback() {
    this.addEventListener("click", (e) => {
      window.confirm(
        this.getAttribute("data-message") || "Are you sure you wish to do this?"
      ) || e.preventDefault();
    });
  }
};
window.customElements.define("confirm-button", ConfirmButton, {
  extends: "button",
});
var LoaderButtonMixin = {
    _prepareButton() {
      (this.originalContent = this.innerHTML),
        (this._startTransitionPromise = null),
        (this.innerHTML = `\n      <span class="loader-button__text">${this.innerHTML}</span>\n      <span class="loader-button__loader" hidden>\n        <div class="spinner">\n          <svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50">\n            <circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle>\n          </svg>\n        </div>\n      </span>\n    `),
        (this.textElement = this.firstElementChild),
        (this.spinnerElement = this.lastElementChild),
        window.addEventListener("pagehide", () =>
          this.removeAttribute("aria-busy")
        );
    },
    _startTransition() {
      const e = this.textElement.animate(
        {
          opacity: [1, 0],
          transform: ["translateY(0)", "translateY(-10px)"],
        },
        {
          duration: 75,
          easing: "ease",
          fill: "forwards",
        }
      );
      this.spinnerElement.hidden = !1;
      const t = this.spinnerElement.animate(
        {
          opacity: [0, 1],
          transform: ["translate(-50%, 0%)", "translate(-50%, -50%)"],
        },
        {
          duration: 75,
          delay: 75,
          easing: "ease",
          fill: "forwards",
        }
      );
      this._startTransitionPromise = Promise.all([
        new Promise((t) => (e.onfinish = () => t())),
        new Promise((e) => (t.onfinish = () => e())),
      ]);
    },
    async _endTransition() {
      this._startTransitionPromise &&
        (await this._startTransitionPromise,
        (this.spinnerElement.animate(
          {
            opacity: [1, 0],
            transform: ["translate(-50%, -50%)", "translate(-50%, -100%)"],
          },
          {
            duration: 75,
            delay: 100,
            easing: "ease",
            fill: "forwards",
          }
        ).onfinish = () => (this.spinnerElement.hidden = !0)),
        this.textElement.animate(
          {
            opacity: [0, 1],
            transform: ["translateY(10px)", "translateY(0)"],
          },
          {
            duration: 75,
            delay: 175,
            easing: "ease",
            fill: "forwards",
          }
        ),
        (this._startTransitionPromise = null));
    },
  },
  LoaderButton = class extends HTMLButtonElement {
    static get observedAttributes() {
      return ["aria-busy"];
    }
    constructor() {
      super(),
        this.addEventListener("click", (e) => {
          "submit" === this.type &&
            this.form &&
            this.form.checkValidity() &&
            !this.form.hasAttribute("is") &&
            (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)
              ? (e.preventDefault(),
                this.setAttribute("aria-busy", "true"),
                setTimeout(() => this.form.submit(), 250))
              : this.setAttribute("aria-busy", "true"));
        });
    }
    connectedCallback() {
      this._prepareButton();
    }
    disconnectedCallback() {
      this.innerHTML = this.originalContent;
    }
    attributeChangedCallback(e, t, i) {
      "aria-busy" === e &&
        ("true" === i ? this._startTransition() : this._endTransition());
    }
  };
Object.assign(LoaderButton.prototype, LoaderButtonMixin),
  window.customElements.define("loader-button", LoaderButton, {
    extends: "button",
  });
var PagePagination = class extends CustomHTMLElement {
  connectedCallback() {
    this.hasAttribute("ajax") &&
      this.delegate.on("click", "a", this._onLinkClicked.bind(this));
  }
  _onLinkClicked(e, t) {
    e.preventDefault();
    const i = new URL(window.location.href);
    i.searchParams.set("page", t.getAttribute("data-page")),
      triggerEvent(this, "pagination:page-changed", {
        url: i.toString(),
      });
  }
};
window.customElements.define("page-pagination", PagePagination);
var ToggleButton = class extends HTMLButtonElement {
  static get observedAttributes() {
    return ["aria-expanded", "aria-busy"];
  }
  constructor() {
    super(),
      this.hasAttribute("loader") && this._prepareButton(),
      this.addEventListener("click", this._onButtonClick.bind(this)),
      (this.rootDelegate = new main_default(document.documentElement));
  }
  _onButtonClick() {
    this.isExpanded = !this.isExpanded;
  }
  connectedCallback() {
    document.addEventListener("openable-element:close", (e) => {
      this.controlledElement === e.target &&
        ((this.isExpanded = !1), e.stopPropagation());
    }),
      document.addEventListener("openable-element:open", (e) => {
        this.controlledElement === e.target &&
          ((this.isExpanded = !0), e.stopPropagation());
      }),
      this.rootDelegate.on(
        "openable-element:load:start",
        `#${this.getAttribute("aria-controls")}`,
        () => {
          this.classList.contains("button")
            ? this.setAttribute("aria-busy", "true")
            : null !== this.offsetParent &&
              triggerEvent(document.documentElement, "theme:loading:start");
        },
        !0
      ),
      this.rootDelegate.on(
        "openable-element:load:end",
        `#${this.getAttribute("aria-controls")}`,
        () => {
          this.classList.contains("button")
            ? this.removeAttribute("aria-busy")
            : null !== this.offsetParent &&
              triggerEvent(document.documentElement, "theme:loading:end");
        },
        !0
      );
  }
  disconnectedCallback() {
    this.rootDelegate.destroy();
  }
  get isExpanded() {
    return "true" === this.getAttribute("aria-expanded");
  }
  set isExpanded(e) {
    this.setAttribute("aria-expanded", e ? "true" : "false");
  }
  get controlledElement() {
    return document.getElementById(this.getAttribute("aria-controls"));
  }
  attributeChangedCallback(e, t, i) {
    switch (e) {
      case "aria-expanded":
        "false" === t && "true" === i
          ? (this.controlledElement.open = !0)
          : "true" === t && "false" === i && (this.controlledElement.open = !1);
        break;
      case "aria-busy":
        this.hasAttribute("loader") &&
          ("true" === i ? this._startTransition() : this._endTransition());
    }
  }
};
Object.assign(ToggleButton.prototype, LoaderButtonMixin),
  window.customElements.define("toggle-button", ToggleButton, {
    extends: "button",
  });
var ToggleLink = class extends HTMLAnchorElement {
  static get observedAttributes() {
    return ["aria-expanded"];
  }
  constructor() {
    super(),
      this.addEventListener("click", (e) => {
        e.preventDefault(), (this.isExpanded = !this.isExpanded);
      }),
      (this.rootDelegate = new main_default(document.documentElement));
  }
  connectedCallback() {
    this.rootDelegate.on(
      "openable-element:close",
      `#${this.getAttribute("aria-controls")}`,
      (e) => {
        this.controlledElement === e.target && (this.isExpanded = !1);
      },
      !0
    ),
      this.rootDelegate.on(
        "openable-element:open",
        `#${this.getAttribute("aria-controls")}`,
        (e) => {
          this.controlledElement === e.target && (this.isExpanded = !0);
        },
        !0
      );
  }
  disconnectedCallback() {
    this.rootDelegate.destroy();
  }
  get isExpanded() {
    return "true" === this.getAttribute("aria-expanded");
  }
  set isExpanded(e) {
    this.setAttribute("aria-expanded", e ? "true" : "false");
  }
  get controlledElement() {
    return document.querySelector(`#${this.getAttribute("aria-controls")}`);
  }
  attributeChangedCallback(e, t, i) {
    "aria-expanded" === e &&
      ("false" === t && "true" === i
        ? (this.controlledElement.open = !0)
        : "true" === t && "false" === i && (this.controlledElement.open = !1));
  }
};
window.customElements.define("toggle-link", ToggleLink, {
  extends: "a",
});
var PageDots = class extends CustomHTMLElement {
  connectedCallback() {
    (this.buttons = Array.from(this.querySelectorAll("button"))),
      this.delegate.on("click", "button", (e, t) => {
        this._dispatchEvent(this.buttons.indexOf(t));
      }),
      this.hasAttribute("animation-timer") &&
        this.delegate.on("animationend", (e) => {
          e.elapsedTime > 0 &&
            this._dispatchEvent(
              (this.selectedIndex + 1 + this.buttons.length) %
                this.buttons.length
            );
        });
  }
  get selectedIndex() {
    return this.buttons.findIndex(
      (e) => "true" === e.getAttribute("aria-current")
    );
  }
  set selectedIndex(e) {
    if (
      (this.buttons.forEach((t, i) =>
        t.setAttribute("aria-current", e === i ? "true" : "false")
      ),
      this.hasAttribute("align-selected"))
    ) {
      const t = this.buttons[e],
        i = window.innerWidth / 2,
        n = t.getBoundingClientRect(),
        s = this._findFirstScrollableElement(this.parentElement);
      s &&
        s.scrollTo({
          behavior: "smooth",
          left: s.scrollLeft + (n.left - i) + n.width / 2,
        });
    }
  }
  _dispatchEvent(e) {
    e !== this.selectedIndex &&
      this.dispatchEvent(
        new CustomEvent("page-dots:changed", {
          bubbles: !0,
          detail: {
            index: e,
          },
        })
      );
  }
  _findFirstScrollableElement(e, t = 0) {
    return null === e || t > 3
      ? null
      : e.scrollWidth > e.clientWidth
      ? e
      : this._findFirstScrollableElement(e.parentElement, t + 1);
  }
};
window.customElements.define("page-dots", PageDots);
var PrevNextButtons = class extends HTMLElement {
    connectedCallback() {
      (this.prevButton = this.querySelector("button:first-of-type")),
        (this.nextButton = this.querySelector("button:last-of-type")),
        this.prevButton.addEventListener("click", () =>
          this.prevButton.dispatchEvent(
            new CustomEvent("prev-next:prev", {
              bubbles: !0,
            })
          )
        ),
        this.nextButton.addEventListener("click", () =>
          this.nextButton.dispatchEvent(
            new CustomEvent("prev-next:next", {
              bubbles: !0,
            })
          )
        );
    }
    set isPrevDisabled(e) {
      this.prevButton.disabled = e;
    }
    set isNextDisabled(e) {
      this.nextButton.disabled = e;
    }
  },
  PrevButton = class extends HTMLButtonElement {
    connectedCallback() {
      this.addEventListener("click", () =>
        this.dispatchEvent(
          new CustomEvent("prev-next:prev", {
            bubbles: !0,
          })
        )
      );
    }
  },
  NextButton = class extends HTMLButtonElement {
    connectedCallback() {
      this.addEventListener("click", () =>
        this.dispatchEvent(
          new CustomEvent("prev-next:next", {
            bubbles: !0,
          })
        )
      );
    }
  };

function getStickyHeaderOffset() {
  const e = getComputedStyle(document.documentElement);
  return (
    parseInt(e.getPropertyValue("--header-height") || 0) *
      parseInt(e.getPropertyValue("--enable-sticky-header") || 0) +
    parseInt(e.getPropertyValue("--announcement-bar-height") || 0) *
      parseInt(e.getPropertyValue("--enable-sticky-announcement-bar") || 0)
  );
}
window.customElements.define("prev-next-buttons", PrevNextButtons),
  window.customElements.define("prev-button", PrevButton, {
    extends: "button",
  }),
  window.customElements.define("next-button", NextButton, {
    extends: "button",
  });
var SafeSticky = class extends HTMLElement {
  connectedCallback() {
    (this.lastKnownY = window.scrollY),
      (this.currentTop = 0),
      (this.hasPendingRaf = !1),
      window.addEventListener("scroll", this._checkPosition.bind(this));
  }
  get initialTopOffset() {
    return (
      getStickyHeaderOffset() + (parseInt(this.getAttribute("offset")) || 0)
    );
  }
  _checkPosition() {
    this.hasPendingRaf ||
      ((this.hasPendingRaf = !0),
      requestAnimationFrame(() => {
        let e =
            this.getBoundingClientRect().top +
            window.scrollY -
            this.offsetTop +
            this.initialTopOffset,
          t = this.clientHeight - window.innerHeight;
        window.scrollY < this.lastKnownY
          ? (this.currentTop -= window.scrollY - this.lastKnownY)
          : (this.currentTop += this.lastKnownY - window.scrollY),
          (this.currentTop = Math.min(
            Math.max(this.currentTop, -t),
            e,
            this.initialTopOffset
          )),
          (this.lastKnownY = window.scrollY),
          (this.style.top = `${this.currentTop}px`),
          (this.hasPendingRaf = !1);
      }));
  }
};

function throttle(e, t = 15) {
  let i = null,
    n = null;
  const s = (a) => {
    (n = a),
      !i &&
        (e(n),
        (n = null),
        (i = setTimeout(() => {
          (i = null), n && s(n);
        }, t)));
  };
  return s;
}
window.customElements.define("safe-sticky", SafeSticky);
var ScrollSpy = class extends HTMLElement {
  connectedCallback() {
    this._createSvg(),
      (this.elementsToObserve = Array.from(this.querySelectorAll("a")).map(
        (e) => document.querySelector(e.getAttribute("href"))
      )),
      (this.navListItems = Array.from(this.querySelectorAll("li"))),
      (this.navItems = this.navListItems
        .map((e) => {
          const t = e.firstElementChild,
            i = t && t.getAttribute("href").slice(1);
          return {
            listItem: e,
            anchor: t,
            target: document.getElementById(i),
          };
        })
        .filter((e) => e.target)),
      this.drawPath(),
      window.addEventListener(
        "scroll",
        throttle(this.markVisibleSection.bind(this), 25)
      ),
      window.addEventListener("orientationchange", () => {
        window.addEventListener(
          "resize",
          () => {
            this.drawPath(), this.markVisibleSection();
          },
          {
            once: !0,
          }
        );
      }),
      this.markVisibleSection();
  }
  _createSvg() {
    this.navPath = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "path"
    );
    const e = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    e.insertAdjacentElement("beforeend", this.navPath),
      this.insertAdjacentElement("beforeend", e),
      (this.lastPathStart = this.lastPathEnd = null);
  }
  drawPath() {
    let e,
      t = [];
    this.navItems.forEach((i, n) => {
      const s = i.anchor.offsetLeft - 5,
        a = i.anchor.offsetTop,
        r = i.anchor.offsetHeight;
      0 === n
        ? (t.push("M", s, a, "L", s, a + r), (i.pathStart = 0))
        : (e !== s && t.push("L", e, a),
          t.push("L", s, a),
          this.navPath.setAttribute("d", t.join(" ")),
          (i.pathStart = this.navPath.getTotalLength() || 0),
          t.push("L", s, a + r)),
        (e = s),
        this.navPath.setAttribute("d", t.join(" ")),
        (i.pathEnd = this.navPath.getTotalLength());
    });
  }
  syncPath() {
    const e = this.navPath.getTotalLength();
    let t = e,
      i = 0;
    if (
      (this.navItems.forEach((e) => {
        e.listItem.classList.contains("is-visible") &&
          ((t = Math.min(e.pathStart, t)), (i = Math.max(e.pathEnd, i)));
      }),
      (() => this.querySelectorAll(".is-visible").length > 0)() && t < i)
    ) {
      if (t !== this.lastPathStart || i !== this.lastPathEnd) {
        const n = `1 ${t} ${i - t} ${e}`;
        this.navPath.style.setProperty("stroke-dashoffset", "1"),
          this.navPath.style.setProperty("stroke-dasharray", n),
          this.navPath.style.setProperty("opacity", "1");
      }
    } else this.navPath.style.setProperty("opacity", "0");
    (this.lastPathStart = t), (this.lastPathEnd = i);
  }
  markVisibleSection() {
    this.navListItems.forEach((e) => e.classList.remove("is-visible"));
    for (const [e, t] of this.elementsToObserve.entries())
      if (
        t.getBoundingClientRect().top > getStickyHeaderOffset() ||
        e === this.elementsToObserve.length - 1
      ) {
        this.querySelector(`a[href="#${t.id}"]`).parentElement.classList.add(
          "is-visible"
        );
        break;
      }
    this.syncPath();
  }
};
window.customElements.define("scroll-spy", ScrollSpy);
var template =
    "\n  <style>\n    :host {\n      display: inline-block;\n      contain: layout;\n      position: relative;\n    }\n    \n    :host([hidden]) {\n      display: none;\n    }\n    \n    s {\n      position: absolute;\n      top: 0;\n      bottom: 0;\n      left: 0;\n      right: 0;\n      pointer-events: none;\n      background-image:\n        var(--scroll-shadow-top, radial-gradient(farthest-side at 50% 0%, rgba(0,0,0,.2), rgba(0,0,0,0))),\n        var(--scroll-shadow-bottom, radial-gradient(farthest-side at 50% 100%, rgba(0,0,0,.2), rgba(0,0,0,0))),\n        var(--scroll-shadow-left, radial-gradient(farthest-side at 0%, rgba(0,0,0,.2), rgba(0,0,0,0))),\n        var(--scroll-shadow-right, radial-gradient(farthest-side at 100%, rgba(0,0,0,.2), rgba(0,0,0,0)));\n      background-position: top, bottom, left, right;\n      background-repeat: no-repeat;\n      background-size: 100% var(--top, 0), 100% var(--bottom, 0), var(--left, 0) 100%, var(--right, 0) 100%;\n    }\n  </style>\n  <slot></slot>\n  <s></s>\n",
  Updater = class {
    constructor(e) {
      (this.scheduleUpdate = throttle(() =>
        this.update(e, getComputedStyle(e))
      )),
        (this.resizeObserver = new ResizeObserver(
          this.scheduleUpdate.bind(this)
        ));
    }
    start(e) {
      this.element && this.stop(),
        e &&
          (e.addEventListener("scroll", this.scheduleUpdate),
          this.resizeObserver.observe(e),
          (this.element = e));
    }
    stop() {
      this.element &&
        (this.element.removeEventListener("scroll", this.scheduleUpdate),
        this.resizeObserver.unobserve(this.element),
        (this.element = null));
    }
    update(e, t) {
      if (!this.element) return;
      const i = t.getPropertyValue("--scroll-shadow-size")
          ? parseInt(t.getPropertyValue("--scroll-shadow-size"))
          : 0,
        n = {
          top: Math.max(this.element.scrollTop, 0),
          bottom: Math.max(
            this.element.scrollHeight -
              this.element.offsetHeight -
              this.element.scrollTop,
            0
          ),
          left: Math.max(this.element.scrollLeft, 0),
          right: Math.max(
            this.element.scrollWidth -
              this.element.offsetWidth -
              this.element.scrollLeft,
            0
          ),
        };
      requestAnimationFrame(() => {
        for (const t of ["top", "bottom", "left", "right"])
          e.style.setProperty(`--${t}`, `${n[t] > i ? i : n[t]}px`);
      });
    }
  },
  ScrollShadow = class extends HTMLElement {
    constructor() {
      super(),
        (this.attachShadow({
          mode: "open",
        }).innerHTML = template),
        (this.updater = new Updater(this.shadowRoot.lastElementChild));
    }
    connectedCallback() {
      this.shadowRoot
        .querySelector("slot")
        .addEventListener("slotchange", () => this.start()),
        this.start();
    }
    disconnectedCallback() {
      this.updater.stop();
    }
    start() {
      this.updater.start(this.firstElementChild);
    }
  };
"ResizeObserver" in window &&
  window.customElements.define("scroll-shadow", ScrollShadow);
var ShareToggleButton = class extends ToggleButton {
  _onButtonClick() {
    window.matchMedia(window.themeVariables.breakpoints.phone).matches &&
    navigator.share
      ? navigator.share({
          title: this.hasAttribute("share-title")
            ? this.getAttribute("share-title")
            : document.title,
          url: this.hasAttribute("share-url")
            ? this.getAttribute("share-url")
            : window.location.href,
        })
      : super._onButtonClick();
  }
};
window.customElements.define("share-toggle-button", ShareToggleButton, {
  extends: "button",
});
var NativeCarousel = class extends CustomHTMLElement {
    connectedCallback() {
      (this.items = Array.from(this.querySelectorAll("native-carousel-item"))),
        (this.pageDotsElements = Array.from(
          this.querySelectorAll("page-dots")
        )),
        (this.prevNextButtonsElements = Array.from(
          this.querySelectorAll("prev-next-buttons")
        )),
        this.items.length > 1 &&
          (this.addEventListener("prev-next:prev", this.prev.bind(this)),
          this.addEventListener("prev-next:next", this.next.bind(this)),
          this.addEventListener("page-dots:changed", (e) =>
            this.select(e.detail.index, !0)
          ),
          Shopify.designMode &&
            this.addEventListener("shopify:block:select", (e) =>
              this.select(e.target.index, !e.detail.load)
            ));
      const e = this.items[0].parentElement;
      (this.intersectionObserver = new IntersectionObserver(
        this._onVisibilityChanged.bind(this),
        {
          root: e,
          rootMargin: `${e.clientHeight}px 0px`,
          threshold: 0.8,
        }
      )),
        this.items.forEach((e) => this.intersectionObserver.observe(e));
    }
    disconnectedCallback() {
      super.disconnectedCallback(), this.intersectionObserver.disconnect();
    }
    get selectedIndex() {
      return this.items.findIndex((e) => e.selected);
    }
    prev(e = !0) {
      this.select(Math.max(this.selectedIndex - 1, 0), e);
    }
    next(e = !0) {
      this.select(Math.min(this.selectedIndex + 1, this.items.length - 1), e);
    }
    select(e, t = !0) {
      const i = Math.max(0, Math.min(e, this.items.length)),
        n = this.items[i];
      this._adjustNavigationForElement(n),
        t &&
          (this.items.forEach((e) => this.intersectionObserver.unobserve(e)),
          setInterval(() => {
            this.items.forEach((e) => this.intersectionObserver.observe(e));
          }, 800)),
        this.items.forEach((e, t) => (e.selected = t === i));
      const s = "ltr" === window.themeVariables.settings.direction ? 1 : -1;
      n.parentElement.scrollTo({
        left: s * (n.clientWidth * i),
        behavior: t ? "smooth" : "auto",
      });
    }
    _adjustNavigationForElement(e) {
      this.items.forEach((t) => (t.selected = e === t)),
        this.pageDotsElements.forEach((t) => (t.selectedIndex = e.index)),
        this.prevNextButtonsElements.forEach((t) => {
          (t.isPrevDisabled = 0 === e.index),
            (t.isNextDisabled = e.index === this.items.length - 1);
        });
    }
    _onVisibilityChanged(e) {
      for (let t of e)
        if (t.isIntersecting) {
          this._adjustNavigationForElement(t.target);
          break;
        }
    }
  },
  NativeCarouselItem = class extends CustomHTMLElement {
    static get observedAttributes() {
      return ["hidden"];
    }
    get index() {
      return [...this.parentNode.children].indexOf(this);
    }
    get selected() {
      return !this.hasAttribute("hidden");
    }
    set selected(e) {
      this.hidden = !e;
    }
  };
window.customElements.define("native-carousel-item", NativeCarouselItem),
  window.customElements.define("native-carousel", NativeCarousel);
var DragCursor = class extends HTMLElement {
  connectedCallback() {
    (this.scrollableElement = this.parentElement),
      this.scrollableElement.addEventListener(
        "mouseenter",
        this._onMouseEnter.bind(this)
      ),
      this.scrollableElement.addEventListener(
        "mousemove",
        this._onMouseMove.bind(this)
      ),
      this.scrollableElement.addEventListener(
        "mouseleave",
        this._onMouseLeave.bind(this)
      ),
      (this.innerHTML =
        '\n      <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120">\n        <path d="M0 60C0 26.863 26.863 0 60 0s60 26.863 60 60-26.863 60-60 60S0 93.137 0 60z" fill="rgb(var(--text-color))"/>\n        <path d="M46 50L36 60l10 10M74 50l10 10-10 10" stroke="rgb(var(--section-background))" stroke-width="4"/>\n      </svg>\n    ');
  }
  _onMouseEnter(e) {
    this.removeAttribute("hidden"), this._positionCursor(e);
  }
  _onMouseLeave() {
    this.setAttribute("hidden", "");
  }
  _onMouseMove(e) {
    this.toggleAttribute(
      "hidden",
      "BUTTON" === e.target.tagName || "A" === e.target.tagName
    ),
      this._positionCursor(e);
  }
  _positionCursor(e) {
    const t = this.scrollableElement.getBoundingClientRect(),
      i = e.clientX - t.x,
      n = e.clientY - t.y;
    this.style.transform = `translate(${i - this.clientWidth / 2}px, ${
      n - this.clientHeight / 2
    }px)`;
  }
};
window.customElements.define("drag-cursor", DragCursor);
var ScrollableContent = class extends CustomHTMLElement {
  connectedCallback() {
    this.draggable && this._setupDraggability(),
      this._checkScrollability(),
      window.addEventListener("resize", this._checkScrollability.bind(this)),
      this.addEventListener(
        "scroll",
        throttle(this._calculateProgress.bind(this), 15)
      );
  }
  get draggable() {
    return this.hasAttribute("draggable");
  }
  _setupDraggability() {
    this.insertAdjacentHTML(
      "afterend",
      '<drag-cursor hidden class="custom-drag-cursor"></drag-cursor>'
    );
    const e = matchMedia("(hover: none)");
    e.addListener(this._onMediaChanges.bind(this)),
      e.matches || this._attachDraggableListeners();
  }
  _attachDraggableListeners() {
    this.delegate.on("mousedown", this._onMouseDown.bind(this)),
      this.delegate.on("mousemove", this._onMouseMove.bind(this)),
      this.delegate.on("mouseup", this._onMouseUp.bind(this));
  }
  _removeDraggableListeners() {
    this.delegate.off("mousedown"),
      this.delegate.off("mousemove"),
      this.delegate.off("mouseup");
  }
  _checkScrollability() {
    this.classList.toggle("is-scrollable", this.scrollWidth > this.offsetWidth);
  }
  _calculateProgress() {
    const e =
      this.scrollLeft *
      ("ltr" === window.themeVariables.settings.direction ? 1 : -1);
    triggerEvent(this, "scrollable-content:progress", {
      progress:
        100 *
        Math.max(0, Math.min(1, e / (this.scrollWidth - this.clientWidth))),
    });
  }
  _onMediaChanges(e) {
    e.matches
      ? this._removeDraggableListeners()
      : this._attachDraggableListeners();
  }
  _onMouseDown(e) {
    e.target && "IMG" === e.target.nodeName && e.preventDefault(),
      (this.startX = e.clientX + this.scrollLeft),
      (this.diffX = 0),
      (this.drag = !0);
  }
  _onMouseMove(e) {
    this.drag &&
      ((this.diffX = this.startX - (e.clientX + this.scrollLeft)),
      (this.scrollLeft += this.diffX));
  }
  _onMouseUp() {
    this.drag = !1;
    let e = 1,
      t = () => {
        let i = Math.sinh(e);
        i <= 0
          ? window.cancelAnimationFrame(t)
          : ((this.scrollLeft += this.diffX * i),
            (e -= 0.03),
            window.requestAnimationFrame(t));
      };
    t();
  }
};
window.customElements.define("scrollable-content", ScrollableContent);
var LoadingBar = class extends CustomHTMLElement {
  constructor() {
    super(),
      this.rootDelegate.on("theme:loading:start", this.show.bind(this)),
      this.rootDelegate.on("theme:loading:end", this.hide.bind(this)),
      this.delegate.on("transitionend", this._onTransitionEnd.bind(this));
  }
  show() {
    this.classList.add("is-visible"), (this.style.transform = "scaleX(0.4)");
  }
  hide() {
    (this.style.transform = "scaleX(1)"), this.classList.add("is-finished");
  }
  _onTransitionEnd(e) {
    "transform" === e.propertyName &&
      this.classList.contains("is-finished") &&
      (this.classList.remove("is-visible"),
      this.classList.remove("is-finished"),
      (this.style.transform = "scaleX(0)"));
  }
};
window.customElements.define("loading-bar", LoadingBar);
var SplitLines = class extends HTMLElement {
  connectedCallback() {
    (this.originalContent = this.textContent),
      (this.lastWidth = window.innerWidth),
      (this.hasBeenSplitted = !1),
      window.addEventListener("resize", this._onResize.bind(this));
  }
  [Symbol.asyncIterator]() {
    return {
      splitPromise: this.split.bind(this),
      index: 0,
      async next() {
        const e = await this.splitPromise();
        return this.index !== e.length
          ? {
              done: !1,
              value: e[this.index++],
            }
          : {
              done: !0,
            };
      },
    };
  }
  split(e = !1) {
    return this.childElementCount > 0 && !e
      ? Promise.resolve(Array.from(this.children))
      : ((this.hasBeenSplitted = !0),
        new Promise((t) => {
          requestAnimationFrame(() => {
            this.innerHTML = this.originalContent
              .replace(/./g, "<span>$&</span>")
              .replace(/\s/g, " ");
            const i = {};
            Array.from(this.children).forEach((e) => {
              const t = parseInt(e.getBoundingClientRect().top);
              i[t] = (i[t] || "") + e.textContent;
            }),
              (this.innerHTML = Object.values(i)
                .map(
                  (t) =>
                    `<span ${
                      this.hasAttribute("reveal") && !e ? "reveal" : ""
                    } ${
                      this.hasAttribute("reveal-visibility") && !e
                        ? "reveal-visibility"
                        : ""
                    } style="display: block">${t.trim()}</span>`
                )
                .join("")),
              (this.style.opacity = this.hasAttribute("reveal") ? 1 : null),
              (this.style.visibility = this.hasAttribute("reveal-visibility")
                ? "visible"
                : null),
              t(Array.from(this.children));
          });
        }));
  }
  async _onResize() {
    this.lastWidth !== window.innerWidth &&
      this.hasBeenSplitted &&
      (await this.split(!0),
      this.dispatchEvent(
        new CustomEvent("split-lines:re-split", {
          bubbles: !0,
        })
      ),
      (this.lastWidth = window.innerWidth));
  }
};
window.customElements.define("split-lines", SplitLines);
var PopoverContent = class extends OpenableElement {
  connectedCallback() {
    super.connectedCallback(),
      this.delegate.on("click", ".popover__overlay", () => (this.open = !1));
  }
  attributeChangedCallback(e, t, i) {
    super.attributeChangedCallback(e, t, i),
      "open" === e &&
        document.documentElement.classList.toggle("lock-mobile", this.open);
  }
};
window.customElements.define("popover-content", PopoverContent);
var TabsNav = class extends HTMLElement {
  connectedCallback() {
    (this.buttons = Array.from(this.querySelectorAll("button[aria-controls]"))),
      (this.scrollerElement = this.querySelector(".tabs-nav__scroller")),
      this.buttons.forEach((e) =>
        e.addEventListener("click", () => this.selectButton(e))
      ),
      this.addEventListener("shopify:block:select", (e) =>
        this.selectButton(e.target, !e.detail.load)
      ),
      (this.positionElement = document.createElement("span")),
      this.positionElement.classList.add("tabs-nav__position"),
      this.buttons[0].parentElement.insertAdjacentElement(
        "afterend",
        this.positionElement
      ),
      window.addEventListener("resize", this._onWindowResized.bind(this)),
      this._adjustNavigationPosition(),
      this.hasArrows && this._handleArrows();
  }
  get hasArrows() {
    return this.hasAttribute("arrows");
  }
  get selectedTabIndex() {
    return this.buttons.findIndex(
      (e) => "true" === e.getAttribute("aria-expanded")
    );
  }
  get selectedButton() {
    return this.buttons.find((e) => "true" === e.getAttribute("aria-expanded"));
  }
  selectButton(e, t = !0) {
    if (!this.buttons.includes(e) || this.selectedButton === e) return;
    const i = document.getElementById(
        this.selectedButton.getAttribute("aria-controls")
      ),
      n = document.getElementById(e.getAttribute("aria-controls"));
    t ? this._transitionContent(i, n) : ((i.hidden = !0), (n.hidden = !1)),
      this.selectedButton.setAttribute("aria-expanded", "false"),
      e.setAttribute("aria-expanded", "true"),
      triggerEvent(this, "tabs-nav:changed", {
        button: e,
      }),
      this._adjustNavigationPosition();
  }
  addButton(e) {
    e.addEventListener("click", () => this.selectButton(e)),
      e.setAttribute("aria-expanded", "false"),
      this.buttons[this.buttons.length - 1].insertAdjacentElement(
        "afterend",
        e
      ),
      this.buttons.push(e),
      this._adjustNavigationPosition(!1);
  }
  _transitionContent(e, t) {
    e.animate(
      {
        opacity: [1, 0],
      },
      {
        duration: 250,
        easing: "ease",
      }
    ).onfinish = () => {
      (e.hidden = !0),
        (t.hidden = !1),
        t.animate(
          {
            opacity: [0, 1],
          },
          {
            duration: 250,
            easing: "ease",
          }
        );
    };
  }
  _onWindowResized() {
    this._adjustNavigationPosition();
  }
  _adjustNavigationPosition(e = !0) {
    const t =
        this.selectedButton.clientWidth /
        this.positionElement.parentElement.clientWidth,
      i =
        this.selectedButton.offsetLeft /
        this.positionElement.parentElement.clientWidth /
        t,
      n = this.scrollerElement.clientWidth / 2;
    this.scrollerElement.scrollTo({
      behavior: e ? "smooth" : "auto",
      left:
        this.selectedButton.offsetLeft -
        n +
        this.selectedButton.clientWidth / 2,
    }),
      e || (this.positionElement.style.transition = "none"),
      this.positionElement.style.setProperty("--scale", t),
      this.positionElement.style.setProperty("--translate", 100 * i + "%"),
      this.positionElement.clientWidth,
      requestAnimationFrame(() => {
        this.positionElement.classList.add("is-initialized"),
          (this.positionElement.style.transition = null);
      });
  }
  _handleArrows() {
    const e = this.querySelector(".tabs-nav__arrows");
    e.firstElementChild.addEventListener("click", () => {
      this.selectButton(this.buttons[Math.max(this.selectedTabIndex - 1, 0)]);
    }),
      e.lastElementChild.addEventListener("click", () => {
        this.selectButton(
          this.buttons[
            Math.min(this.selectedTabIndex + 1, this.buttons.length - 1)
          ]
        );
      });
  }
};
window.customElements.define("tabs-nav", TabsNav);
var LibraryLoader = class {
  static load(e) {
    const t = "requested",
      i = "loaded",
      n = this.libraries[e];
    if (!n) return;
    if (n.status === t) return n.promise;
    if (n.status === i) return Promise.resolve();
    let s;
    return (
      (s =
        "script" === n.type
          ? new Promise((e, t) => {
              let s = document.createElement("script");
              (s.id = n.tagId),
                (s.src = n.src),
                (s.onerror = t),
                (s.onload = () => {
                  (n.status = i), e();
                }),
                document.body.appendChild(s);
            })
          : new Promise((e, t) => {
              let s = document.createElement("link");
              (s.id = n.tagId),
                (s.href = n.src),
                (s.rel = "stylesheet"),
                (s.type = "text/css"),
                (s.onerror = t),
                (s.onload = () => {
                  (n.status = i), e();
                }),
                document.body.appendChild(s);
            })),
      (n.promise = s),
      (n.status = t),
      s
    );
  }
};
__publicField(LibraryLoader, "libraries", {
  flickity: {
    tagId: "flickity",
    src: window.themeVariables.libs.flickity,
    type: "script",
  },
  photoswipe: {
    tagId: "photoswipe",
    src: window.themeVariables.libs.photoswipe,
    type: "script",
  },
  qrCode: {
    tagId: "qrCode",
    src: window.themeVariables.libs.qrCode,
    type: "script",
  },
  modelViewerUiStyles: {
    tagId: "shopify-model-viewer-ui-styles",
    src: "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css",
    type: "link",
  },
});
var QrCode = class extends HTMLElement {
  async connectedCallback() {
    await LibraryLoader.load("qrCode"),
      new window.QRCode(this, {
        text: this.getAttribute("identifier"),
        width: 200,
        height: 200,
      });
  }
};
window.customElements.define("qr-code", QrCode);
var CountrySelector = class extends HTMLSelectElement {
  connectedCallback() {
    if (
      ((this.provinceElement = document.getElementById(
        this.getAttribute("aria-owns")
      )),
      this.addEventListener(
        "change",
        this._updateProvinceVisibility.bind(this)
      ),
      this.hasAttribute("data-default"))
    )
      for (let e = 0; e !== this.options.length; ++e)
        if (this.options[e].text === this.getAttribute("data-default")) {
          this.selectedIndex = e;
          break;
        }
    this._updateProvinceVisibility();
    const e =
      "SELECT" === this.provinceElement.tagName
        ? this.provinceElement
        : this.provinceElement.querySelector("select");
    if (e.hasAttribute("data-default"))
      for (let t = 0; t !== e.options.length; ++t)
        if (e.options[t].text === e.getAttribute("data-default")) {
          e.selectedIndex = t;
          break;
        }
  }
  _updateProvinceVisibility() {
    const e = this.options[this.selectedIndex];
    if (!e) return;
    let t = JSON.parse(e.getAttribute("data-provinces") || "[]"),
      i =
        "SELECT" === this.provinceElement.tagName
          ? this.provinceElement
          : this.provinceElement.querySelector("select");
    (i.innerHTML = ""),
      0 !== t.length
        ? (t.forEach((e) => {
            i.options.add(new Option(e[1], e[0]));
          }),
          (this.provinceElement.hidden = !1))
        : (this.provinceElement.hidden = !0);
  }
};
window.customElements.define("country-selector", CountrySelector, {
  extends: "select",
});
var ModalContent = class extends OpenableElement {
  connectedCallback() {
    super.connectedCallback(),
      !this.appearAfterDelay ||
        (this.onlyOnce && this.hasAppearedOnce) ||
        setTimeout(() => (this.open = !0), this.apparitionDelay),
      this.delegate.on("click", ".modal__overlay", () => (this.open = !1));
  }
  get appearAfterDelay() {
    return this.hasAttribute("apparition-delay");
  }
  get apparitionDelay() {
    return 1e3 * parseInt(this.getAttribute("apparition-delay") || 0);
  }
  get onlyOnce() {
    return this.hasAttribute("only-once");
  }
  get hasAppearedOnce() {
    return null !== localStorage.getItem("theme:popup-appeared");
  }
  attributeChangedCallback(e, t, i) {
    super.attributeChangedCallback(e, t, i),
      "open" === e &&
        (document.documentElement.classList.toggle("lock-all", this.open),
        this.open && localStorage.setItem("theme:popup-appeared", !0));
  }
};
window.customElements.define("modal-content", ModalContent);
var PriceRange = class extends HTMLElement {
  connectedCallback() {
    (this.rangeLowerBound = this.querySelector(
      ".price-range__range-group input:first-child"
    )),
      (this.rangeHigherBound = this.querySelector(
        ".price-range__range-group input:last-child"
      )),
      (this.textInputLowerBound = this.querySelector(
        ".price-range__input:first-child input"
      )),
      (this.textInputHigherBound = this.querySelector(
        ".price-range__input:last-child input"
      )),
      this.textInputLowerBound.addEventListener("focus", () =>
        this.textInputLowerBound.select()
      ),
      this.textInputHigherBound.addEventListener("focus", () =>
        this.textInputHigherBound.select()
      ),
      this.textInputLowerBound.addEventListener("change", (e) => {
        (e.target.value = Math.max(
          Math.min(
            parseInt(e.target.value),
            parseInt(this.textInputHigherBound.value || e.target.max) - 1
          ),
          e.target.min
        )),
          (this.rangeLowerBound.value = e.target.value),
          this.rangeLowerBound.parentElement.style.setProperty(
            "--range-min",
            (parseInt(this.rangeLowerBound.value) /
              parseInt(this.rangeLowerBound.max)) *
              100 +
              "%"
          );
      }),
      this.textInputHigherBound.addEventListener("change", (e) => {
        (e.target.value = Math.min(
          Math.max(
            parseInt(e.target.value),
            parseInt(this.textInputLowerBound.value || e.target.min) + 1
          ),
          e.target.max
        )),
          (this.rangeHigherBound.value = e.target.value),
          this.rangeHigherBound.parentElement.style.setProperty(
            "--range-max",
            (parseInt(this.rangeHigherBound.value) /
              parseInt(this.rangeHigherBound.max)) *
              100 +
              "%"
          );
      }),
      this.rangeLowerBound.addEventListener("change", (e) => {
        (this.textInputLowerBound.value = e.target.value),
          this.textInputLowerBound.dispatchEvent(
            new Event("change", {
              bubbles: !0,
            })
          );
      }),
      this.rangeHigherBound.addEventListener("change", (e) => {
        (this.textInputHigherBound.value = e.target.value),
          this.textInputHigherBound.dispatchEvent(
            new Event("change", {
              bubbles: !0,
            })
          );
      }),
      this.rangeLowerBound.addEventListener("input", (e) => {
        triggerEvent(this, "facet:abort-loading"),
          (e.target.value = Math.min(
            parseInt(e.target.value),
            parseInt(this.textInputHigherBound.value || e.target.max) - 1
          )),
          e.target.parentElement.style.setProperty(
            "--range-min",
            (parseInt(e.target.value) / parseInt(e.target.max)) * 100 + "%"
          ),
          (this.textInputLowerBound.value = e.target.value);
      }),
      this.rangeHigherBound.addEventListener("input", (e) => {
        triggerEvent(this, "facet:abort-loading"),
          (e.target.value = Math.max(
            parseInt(e.target.value),
            parseInt(this.textInputLowerBound.value || e.target.min) + 1
          )),
          e.target.parentElement.style.setProperty(
            "--range-max",
            (parseInt(e.target.value) / parseInt(e.target.max)) * 100 + "%"
          ),
          (this.textInputHigherBound.value = e.target.value);
      });
  }
};
window.customElements.define("price-range", PriceRange);
var LinkBar = class extends HTMLElement {
  connectedCallback() {
    const e = this.querySelector(".link-bar__link-item--selected");
    e &&
      requestAnimationFrame(() => {
        e.style.scrollSnapAlign = "none";
      });
  }
};
window.customElements.define("link-bar", LinkBar);
var MediaFeatures = class {
    static prefersReducedMotion() {
      return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    }
    static supportsHover() {
      return window.matchMedia("(pointer: fine)").matches;
    }
  },
  FlickityCarousel = class extends CustomHTMLElement {
    constructor() {
      super(),
        1 !== this.childElementCount &&
          (this.addEventListener(
            "flickity:ready",
            this._preloadNextImage.bind(this)
          ),
          this.addEventListener(
            "flickity:slide-changed",
            this._preloadNextImage.bind(this)
          ),
          this._createFlickity());
    }
    async disconnectedCallback() {
      this.flickity && (await this.flickity).destroy();
    }
    get flickityConfig() {
      return JSON.parse(this.getAttribute("flickity-config"));
    }
    get flickityInstance() {
      return this.flickity;
    }
    async next() {
      (await this.flickityInstance).next();
    }
    async previous() {
      (await this.flickityInstance).previous();
    }
    async select(e) {
      (await this.flickityInstance).selectCell(e);
    }
    async setDraggable(e) {
      const t = await this.flickity;
      (t.options.draggable = e), t.updateDraggable();
    }
    async reload() {
      (await this.flickity).destroy(),
        this.flickityConfig.cellSelector &&
          Array.from(this.children)
            .sort((e, t) =>
              parseInt(e.getAttribute("data-original-position")) >
              parseInt(t.getAttribute("data-original-position"))
                ? 1
                : -1
            )
            .forEach((e) => this.appendChild(e)),
        this._createFlickity();
    }
    async _createFlickity() {
      (this.flickity = new Promise(async (e) => {
        await LibraryLoader.load("flickity"),
          await this.untilVisible({
            rootMargin: "400px",
            threshold: 0,
          }),
          e(
            new window.ThemeFlickity(this, {
              ...this.flickityConfig,
              rightToLeft: "rtl" === window.themeVariables.settings.direction,
              accessibility: MediaFeatures.supportsHover(),
              on: {
                ready: (e) => triggerEvent(this, "flickity:ready", e),
                change: (e) => triggerEvent(this, "flickity:slide-changed", e),
                settle: (e) => triggerEvent(this, "flickity:slide-settled", e),
              },
            })
          );
      })),
        this.hasAttribute("click-nav") &&
          ((await this.flickityInstance).on(
            "staticClick",
            this._onStaticClick.bind(this)
          ),
          this.addEventListener("mousemove", this._onMouseMove.bind(this)));
    }
    async _onStaticClick(e, t, i) {
      const n = await this.flickityInstance,
        s =
          n.selectedElement.hasAttribute("data-media-type") &&
          ["video", "external_video", "model"].includes(
            n.selectedElement.getAttribute("data-media-type")
          );
      if (
        !i ||
        s ||
        window.matchMedia(window.themeVariables.breakpoints.phone).matches
      )
        return;
      const a = n.viewport.getBoundingClientRect(),
        r = Math.floor(a.right - a.width / 2);
      t.clientX > r ? n.next() : n.previous();
    }
    async _onMouseMove(e) {
      const t = await this.flickityInstance,
        i =
          t.selectedElement.hasAttribute("data-media-type") &&
          ["video", "external_video", "model"].includes(
            t.selectedElement.getAttribute("data-media-type")
          );
      this.classList.toggle(
        "is-hovering-right",
        e.offsetX > this.clientWidth / 2 && !i
      ),
        this.classList.toggle(
          "is-hovering-left",
          e.offsetX <= this.clientWidth / 2 && !i
        );
    }
    async _preloadNextImage() {
      const e = await this.flickity;
      e.selectedElement.nextElementSibling &&
        e.selectedElement.nextElementSibling
          .querySelector("img")
          ?.setAttribute("loading", "eager");
    }
  };

function getSiblings(e, t, i = !1) {
  let n = [],
    s = e;
  for (; (s = s.previousElementSibling); ) (t && !s.matches(t)) || n.push(s);
  for (i && n.push(e), s = e; (s = s.nextElementSibling); )
    (t && !s.matches(t)) || n.push(s);
  return n;
}
async function resolveAsyncIterator(e) {
  const t = [];
  (null != e && "function" == typeof e[Symbol.iterator]) || (e = [e]);
  for (const i of e)
    if ("function" == typeof i[Symbol.asyncIterator])
      for await (const e of i) t.push(e);
    else t.push(i);
  return t;
}
window.customElements.define("flickity-carousel", FlickityCarousel);
var FlickityControls = class extends CustomHTMLElement {
  async connectedCallback() {
    this.flickityCarousel.addEventListener(
      "flickity:ready",
      this._onSlideChanged.bind(this, !1)
    ),
      this.flickityCarousel.addEventListener(
        "flickity:slide-changed",
        this._onSlideChanged.bind(this, !0)
      ),
      this.delegate.on("click", '[data-action="prev"]', () =>
        this.flickityCarousel.previous()
      ),
      this.delegate.on("click", '[data-action="next"]', () =>
        this.flickityCarousel.next()
      ),
      this.delegate.on("click", '[data-action="select"]', (e, t) =>
        this.flickityCarousel.select(`#${t.getAttribute("aria-controls")}`)
      );
  }
  get flickityCarousel() {
    return (this._flickityCarousel =
      this._flickityCarousel ||
      document.getElementById(this.getAttribute("controls")));
  }
  async _onSlideChanged(e = !0) {
    let t = await this.flickityCarousel.flickityInstance;
    Array.from(
      this.querySelectorAll(`[aria-controls="${t.selectedElement.id}"]`)
    ).forEach((t) => {
      t.setAttribute("aria-current", "true"),
        getSiblings(t).forEach((e) => e.removeAttribute("aria-current")),
        requestAnimationFrame(() => {
          if (t.offsetParent && t.offsetParent !== this) {
            const i = t.offsetParent.clientHeight / 2,
              n = t.offsetParent.clientWidth / 2;
            t.offsetParent.scrollTo({
              behavior: e ? "smooth" : "auto",
              top: t.offsetTop - i + t.clientHeight / 2,
              left: t.offsetLeft - n + t.clientWidth / 2,
            });
          }
        });
    });
  }
};
window.customElements.define("flickity-controls", FlickityControls);
var ExternalVideo = class extends CustomHTMLElement {
  constructor() {
    super(),
      (this.hasLoaded = !1),
      (async () => {
        this.autoPlay
          ? (await this.untilVisible({
              rootMargin: "300px",
              threshold: 0,
            }),
            this.play())
          : this.addEventListener("click", this.play.bind(this), {
              once: !0,
            });
      })();
  }
  get autoPlay() {
    return this.hasAttribute("autoplay");
  }
  get provider() {
    return this.getAttribute("provider");
  }
  async play() {
    this.hasLoaded || (await this._setupPlayer()),
      "youtube" === this.provider
        ? setTimeout(() => {
            this.querySelector("iframe").contentWindow.postMessage(
              JSON.stringify({
                event: "command",
                func: "playVideo",
                args: "",
              }),
              "*"
            );
          }, 150)
        : "vimeo" === this.provider &&
          this.querySelector("iframe").contentWindow.postMessage(
            JSON.stringify({
              method: "play",
            }),
            "*"
          );
  }
  pause() {
    this.hasLoaded &&
      ("youtube" === this.provider
        ? this.querySelector("iframe").contentWindow.postMessage(
            JSON.stringify({
              event: "command",
              func: "pauseVideo",
              args: "",
            }),
            "*"
          )
        : "vimeo" === this.provider &&
          this.querySelector("iframe").contentWindow.postMessage(
            JSON.stringify({
              method: "pause",
            }),
            "*"
          ));
  }
  _setupPlayer() {
    return this._setupPromise
      ? this._setupPromise
      : (this._setupPromise = new Promise((e) => {
          const t = this.querySelector("template"),
            i = t.content.firstElementChild.cloneNode(!0);
          (i.onload = () => {
            (this.hasLoaded = !0), e();
          }),
            this.autoPlay
              ? t.replaceWith(i)
              : ((this.innerHTML = ""), this.appendChild(i));
        }));
  }
};
window.customElements.define("external-video", ExternalVideo);
var ProductLoader = class {
  static load(e) {
    if (e)
      return (
        this.loadedProducts[e] ||
          (this.loadedProducts[e] = new Promise(async (t) => {
            const i = await fetch(
              `${window.themeVariables.routes.rootUrlWithoutSlash}/products/${e}.js`
            );
            t(await i.json());
          })),
        this.loadedProducts[e]
      );
  }
};
__publicField(ProductLoader, "loadedProducts", {});
var ModelMedia = class extends HTMLElement {
  constructor() {
    super(),
      LibraryLoader.load("modelViewerUiStyles"),
      window.Shopify.loadFeatures([
        {
          name: "shopify-xr",
          version: "1.0",
          onLoad: this._setupShopifyXr.bind(this),
        },
        {
          name: "model-viewer-ui",
          version: "1.0",
          onLoad: () => {
            this.modelUi = new window.Shopify.ModelViewerUI(
              this.firstElementChild,
              {
                focusOnPlay: !1,
              }
            );
            const e = this.querySelector("model-viewer");
            e.addEventListener("shopify_model_viewer_ui_toggle_play", () => {
              e.dispatchEvent(
                new CustomEvent("model:played", {
                  bubbles: !0,
                })
              );
            }),
              e.addEventListener("shopify_model_viewer_ui_toggle_pause", () => {
                e.dispatchEvent(
                  new CustomEvent("model:paused", {
                    bubbles: !0,
                  })
                );
              });
          },
        },
      ]);
  }
  disconnectedCallback() {
    this.modelUi?.destroy();
  }
  play() {
    this.modelUi && this.modelUi.play();
  }
  pause() {
    this.modelUi && this.modelUi.pause();
  }
  async _setupShopifyXr() {
    if (window.ShopifyXR) {
      const e = (
        await ProductLoader.load(this.getAttribute("product-handle"))
      ).media.filter((e) => "model" === e.media_type);
      window.ShopifyXR.addModels(e), window.ShopifyXR.setupXRElements();
    } else
      document.addEventListener(
        "shopify_xr_initialized",
        this._setupShopifyXr.bind(this)
      );
  }
};
window.customElements.define("model-media", ModelMedia);
var NativeVideo = class extends HTMLElement {
  constructor() {
    super(),
      (this.hasLoaded = !1),
      this.autoPlay
        ? this.play()
        : this.addEventListener("click", this.play.bind(this), {
            once: !0,
          });
  }
  get autoPlay() {
    return this.hasAttribute("autoplay");
  }
  play() {
    this.hasLoaded || this._replaceContent(),
      this.querySelector("video").play();
  }
  pause() {
    this.hasLoaded && this.querySelector("video").pause();
  }
  _replaceContent() {
    let e = this.querySelector("template");
    e &&
      ((e = e.content.firstElementChild.cloneNode(!0)),
      this.hasAttribute("autoplay") || (this.innerHTML = ""),
      this.appendChild(e),
      this.firstElementChild.addEventListener("play", () => {
        this.dispatchEvent(
          new CustomEvent("video:played", {
            bubbles: !0,
          })
        );
      }),
      this.firstElementChild.addEventListener("pause", () => {
        this.dispatchEvent(
          new CustomEvent("video:paused", {
            bubbles: !0,
          })
        );
      }),
      (this.hasLoaded = !0));
  }
};
window.customElements.define("native-video", NativeVideo);
var ComboBox = class extends OpenableElement {
  connectedCallback() {
    if (
      (super.connectedCallback(),
      (this.options = Array.from(this.querySelectorAll('[role="option"]'))),
      this.delegate.on(
        "click",
        '[role="option"]',
        this._onValueClicked.bind(this)
      ),
      this.delegate.on(
        "keydown",
        '[role="listbox"]',
        this._onKeyDown.bind(this)
      ),
      this.delegate.on("change", "select", this._onValueChanged.bind(this)),
      this.delegate.on("click", ".combo-box__overlay", () => (this.open = !1)),
      this.hasAttribute("fit-toggle"))
    ) {
      const e = Math.max(...this.options.map((e) => e.clientWidth)),
        t = document.querySelector(`[aria-controls="${this.id}"]`);
      t && t.style.setProperty("--largest-option-width", `${e + 2}px`);
    }
  }
  get nativeSelect() {
    return this.querySelector("select");
  }
  set selectedValue(e) {
    this.options.forEach((t) => {
      t.setAttribute(
        "aria-selected",
        t.getAttribute("value") === e ? "true" : "false"
      );
    });
  }
  attributeChangedCallback(e, t, i) {
    if ((super.attributeChangedCallback(e, t, i), "open" === e)) {
      if (this.open) {
        const e = this.getBoundingClientRect();
        this.classList.toggle(
          "combo-box--top",
          e.top >= (window.innerHeight / 2) * 1.5
        ),
          setTimeout(() => this.focusTrap.activate(), 150);
      } else
        this.focusTrap.deactivate(),
          setTimeout(() => this.classList.remove("combo-box--top"), 200);
      document.documentElement.classList.toggle("lock-mobile", this.open);
    }
  }
  _onValueClicked(e, t) {
    (this.selectedValue = t.value),
      (this.nativeSelect.value = t.value),
      this.nativeSelect.dispatchEvent(
        new Event("change", {
          bubbles: !0,
        })
      ),
      (this.open = !1);
  }
  _onValueChanged(e, t) {
    Array.from(this.nativeSelect.options).forEach((e) =>
      e.toggleAttribute("selected", t.value === e.value)
    ),
      (this.selectedValue = t.value);
  }
  _onKeyDown(e) {
    ("ArrowDown" !== e.key && "ArrowUp" !== e.key) ||
      (e.preventDefault(),
      "ArrowDown" === e.key
        ? document.activeElement.nextElementSibling?.focus()
        : document.activeElement.previousElementSibling?.focus());
  }
};
window.customElements.define("combo-box", ComboBox);
var QuantitySelector = class extends CustomHTMLElement {
  connectedCallback() {
    (this.inputElement = this.querySelector("input")),
      this.delegate.on(
        "click",
        "button:first-child",
        () => (this.inputElement.quantity = this.inputElement.quantity - 1)
      ),
      this.delegate.on(
        "click",
        "button:last-child",
        () => (this.inputElement.quantity = this.inputElement.quantity + 1)
      );
  }
};
window.customElements.define("quantity-selector", QuantitySelector);
var InputNumber = class extends HTMLInputElement {
  connectedCallback() {
    this.addEventListener("input", this._onValueInput.bind(this)),
      this.addEventListener("change", this._onValueChanged.bind(this)),
      this.addEventListener("keydown", this._onKeyDown.bind(this));
  }
  get quantity() {
    return parseInt(this.value);
  }
  set quantity(e) {
    const t =
      ("number" == typeof e || ("string" == typeof e && "" !== e.trim())) &&
      !isNaN(e);
    "" !== e &&
      ((!t || e < 0) && (e = parseInt(e) || 1),
      (this.value = Math.max(
        this.min || 1,
        Math.min(e, this.max || Number.MAX_VALUE)
      ).toString()),
      (this.size = Math.max(this.value.length + 1, 2)));
  }
  _onValueInput() {
    this.quantity = this.value;
  }
  _onValueChanged() {
    "" === this.value && (this.quantity = 1);
  }
  _onKeyDown(e) {
    e.stopPropagation(),
      "ArrowUp" === e.key
        ? (this.quantity = this.quantity + 1)
        : "ArrowDown" === e.key && (this.quantity = this.quantity - 1);
  }
};
window.customElements.define("input-number", InputNumber, {
  extends: "input",
});
var AnnouncementBar = class extends CustomHTMLElement {
  async connectedCallback() {
    await customElements.whenDefined("announcement-bar-item"),
      (this.items = Array.from(this.querySelectorAll("announcement-bar-item"))),
      (this.hasPendingTransition = !1),
      this.delegate.on(
        "click",
        '[data-action="prev"]',
        this.previous.bind(this)
      ),
      this.delegate.on("click", '[data-action="next"]', this.next.bind(this)),
      this.autoPlay &&
        (this.delegate.on(
          "announcement-bar:content:open",
          this._pausePlayer.bind(this)
        ),
        this.delegate.on(
          "announcement-bar:content:close",
          this._startPlayer.bind(this)
        )),
      window.ResizeObserver &&
        ((this.resizeObserver = new ResizeObserver(
          this._updateCustomProperties.bind(this)
        )),
        this.resizeObserver.observe(this)),
      this.autoPlay && this._startPlayer(),
      Shopify.designMode &&
        this.delegate.on("shopify:block:select", (e) =>
          this.select(e.target.index, !1)
        );
  }
  get autoPlay() {
    return this.hasAttribute("auto-play");
  }
  get selectedIndex() {
    return this.items.findIndex((e) => e.selected);
  }
  previous() {
    this.select(
      (this.selectedIndex - 1 + this.items.length) % this.items.length
    );
  }
  next() {
    this.select(
      (this.selectedIndex + 1 + this.items.length) % this.items.length
    );
  }
  async select(e, t = !0) {
    this.selectedIndex === e ||
      this.hasPendingTransition ||
      (this.autoPlay && this._pausePlayer(),
      (this.hasPendingTransition = !0),
      await this.items[this.selectedIndex].deselect(t),
      await this.items[e].select(t),
      (this.hasPendingTransition = !1),
      this.autoPlay && this._startPlayer());
  }
  _pausePlayer() {
    clearInterval(this._interval);
  }
  _startPlayer() {
    clearInterval(this._interval),
      (this._interval = setInterval(
        this.next.bind(this),
        1e3 * parseInt(this.getAttribute("cycle-speed"))
      ));
  }
  _updateCustomProperties(e) {
    e.forEach((e) => {
      if (e.target === this) {
        const t = e.borderBoxSize
          ? e.borderBoxSize.length > 0
            ? e.borderBoxSize[0].blockSize
            : e.borderBoxSize.blockSize
          : e.target.clientHeight;
        document.documentElement.style.setProperty(
          "--announcement-bar-height",
          `${t}px`
        );
      }
    });
  }
};
window.customElements.define("announcement-bar", AnnouncementBar);
var AnnouncementBarItem = class extends CustomHTMLElement {
  connectedCallback() {
    this.hasContent &&
      ((this.contentElement = this.querySelector(".announcement-bar__content")),
      this.delegate.on(
        "click",
        '[data-action="open-content"]',
        this.openContent.bind(this)
      ),
      this.delegate.on(
        "click",
        '[data-action="close-content"]',
        this.closeContent.bind(this)
      ),
      Shopify.designMode &&
        (this.addEventListener(
          "shopify:block:select",
          this.openContent.bind(this)
        ),
        this.addEventListener(
          "shopify:block:deselect",
          this.closeContent.bind(this)
        )));
  }
  get index() {
    return [...this.parentNode.children].indexOf(this);
  }
  get hasContent() {
    return this.hasAttribute("has-content");
  }
  get selected() {
    return !this.hasAttribute("hidden");
  }
  get focusTrap() {
    return (this._trapFocus =
      this._trapFocus ||
      createFocusTrap(
        this.contentElement.querySelector(".announcement-bar__content-inner"),
        {
          fallbackFocus: this,
          clickOutsideDeactivates: (e) => !("BUTTON" === e.target.tagName),
          allowOutsideClick: (e) => "BUTTON" === e.target.tagName,
          onDeactivate: this.closeContent.bind(this),
          preventScroll: !0,
        }
      ));
  }
  async select(e = !0) {
    this.removeAttribute("hidden"),
      await new Promise((t) => {
        this.animate(
          {
            transform: ["translateY(8px)", "translateY(0)"],
            opacity: [0, 1],
          },
          {
            duration: e ? 150 : 0,
            easing: "ease-in-out",
          }
        ).onfinish = t;
      });
  }
  async deselect(e = !0) {
    await this.closeContent(),
      await new Promise((t) => {
        this.animate(
          {
            transform: ["translateY(0)", "translateY(-8px)"],
            opacity: [1, 0],
          },
          {
            duration: e ? 150 : 0,
            easing: "ease-in-out",
          }
        ).onfinish = t;
      }),
      this.setAttribute("hidden", "");
  }
  async openContent() {
    this.hasContent &&
      (this.contentElement.addEventListener(
        "transitionend",
        () => this.focusTrap.activate(),
        {
          once: !0,
        }
      ),
      this.contentElement.removeAttribute("hidden"),
      document.documentElement.classList.add("lock-all"),
      this.dispatchEvent(
        new CustomEvent("announcement-bar:content:open", {
          bubbles: !0,
        })
      ));
  }
  async closeContent() {
    if (!this.hasContent || this.contentElement.hasAttribute("hidden"))
      return Promise.resolve();
    await new Promise((e) => {
      this.contentElement.addEventListener("transitionend", () => e(), {
        once: !0,
      }),
        this.contentElement.setAttribute("hidden", ""),
        this.focusTrap.deactivate(),
        document.documentElement.classList.remove("lock-all"),
        this.dispatchEvent(
          new CustomEvent("announcement-bar:content:close", {
            bubbles: !0,
          })
        );
    });
  }
};
window.customElements.define("announcement-bar-item", AnnouncementBarItem);
var SearchPage = class extends HTMLElement {
  connectedCallback() {
    (this.facetToolbar = document.getElementById("mobile-facet-toolbar")),
      (this.tabsNav = document.getElementById("search-tabs-nav")),
      this.tabsNav.addEventListener(
        "tabs-nav:changed",
        this._onCategoryChanged.bind(this)
      ),
      this._completeSearch();
  }
  get terms() {
    return this.getAttribute("terms");
  }
  get completeFor() {
    return this.getAttribute("complete-for").split(",");
  }
  async _completeSearch() {
    const e = [];
    this.completeFor.forEach((t) => {
      e.push(
        fetch(
          `${
            window.themeVariables.routes.searchUrl
          }?section_id=${this.getAttribute("section-id")}&q=${
            this.terms
          }&type=${t}&options[prefix]=last&options[unavailable_products]=${
            window.themeVariables.settings.searchUnavailableProducts
          }`
        )
      );
    });
    const t = await Promise.all(e);
    await Promise.all(
      t.map(async (e) => {
        const t = document.createElement("div");
        t.innerHTML = await e.text();
        const i = t.querySelector(".main-search__category-result"),
          n = t.querySelector("#search-tabs-nav .tabs-nav__item");
        i &&
          (i.setAttribute("hidden", ""),
          this.insertAdjacentElement("beforeend", i),
          this.tabsNav.addButton(n));
      })
    );
  }
  _onCategoryChanged(e) {
    const t = e.detail.button;
    this.facetToolbar.classList.toggle(
      "is-collapsed",
      "product" !== t.getAttribute("data-type")
    );
  }
};
window.customElements.define("search-page", SearchPage);
var CookieBar = class extends CustomHTMLElement {
  connectedCallback() {
    window.Shopify &&
      window.Shopify.designMode &&
      (this.rootDelegate.on("shopify:section:select", (e) =>
        filterShopifyEvent(e, this, () => (this.open = !0))
      ),
      this.rootDelegate.on("shopify:section:deselect", (e) =>
        filterShopifyEvent(e, this, () => (this.open = !1))
      )),
      this.delegate.on(
        "click",
        '[data-action~="accept-policy"]',
        this._acceptPolicy.bind(this)
      ),
      this.delegate.on(
        "click",
        '[data-action~="decline-policy"]',
        this._declinePolicy.bind(this)
      ),
      window.Shopify.loadFeatures([
        {
          name: "consent-tracking-api",
          version: "0.1",
          onLoad: this._onCookieBarSetup.bind(this),
        },
      ]);
  }
  set open(e) {
    this.toggleAttribute("hidden", !e);
  }
  _onCookieBarSetup() {
    window.Shopify.customerPrivacy.shouldShowGDPRBanner() && (this.open = !0);
  }
  _acceptPolicy() {
    window.Shopify.customerPrivacy.setTrackingConsent(
      !0,
      () => (this.open = !1)
    );
  }
  _declinePolicy() {
    window.Shopify.customerPrivacy.setTrackingConsent(
      !1,
      () => (this.open = !1)
    );
  }
};
window.customElements.define("cookie-bar", CookieBar);
var ProductRecommendations = class extends HTMLElement {
  async connectedCallback() {
    const e = await fetch(
        `${window.themeVariables.routes.productRecommendationsUrl}?product_id=${this.productId}&limit=${this.recommendationsCount}&section_id=${this.sectionId}&intent=${this.intent}`
      ),
      t = document.createElement("div");
    t.innerHTML = await e.text();
    const i = t.querySelector("product-recommendations");
    i.hasChildNodes()
      ? (this.innerHTML = i.innerHTML)
      : "complementary" === this.intent && this.remove();
  }
  get productId() {
    return this.getAttribute("product-id");
  }
  get sectionId() {
    return this.getAttribute("section-id");
  }
  get recommendationsCount() {
    return parseInt(this.getAttribute("recommendations-count") || 4);
  }
  get intent() {
    return this.getAttribute("intent");
  }
};
window.customElements.define("product-recommendations", ProductRecommendations);
var RecentlyViewedProducts = class extends HTMLElement {
  async connectedCallback() {
    if ("" === this.searchQueryString) return;
    const e = await fetch(
        `${window.themeVariables.routes.searchUrl}?type=product&q=${this.searchQueryString}&section_id=${this.sectionId}`
      ),
      t = document.createElement("div");
    t.innerHTML = await e.text();
    const i = t.querySelector("recently-viewed-products");
    i.hasChildNodes() && (this.innerHTML = i.innerHTML);
  }
  get searchQueryString() {
    const e = JSON.parse(
      localStorage.getItem("theme:recently-viewed-products") || "[]"
    );
    return (
      this.hasAttribute("exclude-product-id") &&
        e.includes(parseInt(this.getAttribute("exclude-product-id"))) &&
        e.splice(
          e.indexOf(parseInt(this.getAttribute("exclude-product-id"))),
          1
        ),
      e
        .map((e) => "id:" + e)
        .slice(0, this.productsCount)
        .join(" OR ")
    );
  }
  get sectionId() {
    return this.getAttribute("section-id");
  }
  get productsCount() {
    return this.getAttribute("products-count") || 4;
  }
};

function getSizedMediaUrl(e, t) {
  let i =
    "string" == typeof e ? e : e.preview_image ? e.preview_image.src : e.url;
  if (null === t) return i;
  if ("master" === t) return i.replace(/http(s)?:/, "");
  const n = i.match(
    /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?$/i
  );
  if (n) {
    const e = i.split(n[0]),
      s = n[0];
    return (e[0] + "_" + t + s).replace(/http(s)?:/, "");
  }
  return null;
}

function getMediaSrcset(e, t) {
  let i = [];
  return (
    ("string" == typeof e ? t : getSupportedSizes(e, t)).forEach((t) => {
      i.push(`${getSizedMediaUrl(e, t + "x")} ${t}w`);
    }),
    i.join(",")
  );
}

function getSupportedSizes(e, t) {
  let i = [],
    n = e.preview_image.width;
  return (
    t.forEach((e) => {
      n >= e && i.push(e);
    }),
    i
  );
}

function imageLoaded(e) {
  return new Promise((t) => {
    !e || "IMG" !== e.tagName || e.complete ? t() : (e.onload = () => t());
  });
}
window.customElements.define(
  "recently-viewed-products",
  RecentlyViewedProducts
);
var CustomAnimation = class {
    constructor(e) {
      (this._effect = e),
        (this._playState = "idle"),
        (this._finished = Promise.resolve());
    }
    get finished() {
      return this._finished;
    }
    get animationEffects() {
      return this._effect instanceof CustomKeyframeEffect
        ? [this._effect]
        : this._effect.animationEffects;
    }
    cancel() {
      this.animationEffects.forEach((e) => e.cancel());
    }
    finish() {
      this.animationEffects.forEach((e) => e.finish());
    }
    play() {
      (this._playState = "running"),
        this._effect.play(),
        (this._finished = this._effect.finished),
        this._finished.then(
          () => {
            this._playState = "finished";
          },
          (e) => {
            this._playState = "idle";
          }
        );
    }
  },
  CustomKeyframeEffect = class {
    constructor(e, t, i = {}) {
      e &&
        ("Animation" in window
          ? (this._animation = new Animation(new KeyframeEffect(e, t, i)))
          : ((i.fill = "forwards"),
            (this._animation = e.animate(t, i)),
            this._animation.pause()),
        this._animation.addEventListener("finish", () => {
          (e.style.opacity = t.hasOwnProperty("opacity")
            ? t.opacity[t.opacity.length - 1]
            : null),
            (e.style.visibility = t.hasOwnProperty("visibility")
              ? t.visibility[t.visibility.length - 1]
              : null);
        }));
    }
    get finished() {
      return this._animation
        ? this._animation.finished
          ? this._animation.finished
          : new Promise((e) => (this._animation.onfinish = e))
        : Promise.resolve();
    }
    play() {
      this._animation &&
        ((this._animation.startTime = null), this._animation.play());
    }
    cancel() {
      this._animation && this._animation.cancel();
    }
    finish() {
      this._animation && this._animation.finish();
    }
  },
  GroupEffect = class {
    constructor(e) {
      (this._childrenEffects = e), (this._finished = Promise.resolve());
    }
    get finished() {
      return this._finished;
    }
    get animationEffects() {
      return this._childrenEffects.flatMap((e) =>
        e instanceof CustomKeyframeEffect ? e : e.animationEffects
      );
    }
  },
  ParallelEffect = class extends GroupEffect {
    play() {
      const e = [];
      for (const t of this._childrenEffects) t.play(), e.push(t.finished);
      this._finished = Promise.all(e);
    }
  },
  SequenceEffect = class extends GroupEffect {
    play() {
      this._finished = new Promise(async (e, t) => {
        try {
          for (const e of this._childrenEffects) e.play(), await e.finished;
          e();
        } catch (e) {
          t();
        }
      });
    }
  },
  SlideshowItem = class extends HTMLElement {
    async connectedCallback() {
      (this._pendingAnimations = []),
        this.addEventListener("split-lines:re-split", (e) => {
          Array.from(e.target.children).forEach(
            (e) => (e.style.visibility = this.selected ? "visible" : "hidden")
          );
        }),
        MediaFeatures.prefersReducedMotion() &&
          (this.setAttribute("reveal-visibility", ""),
          Array.from(
            this.querySelectorAll("[reveal], [reveal-visibility]")
          ).forEach((e) => {
            e.removeAttribute("reveal"), e.removeAttribute("reveal-visibility");
          }));
    }
    get index() {
      return [...this.parentNode.children].indexOf(this);
    }
    get selected() {
      return !this.hasAttribute("hidden");
    }
    async transitionToLeave(e, t = !0) {
      "reveal" !== e && this.setAttribute("hidden", ""),
        this._pendingAnimations.forEach((e) => e.cancel()),
        (this._pendingAnimations = []);
      let i = null,
        n = await resolveAsyncIterator(
          this.querySelectorAll("split-lines, .button-group, .button-wrapper")
        ),
        s = Array.from(this.querySelectorAll(".slideshow__image-wrapper"));
      switch (e) {
        case "sweep":
          i = new CustomAnimation(
            new SequenceEffect([
              new CustomKeyframeEffect(
                this,
                {
                  visibility: ["visible", "hidden"],
                },
                {
                  duration: 500,
                }
              ),
              new ParallelEffect(
                n.map(
                  (e) =>
                    new CustomKeyframeEffect(e, {
                      opacity: [1, 0],
                      visibility: ["visible", "hidden"],
                    })
                )
              ),
            ])
          );
          break;
        case "fade":
          i = new CustomAnimation(
            new CustomKeyframeEffect(
              this,
              {
                opacity: [1, 0],
                visibility: ["visible", "hidden"],
              },
              {
                duration: 250,
                easing: "ease-in-out",
              }
            )
          );
          break;
        case "reveal":
          i = new CustomAnimation(
            new SequenceEffect([
              new ParallelEffect(
                n.reverse().map(
                  (e) =>
                    new CustomKeyframeEffect(
                      e,
                      {
                        opacity: [1, 0],
                        visibility: ["visible", "hidden"],
                      },
                      {
                        duration: 250,
                        easing: "ease-in-out",
                      }
                    )
                )
              ),
              new ParallelEffect(
                s.map((e) =>
                  e.classList.contains("slideshow__image-wrapper--secondary")
                    ? new CustomKeyframeEffect(
                        e,
                        {
                          visibility: ["visible", "hidden"],
                          clipPath: ["inset(0 0 0 0)", "inset(100% 0 0 0)"],
                        },
                        {
                          duration: 450,
                          easing: "cubic-bezier(0.99, 0.01, 0.50, 0.94)",
                        }
                      )
                    : new CustomKeyframeEffect(
                        e,
                        {
                          visibility: ["visible", "hidden"],
                          clipPath: ["inset(0 0 0 0)", "inset(0 0 100% 0)"],
                        },
                        {
                          duration: 450,
                          easing: "cubic-bezier(0.99, 0.01, 0.50, 0.94)",
                        }
                      )
                )
              ),
            ])
          );
      }
      await this._executeAnimation(i, t),
        "reveal" === e && this.setAttribute("hidden", "");
    }
    async transitionToEnter(e, t = !0, i = !1) {
      this.removeAttribute("hidden"), await this._untilReady();
      let n = null,
        s = await resolveAsyncIterator(
          this.querySelectorAll("split-lines, .button-group, .button-wrapper")
        ),
        a = Array.from(this.querySelectorAll(".slideshow__image-wrapper"));
      switch (e) {
        case "sweep":
          n = new CustomAnimation(
            new SequenceEffect([
              new CustomKeyframeEffect(
                this,
                {
                  visibility: ["hidden", "visible"],
                  clipPath: i
                    ? ["inset(0 100% 0 0)", "inset(0 0 0 0)"]
                    : ["inset(0 0 0 100%)", "inset(0 0 0 0)"],
                },
                {
                  duration: 500,
                  easing: "cubic-bezier(1, 0, 0, 1)",
                }
              ),
              new ParallelEffect(
                s.map(
                  (e, t) =>
                    new CustomKeyframeEffect(
                      e,
                      {
                        opacity: [0, 1],
                        visibility: ["hidden", "visible"],
                        clipPath: ["inset(0 0 100% 0)", "inset(0 0 0 0)"],
                        transform: ["translateY(100%)", "translateY(0)"],
                      },
                      {
                        duration: 450,
                        delay: 100 * t,
                        easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)",
                      }
                    )
                )
              ),
            ])
          );
          break;
        case "fade":
          n = new CustomAnimation(
            new CustomKeyframeEffect(
              this,
              {
                opacity: [0, 1],
                visibility: ["hidden", "visible"],
              },
              {
                duration: 250,
                easing: "ease-in-out",
              }
            )
          );
          break;
        case "reveal":
          n = new CustomAnimation(
            new SequenceEffect([
              new ParallelEffect(
                a.map((e) =>
                  e.classList.contains("slideshow__image-wrapper--secondary")
                    ? new CustomKeyframeEffect(
                        e,
                        {
                          visibility: ["hidden", "visible"],
                          clipPath: ["inset(100% 0 0 0)", "inset(0 0 0 0)"],
                        },
                        {
                          duration: 450,
                          delay: 100,
                          easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)",
                        }
                      )
                    : new CustomKeyframeEffect(
                        e,
                        {
                          visibility: ["hidden", "visible"],
                          clipPath: ["inset(0 0 100% 0)", "inset(0 0 0 0)"],
                        },
                        {
                          duration: 450,
                          delay: 100,
                          easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)",
                        }
                      )
                )
              ),
              new ParallelEffect(
                s.map(
                  (e, t) =>
                    new CustomKeyframeEffect(
                      e,
                      {
                        opacity: [0, 1],
                        visibility: ["hidden", "visible"],
                        clipPath: ["inset(0 0 100% 0)", "inset(0 0 0 0)"],
                        transform: ["translateY(100%)", "translateY(0)"],
                      },
                      {
                        duration: 450,
                        delay: 100 * t,
                        easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)",
                      }
                    )
                )
              ),
            ])
          );
      }
      return this._executeAnimation(n, t);
    }
    async _executeAnimation(e, t) {
      return (
        this._pendingAnimations.push(e), t ? e.play() : e.finish(), e.finished
      );
    }
    async _untilReady() {
      return Promise.all(this._getVisibleImages().map((e) => imageLoaded(e)));
    }
    _preloadImages() {
      this._getVisibleImages().forEach((e) => {
        e.setAttribute("loading", "eager");
      });
    }
    _getVisibleImages() {
      return Array.from(this.querySelectorAll("img")).filter(
        (e) => "none" !== getComputedStyle(e.parentElement).display
      );
    }
  };
window.customElements.define("slide-show-item", SlideshowItem);
var VerticalScrollBlockerMixin = {
    _blockVerticalScroll(e = 18) {
      this.addEventListener("touchstart", (e) => {
        this.firstTouchClientX = e.touches[0].clientX;
      }),
        this.addEventListener(
          "touchmove",
          (t) => {
            const i = t.touches[0].clientX - this.firstTouchClientX;
            Math.abs(i) > e && t.preventDefault();
          },
          {
            passive: !1,
          }
        );
    },
  },
  Slideshow = class extends CustomHTMLElement {
    connectedCallback() {
      (this.items = Array.from(this.querySelectorAll("slide-show-item"))),
        (this.pageDots = this.querySelector("page-dots")),
        (this.isTransitioning = !1),
        this.items.length > 1 &&
          (Shopify.designMode &&
            (this.addEventListener(
              "shopify:block:deselect",
              this.startPlayer.bind(this)
            ),
            this.addEventListener("shopify:block:select", (e) => {
              this.pausePlayer(),
                this.intersectionObserver.disconnect(),
                (!e.detail.load && e.target.selected) ||
                  this.select(e.target.index, !e.detail.load);
            })),
          this.addEventListener("swiperight", this.previous.bind(this)),
          this.addEventListener("swipeleft", this.next.bind(this)),
          this.addEventListener("page-dots:changed", (e) =>
            this.select(e.detail.index)
          ),
          this._blockVerticalScroll()),
        this._setupVisibility();
    }
    get selectedIndex() {
      return this.items.findIndex((e) => e.selected);
    }
    get transitionType() {
      return MediaFeatures.prefersReducedMotion()
        ? "fade"
        : this.getAttribute("transition-type");
    }
    async _setupVisibility() {
      await this.untilVisible(),
        await this.items[this.selectedIndex]
          .transitionToEnter(this.transitionType)
          .catch((e) => {}),
        this.startPlayer();
    }
    previous() {
      this.select(
        (this.selectedIndex - 1 + this.items.length) % this.items.length,
        !0,
        !0
      );
    }
    next() {
      this.select(
        (this.selectedIndex + 1 + this.items.length) % this.items.length,
        !0,
        !1
      );
    }
    async select(e, t = !0, i = !1) {
      if ("reveal" === this.transitionType && this.isTransitioning) return;
      this.isTransitioning = !0;
      const n = this.items[this.selectedIndex],
        s = this.items[e];
      this.items[(s.index + 1) % this.items.length]._preloadImages(),
        n &&
          n !== s &&
          ("reveal" !== this.transitionType
            ? n.transitionToLeave(this.transitionType, t)
            : await n.transitionToLeave(this.transitionType, t)),
        this.pageDots && (this.pageDots.selectedIndex = s.index),
        await s.transitionToEnter(this.transitionType, t, i).catch((e) => {}),
        (this.isTransitioning = !1);
    }
    pausePlayer() {
      this.style.setProperty("--section-animation-play-state", "paused");
    }
    startPlayer() {
      this.hasAttribute("auto-play") &&
        this.style.setProperty("--section-animation-play-state", "running");
    }
  };
Object.assign(Slideshow.prototype, VerticalScrollBlockerMixin),
  window.customElements.define("slide-show", Slideshow);
var ImageWithTextItem = class extends HTMLElement {
  get index() {
    return [...this.parentNode.children].indexOf(this);
  }
  get selected() {
    return !this.hasAttribute("hidden");
  }
  get hasAttachedImage() {
    return this.hasAttribute("attached-image");
  }
  async transitionToEnter(e = !0) {
    this.removeAttribute("hidden");
    const t = this.querySelector(".image-with-text__text-wrapper"),
      i = await resolveAsyncIterator(
        this.querySelectorAll(".image-with-text__content split-lines")
      ),
      n = new CustomAnimation(
        new SequenceEffect([
          new ParallelEffect(
            i.map(
              (e, t) =>
                new CustomKeyframeEffect(
                  e,
                  {
                    opacity: [0, 0.2, 1],
                    transform: ["translateY(100%)", "translateY(0)"],
                    clipPath: ["inset(0 0 100% 0)", "inset(0 0 0 0)"],
                  },
                  {
                    duration: 350,
                    delay: 120 * t,
                    easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)",
                  }
                )
            )
          ),
          new CustomKeyframeEffect(
            t,
            {
              opacity: [0, 1],
            },
            {
              duration: 300,
            }
          ),
        ])
      );
    return e ? n.play() : n.finish(), n.finished;
  }
  async transitionToLeave(e = !0) {
    const t = await resolveAsyncIterator(
        this.querySelectorAll(
          ".image-with-text__text-wrapper, .image-with-text__content split-lines"
        )
      ),
      i = new CustomAnimation(
        new ParallelEffect(
          t.map(
            (e) =>
              new CustomKeyframeEffect(
                e,
                {
                  opacity: [1, 0],
                },
                {
                  duration: 200,
                }
              )
          )
        )
      );
    e ? i.play() : i.finish(),
      await i.finished,
      this.setAttribute("hidden", "");
  }
};
window.customElements.define("image-with-text-item", ImageWithTextItem);
var ImageWithText = class extends CustomHTMLElement {
  connectedCallback() {
    (this.items = Array.from(this.querySelectorAll("image-with-text-item"))),
      (this.imageItems = Array.from(
        this.querySelectorAll(".image-with-text__image")
      )),
      (this.pageDots = this.querySelector("page-dots")),
      (this.hasPendingTransition = !1),
      this.items.length > 1 &&
        (this.addEventListener("page-dots:changed", (e) =>
          this.select(e.detail.index)
        ),
        Shopify.designMode &&
          (this.addEventListener(
            "shopify:block:deselect",
            this.startPlayer.bind(this)
          ),
          this.addEventListener("shopify:block:select", (e) => {
            this.intersectionObserver.disconnect(),
              this.pausePlayer(),
              this.select(e.target.index, !e.detail.load);
          }))),
      this._setupVisibility();
  }
  async _setupVisibility() {
    await this.untilVisible(),
      this.hasAttribute("reveal-on-scroll") &&
        (await this.transitionImage(this.selectedIndex),
        this.select(this.selectedIndex)),
      this.startPlayer();
  }
  get selectedIndex() {
    return this.items.findIndex((e) => e.selected);
  }
  async select(e, t = !0) {
    this.hasPendingTransition ||
      ((this.hasPendingTransition = !0),
      (!this.items[e].hasAttachedImage && t) ||
        (await this.transitionImage(e, t)),
      this.selectedIndex !== e &&
        (await this.items[this.selectedIndex].transitionToLeave(t)),
      this.pageDots && (this.pageDots.selectedIndex = e),
      await this.items[e].transitionToEnter(t),
      (this.hasPendingTransition = !1));
  }
  async transitionImage(e, t = !0) {
    const i = this.imageItems.find((e) => !e.hasAttribute("hidden")),
      n =
        this.imageItems.find(
          (t) => t.id === this.items[e].getAttribute("attached-image")
        ) || i;
    i.setAttribute("hidden", ""),
      n.removeAttribute("hidden"),
      await imageLoaded(n);
    const s = new CustomAnimation(
      new CustomKeyframeEffect(
        n,
        {
          visibility: ["hidden", "visible"],
          clipPath: ["inset(0 0 0 100%)", "inset(0 0 0 0)"],
        },
        {
          duration: 600,
          easing: "cubic-bezier(1, 0, 0, 1)",
        }
      )
    );
    t ? s.play() : s.finish();
  }
  pausePlayer() {
    this.style.setProperty("--section-animation-play-state", "paused");
  }
  startPlayer() {
    this.style.setProperty("--section-animation-play-state", "running");
  }
};
window.customElements.define("image-with-text", ImageWithText);
var TestimonialItem = class extends CustomHTMLElement {
  connectedCallback() {
    this.addEventListener("split-lines:re-split", (e) => {
      Array.from(e.target.children).forEach(
        (e) => (e.style.visibility = this.selected ? "visible" : "hidden")
      );
    });
  }
  get index() {
    return [...this.parentNode.children].indexOf(this);
  }
  get selected() {
    return !this.hasAttribute("hidden");
  }
  async transitionToLeave(e = !0) {
    const t = await resolveAsyncIterator(
        this.querySelectorAll("split-lines, .testimonial__author")
      ),
      i = new CustomAnimation(
        new ParallelEffect(
          t.reverse().map(
            (e, t) =>
              new CustomKeyframeEffect(
                e,
                {
                  visibility: ["visible", "hidden"],
                  clipPath: ["inset(0 0 0 0)", "inset(0 0 100% 0)"],
                  transform: ["translateY(0)", "translateY(100%)"],
                },
                {
                  duration: 350,
                  delay: 60 * t,
                  easing: "cubic-bezier(0.68, 0.00, 0.77, 0.00)",
                }
              )
          )
        )
      );
    e ? i.play() : i.finish(),
      await i.finished,
      this.setAttribute("hidden", "");
  }
  async transitionToEnter(e = !0) {
    const t = await resolveAsyncIterator(
        this.querySelectorAll("split-lines, .testimonial__author")
      ),
      i = new CustomAnimation(
        new ParallelEffect(
          t.map(
            (e, t) =>
              new CustomKeyframeEffect(
                e,
                {
                  visibility: ["hidden", "visible"],
                  clipPath: ["inset(0 0 100% 0)", "inset(0 0 0px 0)"],
                  transform: ["translateY(100%)", "translateY(0)"],
                },
                {
                  duration: 550,
                  delay: 120 * t,
                  easing: "cubic-bezier(0.23, 1, 0.32, 1)",
                }
              )
          )
        )
      );
    return (
      this.removeAttribute("hidden"), e ? i.play() : i.finish(), i.finished
    );
  }
};
window.customElements.define("testimonial-item", TestimonialItem);
var TestimonialList = class extends CustomHTMLElement {
  connectedCallback() {
    (this.items = Array.from(this.querySelectorAll("testimonial-item"))),
      (this.pageDots = this.querySelector("page-dots")),
      (this.hasPendingTransition = !1),
      this.items.length > 1 &&
        (this.addEventListener("swiperight", this.previous.bind(this)),
        this.addEventListener("swipeleft", this.next.bind(this)),
        this.addEventListener("prev-next:prev", this.previous.bind(this)),
        this.addEventListener("prev-next:next", this.next.bind(this)),
        this.addEventListener("page-dots:changed", (e) =>
          this.select(e.detail.index)
        ),
        Shopify.designMode &&
          this.addEventListener("shopify:block:select", (e) => {
            this.intersectionObserver?.disconnect(),
              (!e.detail.load && e.target.selected) ||
                this.select(e.target.index, !e.detail.load);
          }),
        this._blockVerticalScroll()),
      this.hasAttribute("reveal-on-scroll") && this._setupVisibility();
  }
  get selectedIndex() {
    return this.items.findIndex((e) => e.selected);
  }
  async _setupVisibility() {
    await this.untilVisible(),
      this.items[this.selectedIndex].transitionToEnter();
  }
  previous() {
    this.select(
      (this.selectedIndex - 1 + this.items.length) % this.items.length
    );
  }
  next() {
    this.select(
      (this.selectedIndex + 1 + this.items.length) % this.items.length
    );
  }
  async select(e, t = !0) {
    this.hasPendingTransition ||
      ((this.hasPendingTransition = !0),
      await this.items[this.selectedIndex].transitionToLeave(t),
      this.pageDots && (this.pageDots.selectedIndex = e),
      await this.items[e].transitionToEnter(t),
      (this.hasPendingTransition = !1));
  }
};
Object.assign(TestimonialList.prototype, VerticalScrollBlockerMixin),
  window.customElements.define("testimonial-list", TestimonialList);
var ShopTheLookItem = class extends HTMLElement {
  get index() {
    return [...this.parentNode.children].indexOf(this);
  }
  get selected() {
    return !this.hasAttribute("hidden");
  }
  async transitionToLeave(e = !0) {
    this.setAttribute("hidden", "");
    const t = new CustomAnimation(
      new CustomKeyframeEffect(
        this,
        {
          visibility: ["visible", "hidden"],
        },
        {
          duration: 500,
        }
      )
    );
    return e ? t.play() : t.finish(), t.finished;
  }
  async transitionToEnter(e = !0) {
    this.removeAttribute("hidden");
    const t = Array.from(this.querySelectorAll(".shop-the-look__dot"));
    t.forEach((e) => (e.style.opacity = 0));
    const i = new CustomAnimation(
      new SequenceEffect([
        new ParallelEffect(
          Array.from(this.querySelectorAll(".shop-the-look__image")).map(
            (e) =>
              new CustomKeyframeEffect(
                e,
                {
                  opacity: [1, 1],
                },
                {
                  duration: 0,
                }
              )
          )
        ),
        new CustomKeyframeEffect(
          this,
          {
            visibility: ["hidden", "visible"],
            zIndex: [0, 1],
            clipPath: ["inset(0 0 0 100%)", "inset(0 0 0 0)"],
          },
          {
            duration: 500,
            easing: "cubic-bezier(1, 0, 0, 1)",
          }
        ),
        new ParallelEffect(
          t.map(
            (e, t) =>
              new CustomKeyframeEffect(
                e,
                {
                  opacity: [0, 1],
                  transform: ["scale(0)", "scale(1)"],
                },
                {
                  duration: 120,
                  delay: 75 * t,
                  easing: "ease-in-out",
                }
              )
          )
        ),
      ])
    );
    if (
      (e ? i.play() : i.finish(),
      await i.finished,
      window.matchMedia(window.themeVariables.breakpoints.tabletAndUp).matches)
    ) {
      const e = this.querySelector(
        ".shop-the-look__product-wrapper .shop-the-look__dot"
      );
      e?.setAttribute("aria-expanded", "true");
    }
  }
};
window.customElements.define("shop-the-look-item", ShopTheLookItem);
var ShopTheLookNav = class extends CustomHTMLElement {
  connectedCallback() {
    (this.shopTheLook = this.closest("shop-the-look")),
      (this.inTransition = !1),
      (this.pendingTransition = !1),
      (this.pendingTransitionTo = null),
      this.delegate.on("click", '[data-action="prev"]', () =>
        this.shopTheLook.previous()
      ),
      this.delegate.on("click", '[data-action="next"]', () =>
        this.shopTheLook.next()
      );
  }
  transitionToIndex(e, t, i = !0) {
    const n = Array.from(
        this.querySelectorAll(".shop-the-look__counter-page-transition")
      ),
      s = n[e],
      a = n[t];
    if (this.inTransition)
      return (this.pendingTransition = !0), void (this.pendingTransitionTo = t);
    (this.inTransition = !0),
      (s.animate(
        {
          transform: ["translateY(0)", "translateY(-100%)"],
        },
        {
          duration: i ? 1e3 : 0,
          easing: "cubic-bezier(1, 0, 0, 1)",
        }
      ).onfinish = () => {
        s.setAttribute("hidden", ""),
          (this.inTransition = !1),
          this.pendingTransition &&
            this.pendingTransitionTo !== t &&
            ((this.pendingTransition = !1),
            this.transitionToIndex(t, this.pendingTransitionTo, i),
            (this.pendingTransitionTo = null));
      }),
      a.removeAttribute("hidden"),
      a.animate(
        {
          transform: ["translateY(100%)", "translateY(0)"],
        },
        {
          duration: i ? 1e3 : 0,
          easing: "cubic-bezier(1, 0, 0, 1)",
        }
      );
  }
};
window.customElements.define("shop-the-look-nav", ShopTheLookNav);
var ShopTheLook = class extends CustomHTMLElement {
  connectedCallback() {
    (this.lookItems = Array.from(this.querySelectorAll("shop-the-look-item"))),
      (this.nav = this.querySelector("shop-the-look-nav")),
      (this.hasPendingTransition = !1),
      this.hasAttribute("reveal-on-scroll") && this._setupVisibility(),
      this.lookItems.length > 1 &&
        Shopify.designMode &&
        this.addEventListener("shopify:block:select", async (e) => {
          this.intersectionObserver.disconnect(),
            await this.select(e.target.index, !e.detail.load),
            this.nav.animate(
              {
                opacity: [0, 1],
                transform: ["translateY(30px)", "translateY(0)"],
              },
              {
                duration: 0,
                fill: "forwards",
                easing: "ease-in-out",
              }
            );
        });
  }
  get selectedIndex() {
    return this.lookItems.findIndex((e) => e.selected);
  }
  async _setupVisibility() {
    await this.untilVisible();
    const e = Array.from(
      this.lookItems[this.selectedIndex].querySelectorAll(
        ".shop-the-look__image"
      )
    );
    for (let t of e) null !== t.offsetParent && (await imageLoaded(t));
    await this.lookItems[this.selectedIndex].transitionToEnter(),
      this.nav &&
        this.nav.animate(
          {
            opacity: [0, 1],
            transform: ["translateY(30px)", "translateY(0)"],
          },
          {
            duration: 150,
            fill: "forwards",
            easing: "ease-in-out",
          }
        );
  }
  previous() {
    this.select(
      (this.selectedIndex - 1 + this.lookItems.length) % this.lookItems.length
    );
  }
  next() {
    this.select(
      (this.selectedIndex + 1 + this.lookItems.length) % this.lookItems.length
    );
  }
  async select(e, t = !0) {
    const i = this.lookItems[this.selectedIndex],
      n = this.lookItems[e];
    this.hasPendingTransition ||
      ((this.hasPendingTransition = !0),
      i !== n &&
        (this.nav.transitionToIndex(this.selectedIndex, e, t),
        i.transitionToLeave()),
      n.transitionToEnter(t),
      (this.hasPendingTransition = !1));
  }
};
window.customElements.define("shop-the-look", ShopTheLook);
var CollectionList = class extends CustomHTMLElement {
  async connectedCallback() {
    (this.items = Array.from(this.querySelectorAll(".list-collections__item"))),
      this.hasAttribute("scrollable") &&
        ((this.scroller = this.querySelector(".list-collections__scroller")),
        this.addEventListener("prev-next:prev", this.previous.bind(this)),
        this.addEventListener("prev-next:next", this.next.bind(this)),
        this.addEventListener("shopify:block:select", (e) =>
          e.target.scrollIntoView({
            block: "nearest",
            inline: "center",
            behavior: e.detail.load ? "auto" : "smooth",
          })
        )),
      this.hasAttribute("reveal-on-scroll") && this._setupVisibility();
  }
  async _setupVisibility() {
    await this.untilVisible();
    const e = MediaFeatures.prefersReducedMotion(),
      t = new CustomAnimation(
        new ParallelEffect(
          this.items.map(
            (t, i) =>
              new SequenceEffect([
                new CustomKeyframeEffect(
                  t.querySelector(".list-collections__item-image"),
                  {
                    opacity: [0, 1],
                    transform: [`scale(${e ? 1 : 1.1})`, "scale(1)"],
                  },
                  {
                    duration: 250,
                    delay: e ? 0 : 150 * i,
                    easing: "cubic-bezier(0.65, 0, 0.35, 1)",
                  }
                ),
                new ParallelEffect(
                  Array.from(
                    t.querySelectorAll(".list-collections__item-info [reveal]")
                  ).map(
                    (t, n) =>
                      new CustomKeyframeEffect(
                        t,
                        {
                          opacity: [0, 1],
                          clipPath: [
                            `inset(${e ? "0 0 0 0" : "0 0 100% 0"})`,
                            "inset(0 0 0 0)",
                          ],
                          transform: [
                            `translateY(${e ? 0 : "100%"})`,
                            "translateY(0)",
                          ],
                        },
                        {
                          duration: 200,
                          delay: e ? 0 : 150 * i + 150 * n,
                          easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)",
                        }
                      )
                  )
                ),
              ])
          )
        )
      );
    this._hasSectionReloaded ? t.finish() : t.play();
  }
  previous() {
    const e = "ltr" === window.themeVariables.settings.direction ? 1 : -1;
    this.scroller.scrollBy({
      left: -this.items[0].clientWidth * e,
      behavior: "smooth",
    });
  }
  next() {
    const e = "ltr" === window.themeVariables.settings.direction ? 1 : -1;
    this.scroller.scrollBy({
      left: this.items[0].clientWidth * e,
      behavior: "smooth",
    });
  }
};
window.customElements.define("collection-list", CollectionList);
var ProductList = class extends CustomHTMLElement {
  constructor() {
    super(),
      (this.productListInner = this.querySelector(".product-list__inner")),
      (this.productItems = Array.from(this.querySelectorAll("product-item")));
  }
  connectedCallback() {
    this.addEventListener("prev-next:prev", this.previous.bind(this)),
      this.addEventListener("prev-next:next", this.next.bind(this)),
      !this.hidden &&
        this.staggerApparition &&
        this._staggerProductsApparition();
  }
  get staggerApparition() {
    return this.hasAttribute("stagger-apparition");
  }
  get apparitionAnimation() {
    return (this._animation =
      this._animation ||
      new CustomAnimation(
        new ParallelEffect(
          this.productItems.map(
            (e, t) =>
              new CustomKeyframeEffect(
                e,
                {
                  opacity: [0, 1],
                  transform: [
                    `translateY(${
                      MediaFeatures.prefersReducedMotion()
                        ? 0
                        : window.innerWidth < 1e3
                        ? 35
                        : 60
                    }px)`,
                    "translateY(0)",
                  ],
                },
                {
                  duration: 600,
                  delay: MediaFeatures.prefersReducedMotion()
                    ? 0
                    : 100 * t - Math.min(3 * t * t, 100 * t),
                  easing: "ease",
                }
              )
          )
        )
      ));
  }
  previous(e) {
    const t = "ltr" === window.themeVariables.settings.direction ? 1 : -1,
      i = parseInt(
        getComputedStyle(this).getPropertyValue("--product-list-column-gap")
      );
    e.target.nextElementSibling.removeAttribute("disabled"),
      e.target.toggleAttribute(
        "disabled",
        this.productListInner.scrollLeft * t -
          (this.productListInner.clientWidth + i) <=
          0
      ),
      this.productListInner.scrollBy({
        left: -(this.productListInner.clientWidth + i) * t,
        behavior: "smooth",
      });
  }
  next(e) {
    const t = "ltr" === window.themeVariables.settings.direction ? 1 : -1,
      i = parseInt(
        getComputedStyle(this).getPropertyValue("--product-list-column-gap")
      );
    e.target.previousElementSibling.removeAttribute("disabled"),
      e.target.toggleAttribute(
        "disabled",
        this.productListInner.scrollLeft * t +
          2 * (this.productListInner.clientWidth + i) >=
          this.productListInner.scrollWidth
      ),
      this.productListInner.scrollBy({
        left: (this.productListInner.clientWidth + i) * t,
        behavior: "smooth",
      });
  }
  attributeChangedCallback(e) {
    this.staggerApparition &&
      "hidden" === e &&
      (this.hidden
        ? this.apparitionAnimation.finish()
        : ((this.productListInner.scrollLeft = 0),
          (this.productListInner.parentElement.scrollLeft = 0),
          this.querySelector(".prev-next-button--prev")?.setAttribute(
            "disabled",
            ""
          ),
          this.querySelector(".prev-next-button--next")?.removeAttribute(
            "disabled"
          ),
          this._staggerProductsApparition()));
  }
  async _staggerProductsApparition() {
    this.productItems.forEach((e) => (e.style.opacity = 0)),
      await this.untilVisible({
        threshold:
          this.clientHeight > 0 ? Math.min(50 / this.clientHeight, 1) : 0,
      }),
      this.apparitionAnimation.play();
  }
};
__publicField(ProductList, "observedAttributes", ["hidden"]),
  window.customElements.define("product-list", ProductList);
var LogoList = class extends CustomHTMLElement {
  async connectedCallback() {
    (this.items = Array.from(this.querySelectorAll(".logo-list__item"))),
      (this.logoListScrollable = this.querySelector(".logo-list__list")),
      this.items.length > 1 &&
        (this.addEventListener("prev-next:prev", this.previous.bind(this)),
        this.addEventListener("prev-next:next", this.next.bind(this))),
      this.hasAttribute("reveal-on-scroll") && this._setupVisibility();
  }
  async _setupVisibility() {
    await this.untilVisible({
      rootMargin: "50px 0px",
      threshold: 0,
    });
    const e = new CustomAnimation(
      new ParallelEffect(
        this.items.map(
          (e, t) =>
            new CustomKeyframeEffect(
              e,
              {
                opacity: [0, 1],
                transform: [
                  `translateY(${
                    MediaFeatures.prefersReducedMotion() ? 0 : "30px"
                  })`,
                  "translateY(0)",
                ],
              },
              {
                duration: 300,
                delay: MediaFeatures.prefersReducedMotion() ? 0 : 100 * t,
                easing: "ease",
              }
            )
        )
      )
    );
    this._hasSectionReloaded ? e.finish() : e.play();
  }
  previous(e) {
    const t = "ltr" === window.themeVariables.settings.direction ? 1 : -1;
    e.target.nextElementSibling.removeAttribute("disabled"),
      e.target.toggleAttribute(
        "disabled",
        this.logoListScrollable.scrollLeft * t -
          (this.logoListScrollable.clientWidth + 24) <=
          0
      ),
      this.logoListScrollable.scrollBy({
        left: -(this.logoListScrollable.clientWidth + 24) * t,
        behavior: "smooth",
      });
  }
  next(e) {
    const t = "ltr" === window.themeVariables.settings.direction ? 1 : -1;
    e.target.previousElementSibling.removeAttribute("disabled"),
      e.target.toggleAttribute(
        "disabled",
        this.logoListScrollable.scrollLeft * t +
          2 * (this.logoListScrollable.clientWidth + 24) >=
          this.logoListScrollable.scrollWidth
      ),
      this.logoListScrollable.scrollBy({
        left: (this.logoListScrollable.clientWidth + 24) * t,
        behavior: "smooth",
      });
  }
};
window.customElements.define("logo-list", LogoList);
var BlogPostNavigation = class extends HTMLElement {
  connectedCallback() {
    window.addEventListener(
      "scroll",
      throttle(this._updateProgressBar.bind(this), 15)
    );
  }
  get hasNextArticle() {
    return this.hasAttribute("has-next-article");
  }
  _updateProgressBar() {
    const e = getStickyHeaderOffset(),
      t = window.matchMedia(window.themeVariables.breakpoints.pocket).matches
        ? 40
        : 80,
      i = this.getBoundingClientRect(),
      n = this.parentElement.getBoundingClientRect(),
      s = n.bottom - (i.bottom - t),
      a = Math.max(-1 * (s / (n.height + t) - 1), 0);
    this.classList.toggle(
      "is-visible",
      n.top < e && n.bottom > e + this.clientHeight - t
    ),
      this.hasNextArticle &&
        (a > 0.8
          ? this.classList.add("article__nav--show-next")
          : this.classList.remove("article__nav--show-next")),
      this.style.setProperty("--transform", `${a}`);
  }
};
window.customElements.define("blog-post-navigation", BlogPostNavigation);
var MultiColumn = class extends CustomHTMLElement {
  connectedCallback() {
    this.hasAttribute("stack") ||
      ((this.multiColumnInner = this.querySelector(".multi-column__inner")),
      this.addEventListener("prev-next:prev", this.previous.bind(this)),
      this.addEventListener("prev-next:next", this.next.bind(this)),
      Shopify.designMode &&
        this.addEventListener("shopify:block:select", (e) => {
          e.target.scrollIntoView({
            inline: "center",
            block: "nearest",
            behavior: e.detail.load ? "auto" : "smooth",
          });
        })),
      this.hasAttribute("stagger-apparition") && this._setupVisibility();
  }
  async _setupVisibility() {
    await this.untilVisible({
      threshold: Math.min(50 / this.clientHeight, 1),
    });
    const e = MediaFeatures.prefersReducedMotion(),
      t = new CustomAnimation(
        new ParallelEffect(
          Array.from(this.querySelectorAll(".multi-column__item")).map(
            (t, i) =>
              new CustomKeyframeEffect(
                t,
                {
                  opacity: [0, 1],
                  transform: [
                    `translateY(${
                      MediaFeatures.prefersReducedMotion()
                        ? 0
                        : window.innerWidth < 1e3
                        ? 35
                        : 60
                    }px)`,
                    "translateY(0)",
                  ],
                },
                {
                  duration: 600,
                  delay: e ? 0 : 100 * i,
                  easing: "ease",
                }
              )
          )
        )
      );
    this._hasSectionReloaded ? t.finish() : t.play();
  }
  previous(e) {
    const t = "ltr" === window.themeVariables.settings.direction ? 1 : -1,
      i = parseInt(
        getComputedStyle(this).getPropertyValue("--multi-column-column-gap")
      );
    e.target.nextElementSibling.removeAttribute("disabled"),
      e.target.toggleAttribute(
        "disabled",
        this.multiColumnInner.scrollLeft * t -
          (this.multiColumnInner.clientWidth + i) <=
          0
      ),
      this.multiColumnInner.scrollBy({
        left: -(this.multiColumnInner.clientWidth + i) * t,
        behavior: "smooth",
      });
  }
  next(e) {
    const t = "ltr" === window.themeVariables.settings.direction ? 1 : -1,
      i = parseInt(
        getComputedStyle(this).getPropertyValue("--multi-column-column-gap")
      );
    e.target.previousElementSibling.removeAttribute("disabled"),
      e.target.toggleAttribute(
        "disabled",
        this.multiColumnInner.scrollLeft * t +
          2 * (this.multiColumnInner.clientWidth + i) >=
          this.multiColumnInner.scrollWidth
      ),
      this.multiColumnInner.scrollBy({
        left: (this.multiColumnInner.clientWidth + i) * t,
        behavior: "smooth",
      });
  }
};
window.customElements.define("multi-column", MultiColumn);
var GalleryList = class extends HTMLElement {
  connectedCallback() {
    (this.listItems = Array.from(this.querySelectorAll("gallery-item"))),
      (this.scrollBarElement = this.querySelector(".gallery__progress-bar")),
      (this.listWrapperElement = this.querySelector(".gallery__list-wrapper")),
      this.listItems.length > 1 &&
        (this.addEventListener(
          "scrollable-content:progress",
          this._updateProgressBar.bind(this)
        ),
        this.addEventListener("prev-next:prev", this.previous.bind(this)),
        this.addEventListener("prev-next:next", this.next.bind(this)),
        Shopify.designMode &&
          this.addEventListener("shopify:block:select", (e) =>
            this.select(e.target.index, !e.detail.load)
          ));
  }
  previous() {
    this.select(
      [...this.listItems].reverse().find((e) => e.isOnLeftHalfPartOfScreen)
        .index
    );
  }
  next() {
    this.select(this.listItems.findIndex((e) => e.isOnRightHalfPartOfScreen));
  }
  select(e, t = !0) {
    const i = this.listItems[e].getBoundingClientRect();
    this.listWrapperElement.scrollBy({
      behavior: t ? "smooth" : "auto",
      left: Math.floor(i.left - window.innerWidth / 2 + i.width / 2),
    });
  }
  _updateProgressBar(e) {
    this.scrollBarElement?.style.setProperty(
      "--transform",
      `${e.detail.progress}%`
    );
  }
};
window.customElements.define("gallery-list", GalleryList);
var GalleryItem = class extends HTMLElement {
  get index() {
    return [...this.parentNode.children].indexOf(this);
  }
  get isOnRightHalfPartOfScreen() {
    return "ltr" === window.themeVariables.settings.direction
      ? this.getBoundingClientRect().left > window.innerWidth / 2
      : this.getBoundingClientRect().right < window.innerWidth / 2;
  }
  get isOnLeftHalfPartOfScreen() {
    return "ltr" === window.themeVariables.settings.direction
      ? this.getBoundingClientRect().right < window.innerWidth / 2
      : this.getBoundingClientRect().left > window.innerWidth / 2;
  }
};
window.customElements.define("gallery-item", GalleryItem);
var ImageWithTextOverlay = class extends CustomHTMLElement {
  connectedCallback() {
    this.hasAttribute("parallax") &&
      !MediaFeatures.prefersReducedMotion() &&
      ((this._hasPendingRaF = !1),
      (this._onScrollListener = this._onScroll.bind(this)),
      window.addEventListener("scroll", this._onScrollListener)),
      this.hasAttribute("reveal-on-scroll") && this._setupVisibility();
  }
  disconnectedCallback() {
    super.disconnectedCallback(),
      this._onScrollListener &&
        window.removeEventListener("scroll", this._onScrollListener);
  }
  async _setupVisibility() {
    await this.untilVisible();
    const e = this.querySelector(".image-overlay__image"),
      t = await resolveAsyncIterator(this.querySelectorAll("split-lines")),
      i = MediaFeatures.prefersReducedMotion();
    await imageLoaded(e);
    const n = [
        new CustomKeyframeEffect(
          e,
          {
            opacity: [0, 1],
            transform: [`scale(${i ? 1 : 1.1})`, "scale(1)"],
          },
          {
            duration: 500,
            easing: "cubic-bezier(0.65, 0, 0.35, 1)",
          }
        ),
        new ParallelEffect(
          t.map(
            (e, t) =>
              new CustomKeyframeEffect(
                e,
                {
                  opacity: [0, 0.2, 1],
                  transform: [`translateY(${i ? 0 : "100%"})`, "translateY(0)"],
                  clipPath: [
                    `inset(${i ? "0 0 0 0" : "0 0 100% 0"})`,
                    "inset(0 0 0 0)",
                  ],
                },
                {
                  duration: 300,
                  delay: i ? 0 : 120 * t,
                  easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)",
                }
              )
          )
        ),
        new CustomKeyframeEffect(
          this.querySelector(".image-overlay__text-container"),
          {
            opacity: [0, 1],
          },
          {
            duration: 300,
          }
        ),
      ],
      s = new CustomAnimation(
        i ? new ParallelEffect(n) : new SequenceEffect(n)
      );
    this._hasSectionReloaded ? s.finish() : s.play();
  }
  _onScroll() {
    this._hasPendingRaF ||
      ((this._hasPendingRaF = !0),
      requestAnimationFrame(() => {
        const e = this.getBoundingClientRect(),
          t = this.querySelector(".image-overlay__content-wrapper"),
          i = this.querySelector(".image-overlay__image"),
          n = e.bottom,
          s = e.height,
          a = getStickyHeaderOffset();
        t &&
          (t.style.opacity = Math.max(
            1 - 3 * (1 - Math.min(n / s, 1)),
            0
          ).toString()),
          i &&
            (i.style.transform = `translateY(${
              100 - 100 * Math.max(1 - (1 - Math.min(n / (s + a), 1)), 0)
            }px)`),
          (this._hasPendingRaF = !1);
      }));
  }
};
window.customElements.define("image-with-text-overlay", ImageWithTextOverlay);
var ImageWithTextBlock = class extends CustomHTMLElement {
  async connectedCallback() {
    this.hasAttribute("reveal-on-scroll") && this._setupVisibility();
  }
  async _setupVisibility() {
    await this.untilVisible();
    const e = Array.from(
        this.querySelectorAll(".image-with-text-block__image[reveal]")
      ),
      t = await resolveAsyncIterator(this.querySelectorAll("split-lines")),
      i = MediaFeatures.prefersReducedMotion();
    for (const t of e) null !== t.offsetParent && (await imageLoaded(t));
    const n = [
        new ParallelEffect(
          e.map(
            (e) =>
              new CustomKeyframeEffect(
                e,
                {
                  opacity: [0, 1],
                  transform: [`scale(${i ? 1 : 1.1})`, "scale(1)"],
                },
                {
                  duration: 500,
                  easing: "cubic-bezier(0.65, 0, 0.35, 1)",
                }
              )
          )
        ),
        new CustomKeyframeEffect(
          this.querySelector(".image-with-text-block__content"),
          {
            opacity: [0, 1],
            transform: [`translateY(${i ? 0 : "60px"})`, "translateY(0)"],
          },
          {
            duration: 150,
            easing: "ease-in-out",
          }
        ),
        new ParallelEffect(
          t.map(
            (e, t) =>
              new CustomKeyframeEffect(
                e,
                {
                  opacity: [0, 0.2, 1],
                  transform: [`translateY(${i ? 0 : "100%"})`, "translateY(0)"],
                  clipPath: [
                    `inset(${i ? "0 0 0 0" : "0 0 100% 0"})`,
                    "inset(0 0 0 0)",
                  ],
                },
                {
                  duration: 300,
                  delay: i ? 0 : 120 * t,
                  easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)",
                }
              )
          )
        ),
        new CustomKeyframeEffect(
          this.querySelector(".image-with-text-block__text-container"),
          {
            opacity: [0, 1],
          },
          {
            duration: 300,
          }
        ),
      ],
      s = new CustomAnimation(
        i ? new ParallelEffect(n) : new SequenceEffect(n)
      );
    this._hasSectionReloaded ? s.finish() : s.play();
  }
};
window.customElements.define("image-with-text-block", ImageWithTextBlock);
var ArticleList = class extends CustomHTMLElement {
  async connectedCallback() {
    if (
      ((this.articleItems = Array.from(this.querySelectorAll(".article-item"))),
      this.staggerApparition)
    ) {
      await this.untilVisible({
        threshold:
          this.clientHeight > 0 ? Math.min(50 / this.clientHeight, 1) : 0,
      });
      const e = new CustomAnimation(
        new ParallelEffect(
          this.articleItems.map(
            (e, t) =>
              new CustomKeyframeEffect(
                e,
                {
                  opacity: [0, 1],
                  transform: [
                    `translateY(${
                      MediaFeatures.prefersReducedMotion()
                        ? 0
                        : window.innerWidth < 1e3
                        ? 35
                        : 60
                    }px)`,
                    "translateY(0)",
                  ],
                },
                {
                  duration: 600,
                  delay: MediaFeatures.prefersReducedMotion()
                    ? 0
                    : 100 * t - Math.min(3 * t * t, 100 * t),
                  easing: "ease",
                }
              )
          )
        )
      );
      this._hasSectionReloaded ? e.finish() : e.play();
    }
  }
  get staggerApparition() {
    return this.hasAttribute("stagger-apparition");
  }
};
window.customElements.define("article-list", ArticleList);
var BlogPostHeader = class extends HTMLElement {
  async connectedCallback() {
    const e = this.querySelector(".article__image");
    MediaFeatures.prefersReducedMotion()
      ? e.removeAttribute("reveal")
      : (await imageLoaded(e),
        e.animate(
          {
            opacity: [0, 1],
            transform: ["scale(1.1)", "scale(1)"],
          },
          {
            duration: 500,
            fill: "forwards",
            easing: "cubic-bezier(0.65, 0, 0.35, 1)",
          }
        ));
  }
};
window.customElements.define("blog-post-header", BlogPostHeader);
var PredictiveSearchInput = class extends HTMLInputElement {
  connectedCallback() {
    this.addEventListener(
      "click",
      () =>
        (document.getElementById(this.getAttribute("aria-controls")).open = !0)
    );
  }
};
window.customElements.define("predictive-search-input", PredictiveSearchInput, {
  extends: "input",
});
var DrawerContent = class extends OpenableElement {
  connectedCallback() {
    if ((super.connectedCallback(), this.hasAttribute("reverse-breakpoint"))) {
      this.originalDirection = this.classList.contains("drawer--from-left")
        ? "left"
        : "right";
      const e = window.matchMedia(this.getAttribute("reverse-breakpoint"));
      e.addListener(this._checkReverseOpeningDirection.bind(this)),
        this._checkReverseOpeningDirection(e);
    }
    this.delegate.on("click", ".drawer__overlay", () => (this.open = !1));
  }
  attributeChangedCallback(e, t, i) {
    super.attributeChangedCallback(e, t, i),
      "open" === e &&
        document.documentElement.classList.toggle("lock-all", this.open);
  }
  _checkReverseOpeningDirection(e) {
    this.classList.remove("drawer--from-left"),
      (("left" === this.originalDirection && !e.matches) ||
        ("left" !== this.originalDirection && e.matches)) &&
        this.classList.add("drawer--from-left");
  }
};
window.customElements.define("drawer-content", DrawerContent);
var PredictiveSearchDrawer = class extends DrawerContent {
  connectedCallback() {
    super.connectedCallback(),
      (this.inputElement = this.querySelector('[name="q"]')),
      (this.drawerContentElement = this.querySelector(".drawer__content")),
      (this.drawerFooterElement = this.querySelector(".drawer__footer")),
      (this.loadingStateElement = this.querySelector(
        ".predictive-search__loading-state"
      )),
      (this.resultsElement = this.querySelector(".predictive-search__results")),
      (this.menuListElement = this.querySelector(
        ".predictive-search__menu-list"
      )),
      this.delegate.on(
        "input",
        '[name="q"]',
        this._debounce(this._onSearch.bind(this), 200)
      ),
      this.delegate.on(
        "click",
        '[data-action="reset-search"]',
        this._startNewSearch.bind(this)
      );
  }
  async _onSearch(e, t) {
    if ("Enter" !== e.key)
      if (
        (this.abortController && this.abortController.abort(),
        this.drawerContentElement.classList.remove("drawer__content--center"),
        (this.drawerFooterElement.hidden = !0),
        "" === t.value)
      )
        (this.loadingStateElement.hidden = !0),
          (this.resultsElement.hidden = !0),
          this.menuListElement && (this.menuListElement.hidden = !1);
      else {
        this.drawerContentElement.classList.add("drawer__content--center"),
          (this.loadingStateElement.hidden = !1),
          (this.resultsElement.hidden = !0),
          this.menuListElement && (this.menuListElement.hidden = !0);
        let i = {};
        try {
          (this.abortController = new AbortController()),
            (i = this._supportPredictiveApi()
              ? await this._doPredictiveSearch(t.value)
              : await this._doLiquidSearch(t.value));
        } catch (e) {
          if ("AbortError" === e.name) return;
        }
        (this.loadingStateElement.hidden = !0),
          (this.resultsElement.hidden = !1),
          this.menuListElement && (this.menuListElement.hidden = !0),
          i.hasResults &&
            ((this.drawerFooterElement.hidden = !1),
            this.drawerContentElement.classList.remove(
              "drawer__content--center"
            )),
          (this.resultsElement.innerHTML = i.html);
      }
  }
  async _doPredictiveSearch(e) {
    const t = await fetch(
        `${
          window.themeVariables.routes.predictiveSearchUrl
        }?q=${encodeURIComponent(
          e
        )}&resources[limit]=10&resources[limit_scope]=each&section_id=predictive-search`,
        {
          signal: this.abortController.signal,
        }
      ),
      i = document.createElement("div");
    return (
      (i.innerHTML = await t.text()),
      {
        hasResults:
          null !== i.querySelector(".predictive-search__results-categories"),
        html: i.firstElementChild.innerHTML,
      }
    );
  }
  async _doLiquidSearch(e) {
    const t = await fetch(
        `${window.themeVariables.routes.searchUrl}?q=${encodeURIComponent(
          e
        )}&resources[limit]=50&section_id=predictive-search-compatibility`,
        {
          signal: this.abortController.signal,
        }
      ),
      i = document.createElement("div");
    return (
      (i.innerHTML = await t.text()),
      {
        hasResults:
          null !== i.querySelector(".predictive-search__results-categories"),
        html: i.firstElementChild.innerHTML,
      }
    );
  }
  _startNewSearch() {
    (this.inputElement.value = ""), this.inputElement.focus();
    const e = new Event("input", {
      bubbles: !0,
      cancelable: !0,
    });
    this.inputElement.dispatchEvent(e);
  }
  _supportPredictiveApi() {
    return JSON.parse(document.getElementById("shopify-features").innerHTML)
      .predictiveSearch;
  }
  _debounce(e, t) {
    let i = null;
    return (...n) => {
      clearTimeout(i),
        (i = setTimeout(() => {
          e.apply(this, n);
        }, t));
    };
  }
};
window.customElements.define(
  "predictive-search-drawer",
  PredictiveSearchDrawer
);
var Timeline = class extends HTMLElement {
  connectedCallback() {
    if (
      ((this.prevNextButtons = this.querySelector("prev-next-buttons")),
      (this.pageDots = this.querySelector("page-dots")),
      (this.scrollBarElement = this.querySelector(".timeline__progress-bar")),
      (this.listWrapperElement = this.querySelector(".timeline__list-wrapper")),
      (this.listItemElements = Array.from(
        this.querySelectorAll(".timeline__item")
      )),
      (this.isScrolling = !1),
      this.listItemElements.length > 1)
    ) {
      this.addEventListener("prev-next:prev", this.previous.bind(this)),
        this.addEventListener("prev-next:next", this.next.bind(this)),
        this.addEventListener("page-dots:changed", (e) =>
          this.select(e.detail.index)
        ),
        Shopify.designMode &&
          this.addEventListener("shopify:block:select", (e) => {
            this.select(
              [...e.target.parentNode.children].indexOf(e.target),
              !e.detail.load
            );
          }),
        (this.itemIntersectionObserver = new IntersectionObserver(
          this._onItemObserved.bind(this),
          {
            threshold: 0.4,
          }
        ));
      const e = window.matchMedia(window.themeVariables.breakpoints.pocket);
      e.addListener(this._onMediaChanged.bind(this)), this._onMediaChanged(e);
    }
  }
  get selectedIndex() {
    return this.listItemElements.findIndex((e) => !e.hasAttribute("hidden"));
  }
  previous() {
    this.select(Math.max(0, this.selectedIndex - 1));
  }
  next() {
    this.select(
      Math.min(this.selectedIndex + 1, this.listItemElements.length - 1)
    );
  }
  select(e, t = !0) {
    const i = this.listItemElements[e].getBoundingClientRect();
    t &&
      ((this.isScrolling = !0), setTimeout(() => (this.isScrolling = !1), 800)),
      window.matchMedia(window.themeVariables.breakpoints.pocket).matches
        ? this.listWrapperElement.scrollTo({
            behavior: t ? "smooth" : "auto",
            left: this.listItemElements[0].clientWidth * e,
          })
        : this.listWrapperElement.scrollBy({
            behavior: t ? "smooth" : "auto",
            left: Math.floor(i.left - window.innerWidth / 2 + i.width / 2),
          }),
      this._onItemSelected(e);
  }
  _onItemSelected(e) {
    const t = this.listItemElements[e];
    t.removeAttribute("hidden", "false"),
      getSiblings(t).forEach((e) => e.setAttribute("hidden", "")),
      (this.prevNextButtons.isPrevDisabled = 0 === e),
      (this.prevNextButtons.isNextDisabled =
        e === this.listItemElements.length - 1),
      (this.pageDots.selectedIndex = e),
      this.scrollBarElement?.style.setProperty(
        "--transform",
        (100 / (this.listItemElements.length - 1)) * e + "%"
      );
  }
  _onItemObserved(e) {
    this.isScrolling ||
      e.forEach((e) => {
        e.isIntersecting &&
          this._onItemSelected(
            [...e.target.parentNode.children].indexOf(e.target)
          );
      });
  }
  _onMediaChanged(e) {
    e.matches
      ? this.listItemElements.forEach((e) =>
          this.itemIntersectionObserver.observe(e)
        )
      : this.listItemElements.forEach((e) =>
          this.itemIntersectionObserver.unobserve(e)
        );
  }
};
window.customElements.define("time-line", Timeline);
var PressList = class extends CustomHTMLElement {
  connectedCallback() {
    (this.pressItemsWrapper = this.querySelector(".press-list__wrapper")),
      (this.pressItems = Array.from(this.querySelectorAll("press-item"))),
      (this.pageDots = this.querySelector("page-dots")),
      this.pressItems.length > 1 &&
        (Shopify.designMode &&
          this.addEventListener("shopify:block:select", (e) => {
            this.intersectionObserver?.disconnect(),
              (!e.detail.load && e.target.selected) ||
                this.select(e.target.index, !e.detail.load);
          }),
        this.pressItemsWrapper.addEventListener(
          "swiperight",
          this.previous.bind(this)
        ),
        this.pressItemsWrapper.addEventListener(
          "swipeleft",
          this.next.bind(this)
        ),
        this.addEventListener("page-dots:changed", (e) =>
          this.select(e.detail.index)
        ),
        this._blockVerticalScroll()),
      this.hasAttribute("reveal-on-scroll") && this._setupVisibility();
  }
  async _setupVisibility() {
    await this.untilVisible(),
      this.pressItems[this.selectedIndex].transitionToEnter();
  }
  get selectedIndex() {
    return this.pressItems.findIndex((e) => e.selected);
  }
  previous() {
    this.select(
      (this.selectedIndex - 1 + this.pressItems.length) % this.pressItems.length
    );
  }
  next() {
    this.select(
      (this.selectedIndex + 1 + this.pressItems.length) % this.pressItems.length
    );
  }
  async select(e, t = !0) {
    const i = this.pressItems[this.selectedIndex],
      n = this.pressItems[e];
    await i.transitionToLeave(t),
      (this.pageDots.selectedIndex = e),
      await n.transitionToEnter(t);
  }
};
Object.assign(PressList.prototype, VerticalScrollBlockerMixin),
  window.customElements.define("press-list", PressList);
var PressItem = class extends HTMLElement {
  connectedCallback() {
    this.addEventListener("split-lines:re-split", (e) => {
      Array.from(e.target.children).forEach(
        (e) => (e.style.visibility = this.selected ? "visible" : "hidden")
      );
    });
  }
  get index() {
    return [...this.parentNode.children].indexOf(this);
  }
  get selected() {
    return !this.hasAttribute("hidden");
  }
  async transitionToLeave(e = !0) {
    const t = await resolveAsyncIterator(this.querySelectorAll("split-lines")),
      i = new CustomAnimation(
        new ParallelEffect(
          t.reverse().map(
            (e, t) =>
              new CustomKeyframeEffect(
                e,
                {
                  visibility: ["visible", "hidden"],
                  clipPath: ["inset(0 0 0 0)", "inset(0 0 100% 0)"],
                  transform: ["translateY(0)", "translateY(100%)"],
                },
                {
                  duration: 350,
                  delay: 60 * t,
                  easing: "cubic-bezier(0.68, 0.00, 0.77, 0.00)",
                }
              )
          )
        )
      );
    e ? i.play() : i.finish(),
      await i.finished,
      this.setAttribute("hidden", "");
  }
  async transitionToEnter(e = !0) {
    this.removeAttribute("hidden");
    const t = await resolveAsyncIterator(
        this.querySelectorAll("split-lines, .testimonial__author")
      ),
      i = new CustomAnimation(
        new ParallelEffect(
          t.map(
            (e, t) =>
              new CustomKeyframeEffect(
                e,
                {
                  visibility: ["hidden", "visible"],
                  clipPath: ["inset(0 0 100% 0)", "inset(0 0 0px 0)"],
                  transform: ["translateY(100%)", "translateY(0)"],
                },
                {
                  duration: 550,
                  delay: 120 * t,
                  easing: "cubic-bezier(0.23, 1, 0.32, 1)",
                }
              )
          )
        )
      );
    return e ? i.play() : i.finish(), i.finished;
  }
};
window.customElements.define("press-item", PressItem);
var DesktopNavigation = class extends CustomHTMLElement {
  connectedCallback() {
    (this.openingTimeout = null),
      (this.currentMegaMenu = null),
      this.delegate.on(
        "mouseenter",
        ".has-dropdown",
        (e, t) => {
          e.target === t && null !== e.relatedTarget && this.openDropdown(t);
        },
        !0
      ),
      this.delegate.on(
        "click",
        ".header__linklist-link[aria-expanded], .nav-dropdown__link[aria-expanded]",
        (e, t) => {
          window.matchMedia("(hover: hover)").matches ||
            "true" === t.getAttribute("aria-expanded") ||
            (e.preventDefault(), this.openDropdown(t.parentElement));
        }
      ),
      this.delegate.on("shopify:block:select", (e) =>
        this.openDropdown(e.target.parentElement)
      ),
      this.delegate.on("shopify:block:deselect", (e) =>
        this.closeDropdown(e.target.parentElement)
      );
  }
  openDropdown(e) {
    const t = e.querySelector("[aria-controls]"),
      i = e.querySelector(`#${t.getAttribute("aria-controls")}`);
    this.currentMegaMenu = i.classList.contains("mega-menu") ? i : null;
    let n = setTimeout(() => {
      if ("true" === t.getAttribute("aria-expanded")) return;
      if (
        (t.setAttribute("aria-expanded", "true"),
        i.removeAttribute("hidden"),
        i.classList.contains("mega-menu") &&
          !MediaFeatures.prefersReducedMotion())
      ) {
        const e = Array.from(
          i.querySelectorAll(".mega-menu__column, .mega-menu__image-push")
        );
        e.forEach((e) => {
          e.getAnimations().forEach((e) => e.cancel()), (e.style.opacity = 0);
        }),
          new CustomAnimation(
            new ParallelEffect(
              e.map(
                (e, t) =>
                  new CustomKeyframeEffect(
                    e,
                    {
                      opacity: [0, 1],
                      transform: ["translateY(20px)", "translateY(0)"],
                    },
                    {
                      duration: 250,
                      delay: 100 + 60 * t,
                      easing: "cubic-bezier(0.65, 0, 0.35, 1)",
                    }
                  )
              )
            )
          ).play();
      }
      const s = (t) => {
          null !== t.relatedTarget &&
            (this.closeDropdown(e), e.removeEventListener("mouseleave", s));
        },
        a = () => {
          this.closeDropdown(e),
            document.documentElement.removeEventListener("mouseleave", a);
        };
      e.addEventListener("mouseleave", s),
        document.documentElement.addEventListener("mouseleave", a),
        (n = null),
        this.dispatchEvent(
          new CustomEvent("desktop-nav:dropdown:open", {
            bubbles: !0,
          })
        );
    }, 100);
    e.addEventListener(
      "mouseleave",
      () => {
        n && clearTimeout(n);
      },
      {
        once: !0,
      }
    );
  }
  closeDropdown(e) {
    const t = e.querySelector("[aria-controls]"),
      i = e.querySelector(`#${t.getAttribute("aria-controls")}`);
    requestAnimationFrame(() => {
      i.classList.add("is-closing"),
        t.setAttribute("aria-expanded", "false"),
        setTimeout(
          () => {
            i.setAttribute("hidden", ""),
              clearTimeout(this.openingTimeout),
              i.classList.remove("is-closing");
          },
          i.classList.contains("mega-menu") && this.currentMegaMenu !== i
            ? 250
            : 0
        ),
        this.dispatchEvent(
          new CustomEvent("desktop-nav:dropdown:close", {
            bubbles: !0,
          })
        );
    });
  }
};
window.customElements.define("desktop-navigation", DesktopNavigation);
var MobileNavigation = class extends DrawerContent {
  get apparitionAnimation() {
    if (this._apparitionAnimation) return this._apparitionAnimation;
    if (!MediaFeatures.prefersReducedMotion()) {
      const e = Array.from(
          this.querySelectorAll('.mobile-nav__item[data-level="1"]')
        ),
        t = [];
      t.push(
        new ParallelEffect(
          e.map(
            (e, t) =>
              new CustomKeyframeEffect(
                e,
                {
                  opacity: [0, 1],
                  transform: ["translateX(-40px)", "translateX(0)"],
                },
                {
                  duration: 300,
                  delay: 300 + 120 * t - Math.min(2 * t * t, 120 * t),
                  easing: "cubic-bezier(0.25, 1, 0.5, 1)",
                }
              )
          )
        )
      );
      const i = this.querySelector(".drawer__footer");
      return (
        i &&
          t.push(
            new CustomKeyframeEffect(
              i,
              {
                opacity: [0, 1],
                transform: ["translateY(100%)", "translateY(0)"],
              },
              {
                duration: 300,
                delay: 500 + Math.max(125 * e.length - 25 * e.length, 25),
                easing: "cubic-bezier(0.25, 1, 0.5, 1)",
              }
            )
          ),
        (this._apparitionAnimation = new CustomAnimation(new ParallelEffect(t)))
      );
    }
  }
  attributeChangedCallback(e, t, i) {
    super.attributeChangedCallback(e, t, i),
      "open" === e &&
        (this.open &&
          this.apparitionAnimation &&
          (Array.from(
            this.querySelectorAll(
              '.mobile-nav__item[data-level="1"], .drawer__footer'
            )
          ).forEach((e) => (e.style.opacity = 0)),
          this.apparitionAnimation.play()),
        triggerEvent(this, this.open ? "mobile-nav:open" : "mobile-nav:close"));
  }
};
window.customElements.define("mobile-navigation", MobileNavigation);
var StoreHeader = class extends CustomHTMLElement {
  connectedCallback() {
    window.ResizeObserver &&
      ((this.resizeObserver = new ResizeObserver(
        this._updateCustomProperties.bind(this)
      )),
      this.resizeObserver.observe(this),
      this.resizeObserver.observe(this.querySelector(".header__wrapper"))),
      this.isTransparent &&
        ((this.isTransparencyDetectionLocked = !1),
        this.delegate.on(
          "desktop-nav:dropdown:open",
          () => (this.lockTransparency = !0)
        ),
        this.delegate.on(
          "desktop-nav:dropdown:close",
          () => (this.lockTransparency = !1)
        ),
        this.rootDelegate.on(
          "mobile-nav:open",
          () => (this.lockTransparency = !0)
        ),
        this.rootDelegate.on(
          "mobile-nav:close",
          () => (this.lockTransparency = !1)
        ),
        this.delegate.on(
          "mouseenter",
          this._checkTransparentHeader.bind(this),
          !0
        ),
        this.delegate.on("mouseleave", this._checkTransparentHeader.bind(this)),
        this.isSticky &&
          (this._checkTransparentHeader(),
          (this._onWindowScrollListener = throttle(
            this._checkTransparentHeader.bind(this),
            100
          )),
          window.addEventListener("scroll", this._onWindowScrollListener)));
  }
  disconnectedCallback() {
    super.disconnectedCallback(),
      window.ResizeObserver && this.resizeObserver.disconnect(),
      this.isTransparent &&
        this.isSticky &&
        window.removeEventListener("scroll", this._onWindowScrollListener);
  }
  get isSticky() {
    return this.hasAttribute("sticky");
  }
  get isTransparent() {
    return this.hasAttribute("transparent");
  }
  get transparentHeaderThreshold() {
    return 25;
  }
  set lockTransparency(e) {
    (this.isTransparencyDetectionLocked = e), this._checkTransparentHeader();
  }
  _updateCustomProperties(e) {
    e.forEach((e) => {
      if (e.target === this) {
        const t = e.borderBoxSize
          ? e.borderBoxSize.length > 0
            ? e.borderBoxSize[0].blockSize
            : e.borderBoxSize.blockSize
          : e.target.clientHeight;
        document.documentElement.style.setProperty("--header-height", `${t}px`);
      }
      if (e.target.classList.contains("header__wrapper")) {
        const t = e.borderBoxSize
          ? e.borderBoxSize.length > 0
            ? e.borderBoxSize[0].blockSize
            : e.borderBoxSize.blockSize
          : e.target.clientHeight;
        document.documentElement.style.setProperty(
          "--header-height-without-bottom-nav",
          `${t}px`
        );
      }
    });
  }
  _checkTransparentHeader(e) {
    this.isTransparencyDetectionLocked ||
    window.scrollY > this.transparentHeaderThreshold ||
    (e && "mouseenter" === e.type)
      ? this.classList.remove("header--transparent")
      : this.classList.add("header--transparent");
  }
};
window.customElements.define("store-header", StoreHeader);
var GiftCardRecipient = class extends HTMLElement {
  connectedCallback() {
    const e = Array.from(this.querySelectorAll('[name*="properties"]')),
      t = "properties[__shopify_send_gift_card_to_recipient]";
    (this.recipientCheckbox = e.find((e) => e.name === t)),
      (this.recipientOtherProperties = e.filter((e) => e.name !== t)),
      (this.recipientFieldsContainer = this.querySelector(
        ".gift-card-recipient__fields"
      )),
      this.recipientCheckbox?.addEventListener(
        "change",
        this._synchronizeProperties.bind(this)
      ),
      (this.offsetProperty = this.querySelector(
        '[name="properties[__shopify_offset]"]'
      )),
      this.offsetProperty &&
        (this.offsetProperty.value = new Date().getTimezoneOffset().toString()),
      (this.recipientSendOnProperty = this.querySelector(
        '[name="properties[Send on]"]'
      ));
    const i = new Date(),
      n = new Date();
    n.setDate(i.getDate() + 90),
      this.recipientSendOnProperty?.setAttribute("min", this._formatDate(i)),
      this.recipientSendOnProperty?.setAttribute("max", this._formatDate(n)),
      this._synchronizeProperties();
  }
  _synchronizeProperties() {
    this.recipientOtherProperties.forEach(
      (e) => (e.disabled = !this.recipientCheckbox.checked)
    ),
      this.recipientFieldsContainer.classList.toggle(
        "js:hidden",
        !this.recipientCheckbox.checked
      );
  }
  _formatDate(e) {
    const t = e.getTimezoneOffset();
    return new Date(e.getTime() - 60 * t * 1e3).toISOString().split("T")[0];
  }
};
window.customElements.get("gift-card-recipient") ||
  window.customElements.define("gift-card-recipient", GiftCardRecipient);
var PhotoSwipeUi = class {
    constructor(e) {
      (this.photoSwipeInstance = e),
        (this.delegate = new main_default(this.photoSwipeInstance.scrollWrap)),
        (this.maxSpreadZoom =
          window.themeVariables.settings.mobileZoomFactor || 2),
        (this.pswpUi =
          this.photoSwipeInstance.scrollWrap.querySelector(".pswp__ui")),
        this.delegate.on(
          "click",
          '[data-action="pswp-close"]',
          this._close.bind(this)
        ),
        this.delegate.on(
          "click",
          '[data-action="pswp-prev"]',
          this._goToPrev.bind(this)
        ),
        this.delegate.on(
          "click",
          '[data-action="pswp-next"]',
          this._goToNext.bind(this)
        ),
        this.delegate.on(
          "click",
          '[data-action="pswp-move-to"]',
          this._moveTo.bind(this)
        ),
        this.photoSwipeInstance.listen("close", this._onPswpClosed.bind(this)),
        this.photoSwipeInstance.listen(
          "doubleTap",
          this._onPswpDoubleTap.bind(this)
        ),
        this.photoSwipeInstance.listen(
          "beforeChange",
          this._onPswpBeforeChange.bind(this)
        ),
        this.photoSwipeInstance.listen(
          "initialZoomInEnd",
          this._onPswpInitialZoomInEnd.bind(this)
        ),
        this.photoSwipeInstance.listen(
          "initialZoomOut",
          this._onPswpInitialZoomOut.bind(this)
        ),
        this.photoSwipeInstance.listen(
          "parseVerticalMargin",
          this._onPswpParseVerticalMargin.bind(this)
        ),
        this.delegate.on("pswpTap", ".pswp__img", this._onPswpTap.bind(this));
    }
    init() {
      const e = this.pswpUi.querySelector(".pswp__prev-next-buttons"),
        t = this.pswpUi.querySelector(".pswp__dots-nav-wrapper");
      if (this.photoSwipeInstance.items.length <= 1)
        return (e.style.display = "none"), void (t.style.display = "none");
      (e.style.display = ""), (t.style.display = "");
      let i = "";
      this.photoSwipeInstance.items.forEach((e, t) => {
        i += `\n        <button class="dots-nav__item tap-area" ${
          0 === t ? 'aria-current="true"' : ""
        } data-action="pswp-move-to">\n          <span class="visually-hidden">Go to slide ${t}</span>\n        </button>\n      `;
      }),
        (t.querySelector(".pswp__dots-nav-wrapper .dots-nav").innerHTML = i);
    }
    _close() {
      this.photoSwipeInstance.close();
    }
    _goToPrev() {
      this.photoSwipeInstance.prev();
    }
    _goToNext() {
      this.photoSwipeInstance.next();
    }
    _moveTo(e, t) {
      this.photoSwipeInstance.goTo([...t.parentNode.children].indexOf(t));
    }
    _onPswpClosed() {
      this.delegate.off("pswpTap");
    }
    _onPswpDoubleTap(e) {
      const t = this.photoSwipeInstance.currItem.initialZoomLevel;
      this.photoSwipeInstance.getZoomLevel() !== t
        ? this.photoSwipeInstance.zoomTo(t, e, 333)
        : this.photoSwipeInstance.zoomTo(
            t < 0.7 ? 1 : this.maxSpreadZoom,
            e,
            333
          );
    }
    _onPswpTap(e) {
      "mouse" === e.detail.pointerType &&
        this.photoSwipeInstance.toggleDesktopZoom(e.detail.releasePoint);
    }
    _onPswpBeforeChange() {
      if (this.photoSwipeInstance.items.length <= 1) return;
      const e = this.photoSwipeInstance.scrollWrap.querySelector(
        `.dots-nav__item:nth-child(${
          this.photoSwipeInstance.getCurrentIndex() + 1
        })`
      );
      e.setAttribute("aria-current", "true"),
        getSiblings(e).forEach((e) => e.removeAttribute("aria-current"));
    }
    _onPswpInitialZoomInEnd() {
      this.pswpUi?.classList.remove("pswp__ui--hidden");
    }
    _onPswpInitialZoomOut() {
      this.pswpUi?.classList.add("pswp__ui--hidden");
    }
    _onPswpParseVerticalMargin(e) {
      e.vGap.bottom =
        this.photoSwipeInstance.items.length <= 1 ||
        window.matchMedia(window.themeVariables.breakpoints.lapAndUp).matches
          ? 0
          : 60;
    }
  },
  ProductImageZoom = class extends OpenableElement {
    connectedCallback() {
      super.connectedCallback(),
        (this.mediaElement = this.closest(".product__media")),
        (this.maxSpreadZoom =
          window.themeVariables.settings.mobileZoomFactor || 2),
        LibraryLoader.load("photoswipe");
    }
    disconnectedCallback() {
      super.disconnectedCallback(), this.photoSwipeInstance?.destroy();
    }
    async attributeChangedCallback(e, t, i) {
      super.attributeChangedCallback(e, t, i),
        "open" === e &&
          this.open &&
          (await LibraryLoader.load("photoswipe"), this._openPhotoSwipe());
    }
    async _openPhotoSwipe() {
      const e = await this._buildItems();
      this.photoSwipeInstance = new window.ThemePhotoSwipe(
        this,
        PhotoSwipeUi,
        e,
        {
          index: e.findIndex((e) => e.selected),
          maxSpreadZoom: this.maxSpreadZoom,
          loop: !1,
          allowPanToNext: !1,
          closeOnScroll: !1,
          closeOnVerticalDrag: MediaFeatures.supportsHover(),
          showHideOpacity: !0,
          arrowKeys: !0,
          history: !1,
          getThumbBoundsFn: () => {
            const e = this.mediaElement.querySelector(
                ".product__media-item.is-selected"
              ),
              t = window.pageYOffset || document.documentElement.scrollTop,
              i = e.getBoundingClientRect();
            return {
              x: i.left,
              y: i.top + t,
              w: i.width,
            };
          },
          getDoubleTapZoom: (e, t) =>
            e ? (t.w > t.h ? 1.6 : 1) : t.initialZoomLevel < 0.7 ? 1 : 1.33,
        }
      );
      let t = null;
      (this.photoSwipeInstance.updateSize = new Proxy(
        this.photoSwipeInstance.updateSize,
        {
          apply: (e, i, n) => {
            t !== window.innerWidth && (e(arguments), (t = window.innerWidth));
          },
        }
      )),
        this.photoSwipeInstance.listen("close", () => {
          this.open = !1;
        }),
        this.photoSwipeInstance.init();
    }
    async _buildItems() {
      const e = Array.from(
          this.mediaElement.querySelectorAll(
            '.product__media-item[data-media-type="image"]:not(.is-filtered)'
          )
        ),
        t = await ProductLoader.load(this.getAttribute("product-handle"));
      return Promise.resolve(
        e.map((e) => {
          const i = t.media.find(
              (t) => t.id === parseInt(e.getAttribute("data-media-id"))
            ),
            n = getSupportedSizes(
              i,
              [
                200, 300, 400, 500, 600, 700, 800, 1e3, 1200, 1400, 1600, 1800,
                2e3, 2200, 2400, 2600, 2800, 3e3,
              ]
            ),
            s = Math.min(n[n.length - 1], window.innerWidth);
          return {
            selected: e.classList.contains("is-selected"),
            src: getSizedMediaUrl(
              i,
              `${Math.ceil(
                Math.min(s * window.devicePixelRatio * this.maxSpreadZoom, 3e3)
              )}x`
            ),
            msrc: e.firstElementChild.currentSrc,
            originalMedia: i,
            w: s,
            h: parseInt(s / i.aspect_ratio),
          };
        })
      );
    }
  };
window.customElements.define("product-image-zoom", ProductImageZoom);
var ProductInventory = class extends HTMLElement {
  connectedCallback() {
    const e = this.querySelector("script");
    e &&
      ((this.inventories = JSON.parse(e.innerHTML)),
      document
        .getElementById(this.getAttribute("form-id"))
        ?.addEventListener(
          "variant:changed",
          this._onVariantChanged.bind(this)
        ));
  }
  _onVariantChanged(e) {
    this.querySelector("span")?.remove(),
      e.detail.variant && "" !== this.inventories[e.detail.variant.id]
        ? ((this.hidden = !1),
          this.insertAdjacentHTML(
            "afterbegin",
            this.inventories[e.detail.variant.id]
          ))
        : (this.hidden = !0);
  }
};
window.customElements.define("product-inventory", ProductInventory);
var PaymentContainer = class extends HTMLElement {
  connectedCallback() {
    document
      .getElementById(this.getAttribute("form-id"))
      ?.addEventListener("variant:changed", this._onVariantChanged.bind(this)),
      Shopify.designMode &&
        Shopify.PaymentButton &&
        Shopify.PaymentButton.init();
  }
  _onVariantChanged(e) {
    this._updateAddToCartButton(e.detail.variant),
      this._updateDynamicCheckoutButton(e.detail.variant);
  }
  _updateAddToCartButton(e) {
    let t = this.querySelector("[data-product-add-to-cart-button]");
    if (!t) return;
    let i = "";
    t.classList.remove(
      "button--primary",
      "button--secondary",
      "button--ternary"
    ),
      e
        ? e.available
          ? (t.removeAttribute("disabled"),
            t.classList.add(
              t.hasAttribute("data-use-primary")
                ? "button--primary"
                : "button--secondary"
            ),
            (i = t.getAttribute("data-button-content")))
          : (t.setAttribute("disabled", "disabled"),
            t.classList.add("button--ternary"),
            (i = window.themeVariables.strings.productFormSoldOut))
        : (t.setAttribute("disabled", "disabled"),
          t.classList.add("button--ternary"),
          (i = window.themeVariables.strings.productFormUnavailable)),
      "loader-button" === t.getAttribute("is")
        ? (t.firstElementChild.innerHTML = i)
        : (t.innerHTML = i);
  }
  _updateDynamicCheckoutButton(e) {
    let t = this.querySelector(".shopify-payment-button");
    t && (t.style.display = e && e.available ? "block" : "none");
  }
};
window.customElements.define("product-payment-container", PaymentContainer);
var PaymentTerms = class extends CustomHTMLElement {
  connectedCallback() {
    document
      .getElementById(this.getAttribute("form-id"))
      ?.addEventListener("variant:changed", this._onVariantChanged.bind(this));
  }
  _onVariantChanged(e) {
    const t = e.detail.variant;
    if (t) {
      const e = this.querySelector('[name="id"]');
      (e.value = t.id),
        e.dispatchEvent(
          new Event("change", {
            bubbles: !0,
          })
        );
    }
  }
};
window.customElements.define("product-payment-terms", PaymentTerms);
var ProductForm = class extends HTMLFormElement {
  connectedCallback() {
    (this.id.disabled = !1),
      this.addEventListener("submit", this._onSubmit.bind(this));
  }
  async _onSubmit(e) {
    if ((e.preventDefault(), !this.checkValidity()))
      return void this.reportValidity();
    const t = Array.from(this.elements).filter((e) => "submit" === e.type);
    t.forEach((e) => {
      e.setAttribute("disabled", "disabled"),
        e.setAttribute("aria-busy", "true");
    });
    const i = new FormData(this);
    properties
      ? (i.append("sections", ["mini-cart"]),
        i.delete("option1"),
        i.delete("option2"),
        i.delete("option3"),
        Object.entries(properties).forEach(([e, t]) => {
          "" !== t && i.append(`properties[${e}]`, t);
        }))
      : (i.append("sections", ["mini-cart"]),
        i.delete("option1"),
        i.delete("option2"),
        i.delete("option3"));
    const n = await fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
      body: i,
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
    });
    t.forEach((e) => {
      e.removeAttribute("disabled"), e.removeAttribute("aria-busy");
    });
    const s = await n.json();
    setTimeout(function () {
      if (n.ok) {
        if (
          "page" === window.themeVariables.settings.cartType ||
          "cart" === window.themeVariables.settings.pageType
        )
          return (window.location.href = `${Shopify.routes.root}cart`);
        this.dispatchEvent(
          new CustomEvent("variant:added", {
            bubbles: !0,
            detail: {
              variant: s.hasOwnProperty("items") ? s.items[0] : s,
            },
          })
        ),
          fetch(`${window.themeVariables.routes.cartUrl}.js`).then(
            async (e) => {
              const t = await e.json();
              document.documentElement.dispatchEvent(
                new CustomEvent("cart:updated", {
                  bubbles: !0,
                  detail: {
                    cart: t,
                  },
                })
              ),
                (t.sections = s.sections),
                document.documentElement.dispatchEvent(
                  new CustomEvent("cart:refresh", {
                    bubbles: !0,
                    detail: {
                      cart: t,
                      openMiniCart:
                        "drawer" === window.themeVariables.settings.cartType &&
                        null === this.closest(".drawer"),
                    },
                  })
                );
            }
          ),
          e.target.querySelector(".product-form__add-button") &&
            setTimeout(function () {
              clickElementsSequentially(), console.log("Fuction called");
            }, 200),
          setTimeout(function () {
            document.querySelector(".add-nailcare-set") &&
              document.querySelector(".add-nailcare-set").click();
          }, 400),
          updateCartCount();
        let t =
          '\n      <div class="spinner-box">\n        <div class="circle-border">\n          <div class="circle-core"></div>\n        </div>  \n      </div>\n      ';
        setTimeout(function () {
          document
            .querySelector("#mini-cart")
            .insertAdjacentHTML("beforeend", t),
            setTimeout(function () {
              document.querySelector(".spinner-box") &&
                (document.querySelector(".spinner-box").style.display = "none");
            }, 2300);
        }, 500),
          (properties = {});
      }
    }, 1200),
      this.dispatchEvent(
        new CustomEvent("cart-notification:show", {
          bubbles: !0,
          cancelable: !0,
          detail: {
            status: n.ok ? "success" : "error",
            error: s.description || "",
          },
        })
      );
  }
};
window.customElements.define("product-form", ProductForm, {
  extends: "form",
});
var ProductMedia = class extends CustomHTMLElement {
  async connectedCallback() {
    (this.mainCarousel = this.querySelector("flickity-carousel")),
      this.hasAttribute("reveal-on-scroll") && this._setupVisibility(),
      1 !== this.mainCarousel.childElementCount &&
        ((this.selectedVariantMediaId = null),
        (this.viewInSpaceElement = this.querySelector(
          "[data-shopify-model3d-id]"
        )),
        (this.zoomButton = this.querySelector(".product__zoom-button")),
        (this.product = await ProductLoader.load(
          this.getAttribute("product-handle")
        )),
        document
          .getElementById(this.getAttribute("form-id"))
          ?.addEventListener(
            "variant:changed",
            this._onVariantChanged.bind(this)
          ),
        this.mainCarousel.addEventListener("model:played", () =>
          this.mainCarousel.setDraggable(!1)
        ),
        this.mainCarousel.addEventListener("model:paused", () =>
          this.mainCarousel.setDraggable(!0)
        ),
        this.mainCarousel.addEventListener("video:played", () =>
          this.mainCarousel.setDraggable(!1)
        ),
        this.mainCarousel.addEventListener("video:paused", () =>
          this.mainCarousel.setDraggable(!0)
        ),
        this.mainCarousel.addEventListener(
          "flickity:ready",
          this._onFlickityReady.bind(this)
        ),
        this.mainCarousel.addEventListener(
          "flickity:slide-changed",
          this._onFlickityChanged.bind(this)
        ),
        this.mainCarousel.addEventListener(
          "flickity:slide-settled",
          this._onFlickitySettled.bind(this)
        ),
        this._onFlickityReady());
  }
  get thumbnailsPosition() {
    return window.matchMedia(window.themeVariables.breakpoints.pocket).matches
      ? "bottom"
      : this.getAttribute("thumbnails-position");
  }
  async _setupVisibility() {
    await this.untilVisible();
    const e = await this.mainCarousel.flickityInstance,
      t = e
        ? e.selectedElement.querySelector("img")
        : this.querySelector(".product__media-image-wrapper img"),
      i = MediaFeatures.prefersReducedMotion();
    await imageLoaded(t);
    const n = new CustomAnimation(
      new ParallelEffect([
        new CustomKeyframeEffect(
          t,
          {
            opacity: [0, 1],
            transform: [`scale(${i ? 1 : 1.1})`, "scale(1)"],
          },
          {
            duration: 500,
            easing: "cubic-bezier(0.65, 0, 0.35, 1)",
          }
        ),
        new ParallelEffect(
          Array.from(
            this.querySelectorAll(".product__thumbnail-item:not(.is-filtered)")
          ).map(
            (e, t) =>
              new CustomKeyframeEffect(
                e,
                {
                  opacity: [0, 1],
                  transform:
                    "left" === this.thumbnailsPosition
                      ? [`translateY(${i ? 0 : "40px"})`, "translateY(0)"]
                      : [`translateX(${i ? 0 : "50px"})`, "translateX(0)"],
                },
                {
                  duration: 250,
                  delay: i ? 0 : 100 * t,
                  easing: "cubic-bezier(0.75, 0, 0.175, 1)",
                }
              )
          )
        ),
      ])
    );
    this._hasSectionReloaded ? n.finish() : n.play();
  }
  async _onVariantChanged(e) {
    const t = e.detail.variant,
      i = [];
    let n = !1;
    if (
      (this.product.media.forEach((e) => {
        let s = t.featured_media && e.id === t.featured_media.id;
        if (e.alt?.includes("#") && ((n = !0), !s)) {
          const n = e.alt.split("#").pop().split("_");
          this.product.options.forEach((s) => {
            s.name.toLowerCase() === n[0].toLowerCase() &&
              t.options[s.position - 1].toLowerCase() !==
                n[1].trim().toLowerCase() &&
              i.push(e.id);
          });
        }
      }),
      [
        ...new Set(
          Array.from(this.querySelectorAll(".is-filtered[data-media-id]")).map(
            (e) => parseInt(e.getAttribute("data-media-id"))
          )
        ),
      ].some((e) => !i.includes(e)))
    ) {
      const e = t.featured_media
        ? t.featured_media.id
        : this.product.media.map((e) => e.id).filter((e) => !i.includes(e))[0];
      Array.from(this.querySelectorAll("[data-media-id]")).forEach((t) => {
        t.classList.toggle(
          "is-filtered",
          i.includes(parseInt(t.getAttribute("data-media-id")))
        ),
          t.classList.toggle(
            "is-selected",
            e === parseInt(t.getAttribute("data-media-id"))
          ),
          t.classList.toggle(
            "is-initial-selected",
            e === parseInt(t.getAttribute("data-media-id"))
          );
      }),
        this.mainCarousel.reload();
    } else {
      if (
        !e.detail.variant.featured_media ||
        this.selectedVariantMediaId === e.detail.variant.featured_media.id
      )
        return;
      this.mainCarousel.select(
        `[data-media-id="${e.detail.variant.featured_media.id}"]`
      );
    }
    this.selectedVariantMediaId = e.detail.variant.featured_media
      ? e.detail.variant.featured_media.id
      : null;
  }
  async _onFlickityReady() {
    const e = await this.mainCarousel.flickityInstance;
    ["video", "external_video"].includes(
      e.selectedElement.getAttribute("data-media-type")
    ) &&
      this.hasAttribute("autoplay-video") &&
      e.selectedElement.firstElementChild.play();
  }
  async _onFlickityChanged() {
    (await this.mainCarousel.flickityInstance).cells.forEach((e) => {
      ["external_video", "video", "model"].includes(
        e.element.getAttribute("data-media-type")
      ) && e.element.firstElementChild.pause();
    });
  }
  async _onFlickitySettled() {
    const e = (await this.mainCarousel.flickityInstance).selectedElement;
    switch (
      (this.zoomButton &&
        (this.zoomButton.hidden =
          "image" !== e.getAttribute("data-media-type")),
      this.viewInSpaceElement &&
        this.viewInSpaceElement.setAttribute(
          "data-shopify-model3d-id",
          this.viewInSpaceElement.getAttribute(
            "data-shopify-model3d-default-id"
          )
        ),
      e.getAttribute("data-media-type"))
    ) {
      case "model":
        this.viewInSpaceElement.setAttribute(
          "data-shopify-model3d-id",
          e.getAttribute("data-media-id")
        ),
          e.firstElementChild.play();
        break;
      case "external_video":
      case "video":
        this.hasAttribute("autoplay-video") && e.firstElementChild.play();
    }
  }
};

function formatMoney(e, t = "") {
  "string" == typeof e && (e = e.replace(".", ""));
  const i = /\{\{\s*(\w+)\s*\}\}/,
    n = t || window.themeVariables.settings.moneyFormat;

  function s(e, t) {
    return null == e || e != e ? t : e;
  }

  function a(e, t, i, n) {
    if (
      ((t = s(t, 2)), (i = s(i, ",")), (n = s(n, ".")), isNaN(e) || null == e)
    )
      return 0;
    let a = (e = (e / 100).toFixed(t)).split(".");
    return (
      a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) +
      (a[1] ? n + a[1] : "")
    );
  }
  let r = "";
  switch (n.match(i)[1]) {
    case "amount":
      r = a(e, 2);
      break;
    case "amount_no_decimals":
      r = a(e, 0);
      break;
    case "amount_with_space_separator":
      r = a(e, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      r = a(e, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      r = a(e, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      r = a(e, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      r = a(e, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      r = a(e, 0, "'");
  }
  return n.indexOf("with_comma_separator"), n.replace(i, r);
}
window.customElements.define("product-media", ProductMedia);
var ProductMeta = class extends HTMLElement {
  connectedCallback() {
    document
      .getElementById(this.getAttribute("form-id"))
      ?.addEventListener("variant:changed", this._onVariantChanged.bind(this));
  }
  get priceClass() {
    return this.getAttribute("price-class") || "";
  }
  get unitPriceClass() {
    return this.getAttribute("unit-price-class") || "";
  }
  _onVariantChanged(e) {
    this._updateLabels(e.detail.variant),
      this._updatePrices(e.detail.variant),
      this._updateSku(e.detail.variant);
  }
  _updateLabels(e) {
    let t = this.querySelector("[data-product-label-list]");
    if (t)
      if (e)
        if (((t.innerHTML = ""), e.available)) {
          if (e.compare_at_price > e.price) {
            let i = "";
            (i =
              "percentage" === window.themeVariables.settings.discountMode
                ? `${Math.round(
                    (100 * (e.compare_at_price - e.price)) / e.compare_at_price
                  )}%`
                : formatMoney(e.compare_at_price - e.price)),
              (t.innerHTML = `<span class="label label--highlight">${window.themeVariables.strings.collectionDiscount.replace(
                "@savings@",
                i
              )}</span>`);
          }
        } else
          t.innerHTML = `<span class="label label--subdued">${window.themeVariables.strings.collectionSoldOut}</span>`;
      else t.innerHTML = "";
  }
  _updatePrices(e) {
    let t = this.querySelector("[data-product-price-list]"),
      i = window.themeVariables.settings.currencyCodeEnabled
        ? window.themeVariables.settings.moneyWithCurrencyFormat
        : window.themeVariables.settings.moneyFormat;
    if (t)
      if (e) {
        if (
          ((t.innerHTML = ""),
          e.compare_at_price > e.price
            ? ((t.innerHTML += `<span class="price price--highlight ${
                this.priceClass
              }"><span class="visually-hidden">${
                window.themeVariables.strings.productSalePrice
              }</span>${formatMoney(e.price, i)}</span>`),
              (t.innerHTML += `<span class="price price--compare"><span class="visually-hidden">${
                window.themeVariables.strings.productRegularPrice
              }</span>${formatMoney(e.compare_at_price, i)}</span>`))
            : (t.innerHTML += `<span class="price ${
                this.priceClass
              }"><span class="visually-hidden">${
                window.themeVariables.strings.productSalePrice
              }</span>${formatMoney(e.price, i)}</span>`),
          e.unit_price_measurement)
        ) {
          let i = "";
          1 !== e.unit_price_measurement.reference_value &&
            (i = `<span class="unit-price-measurement__reference-value">${e.unit_price_measurement.reference_value}</span>`),
            (t.innerHTML += `\n          <div class="price text--subdued ${
              this.unitPriceClass
            }">\n            <div class="unit-price-measurement">\n              <span class="unit-price-measurement__price">${formatMoney(
              e.unit_price
            )}</span>\n              <span class="unit-price-measurement__separator">/</span>\n              ${i}\n              <span class="unit-price-measurement__reference-unit">${
              e.unit_price_measurement.reference_unit
            }</span>\n            </div>\n          </div>\n        `);
        }
        t.style.display = "";
      } else t.style.display = "none";
  }
  _updateSku(e) {
    let t = this.querySelector("[data-product-sku-container]");
    if (!t) return;
    let i = t.querySelector("[data-product-sku-number]");
    e && e.sku
      ? ((i.innerHTML = e.sku), (t.style.display = ""))
      : (t.style.display = "none");
  }
};
window.customElements.define("product-meta", ProductMeta);
var QuickBuyDrawer = class extends DrawerContent {
  connectedCallback() {
    super.connectedCallback(),
      this.delegate.on("variant:changed", this._onVariantChanged.bind(this));
  }
  async _load() {
    await super._load(),
      (this.imageElement = this.querySelector(".quick-buy-product__image")),
      window.Shopify &&
        window.Shopify.PaymentButton &&
        window.Shopify.PaymentButton.init();
  }
  _onVariantChanged(e) {
    const t = e.detail.variant;
    if (
      (t &&
        Array.from(this.querySelectorAll('[href*="/products"]')).forEach(
          (e) => {
            const i = new URL(e.href);
            i.searchParams.set("variant", t.id),
              e.setAttribute("href", i.toString());
          }
        ),
      !this.imageElement || !t || !t.featured_media)
    )
      return;
    const i = t.featured_media;
    i.alt && this.imageElement.setAttribute("alt", i.alt),
      this.imageElement.setAttribute("width", i.preview_image.width),
      this.imageElement.setAttribute("height", i.preview_image.height),
      this.imageElement.setAttribute("src", getSizedMediaUrl(i, "342x")),
      this.imageElement.setAttribute(
        "srcset",
        getMediaSrcset(i, [114, 228, 342])
      );
  }
};
window.customElements.define("quick-buy-drawer", QuickBuyDrawer);
var QuickBuyPopover = class extends PopoverContent {
  connectedCallback() {
    super.connectedCallback(),
      this.delegate.on("variant:changed", this._onVariantChanged.bind(this)),
      this.delegate.on("variant:added", () => (this.open = !1));
  }
  async _load() {
    await super._load(),
      (this.imageElement = this.querySelector(".quick-buy-product__image"));
  }
  _onVariantChanged(e) {
    const t = e.detail.variant;
    if (
      (t &&
        Array.from(this.querySelectorAll('[href*="/products"]')).forEach(
          (e) => {
            const i = new URL(e.href);
            i.searchParams.set("variant", t.id),
              e.setAttribute("href", i.toString());
          }
        ),
      !this.imageElement || !t || !t.featured_media)
    )
      return;
    const i = t.featured_media;
    i.alt && this.imageElement.setAttribute("alt", i.alt),
      this.imageElement.setAttribute("width", i.preview_image.width),
      this.imageElement.setAttribute("height", i.preview_image.height),
      this.imageElement.setAttribute("src", getSizedMediaUrl(i, "195x")),
      this.imageElement.setAttribute(
        "srcset",
        getMediaSrcset(i, [65, 130, 195])
      );
  }
};
window.customElements.define("quick-buy-popover", QuickBuyPopover);
var StorePickup = class extends HTMLElement {
  connectedCallback() {
    document
      .getElementById(this.getAttribute("form-id"))
      ?.addEventListener("variant:changed", this._onVariantChanged.bind(this));
  }
  _onVariantChanged(e) {
    e.detail.variant
      ? this._renderForVariant(e.detail.variant.id)
      : (this.innerHTML = "");
  }
  async _renderForVariant(e) {
    const t = await fetch(
        `${window.themeVariables.routes.rootUrlWithoutSlash}/variants/${e}?section_id=store-availability`
      ),
      i = document.createElement("div");
    (i.innerHTML = await t.text()),
      (this.innerHTML = i.firstElementChild.innerHTML.trim());
  }
};
window.customElements.define("store-pickup", StorePickup);
var ProductVariants = class extends CustomHTMLElement {
  async connectedCallback() {
    (this.masterSelector = document.getElementById(
      this.getAttribute("form-id")
    ).id),
      (this.optionSelectors = Array.from(
        this.querySelectorAll("[data-selector-type]")
      )),
      this.masterSelector
        ? ((this.product = await ProductLoader.load(this.productHandle)),
          this.delegate.on(
            "change",
            '[name^="option"]',
            this._onOptionChanged.bind(this)
          ),
          this.masterSelector.addEventListener(
            "change",
            this._onMasterSelectorChanged.bind(this)
          ),
          this._updateDisableSelectors(),
          this.selectVariant(this.selectedVariant.id))
        : console.warn(
            `The variant selector for product with handle ${this.productHandle} is not linked to any product form.`
          );
  }
  get selectedVariant() {
    return this._getVariantById(parseInt(this.masterSelector.value));
  }
  get productHandle() {
    return this.getAttribute("handle");
  }
  get hideSoldOutVariants() {
    return this.hasAttribute("hide-sold-out-variants");
  }
  get updateUrl() {
    return this.hasAttribute("update-url");
  }
  selectVariant(e) {
    if (
      (this._isVariantSelectable(this._getVariantById(e)) ||
        (e = this._getFirstMatchingAvailableOrSelectableVariant().id),
      this.selectedVariant?.id !== e)
    ) {
      if (
        ((this.masterSelector.value = e),
        this.masterSelector.dispatchEvent(
          new Event("change", {
            bubbles: !0,
          })
        ),
        this.updateUrl && history.replaceState)
      ) {
        const t = new URL(window.location.href);
        e ? t.searchParams.set("variant", e) : t.searchParams.delete("variant"),
          window.history.replaceState(
            {
              path: t.toString(),
            },
            "",
            t.toString()
          );
      }
      this._updateDisableSelectors(),
        triggerEvent(this.masterSelector.form, "variant:changed", {
          variant: this.selectedVariant,
        });
    }
  }
  _onOptionChanged() {
    this.selectVariant(this._getVariantFromOptions()?.id);
  }
  _onMasterSelectorChanged() {
    (this.selectedVariant?.options || []).forEach((e, t) => {
      let i = this.querySelector(
          `input[name="option${t + 1}"][value="${CSS.escape(
            e
          )}"], select[name="option${t + 1}"]`
        ),
        n = !1;
      "SELECT" === i.tagName
        ? ((n = i.value !== e), (i.value = e))
        : "INPUT" === i.tagName &&
          ((n = !i.checked && i.value === e), (i.checked = i.value === e)),
        n &&
          i.dispatchEvent(
            new Event("change", {
              bubbles: !0,
            })
          );
    });
  }
  _getVariantById(e) {
    return this.product.variants.find((t) => t.id === e);
  }
  _getVariantFromOptions() {
    const e = this._getSelectedOptionValues();
    return this.product.variants.find((t) =>
      t.options.every((t, i) => t === e[i])
    );
  }
  _isVariantSelectable(e) {
    return !!e && (e.available || (!this.hideSoldOutVariants && !e.available));
  }
  _getFirstMatchingAvailableOrSelectableVariant() {
    let e = this._getSelectedOptionValues(),
      t = null,
      i = 0;
    do {
      e.pop(),
        (i += 1),
        (t = this.product.variants.find((t) =>
          this.hideSoldOutVariants
            ? t.available &&
              t.options
                .slice(0, t.options.length - i)
                .every((t, i) => t === e[i])
            : t.options
                .slice(0, t.options.length - i)
                .every((t, i) => t === e[i])
        ));
    } while (!t && e.length > 0);
    return t;
  }
  _getSelectedOptionValues() {
    const e = [];
    return (
      Array.from(
        this.querySelectorAll(
          'input[name^="option"]:checked, select[name^="option"]'
        )
      ).forEach((t) => e.push(t.value)),
      e
    );
  }
  _updateDisableSelectors() {
    const e = this.selectedVariant;
    if (!e) return;
    const t = (e, t, i, n) => {
      let s = "";
      switch (e.getAttribute("data-selector-type")) {
        case "color":
          s = `.color-swatch:nth-child(${t + 1})`;
          break;
        case "variant-image":
          s = `.variant-swatch:nth-child(${t + 1})`;
          break;
        case "block":
          s = `.block-swatch:nth-child(${t + 1})`;
          break;
        case "dropdown":
          s = `.combo-box__option-item:nth-child(${t + 1})`;
      }
      e.querySelector(s).toggleAttribute("hidden", !n),
        this.hideSoldOutVariants
          ? e.querySelector(s).toggleAttribute("hidden", !i)
          : e.querySelector(s).classList.toggle("is-disabled", !i);
    };
    this.optionSelectors &&
      this.optionSelectors[0] &&
      this.product.options[0].values.forEach((i, n) => {
        const s = this.product.variants.some((e) => e.option1 === i && e),
          a = this.product.variants.some((e) => e.option1 === i && e.available);
        t(this.optionSelectors[0], n, a, s),
          this.optionSelectors[1] &&
            this.product.options[1].values.forEach((i, n) => {
              const s = this.product.variants.some(
                  (t) => t.option2 === i && t.option1 === e.option1 && t
                ),
                a = this.product.variants.some(
                  (t) =>
                    t.option2 === i && t.option1 === e.option1 && t.available
                );
              t(this.optionSelectors[1], n, a, s),
                this.optionSelectors[2] &&
                  this.product.options[2].values.forEach((i, n) => {
                    const s = this.product.variants.some(
                        (t) =>
                          t.option3 === i &&
                          t.option1 === e.option1 &&
                          t.option2 === e.option2 &&
                          t
                      ),
                      a = this.product.variants.some(
                        (t) =>
                          t.option3 === i &&
                          t.option1 === e.option1 &&
                          t.option2 === e.option2 &&
                          t.available
                      );
                    t(this.optionSelectors[2], n, a, s);
                  });
            });
      });
  }
};
window.customElements.define("product-variants", ProductVariants);
var ProductItem = class extends CustomHTMLElement {
  connectedCallback() {
    (this.primaryImageList = Array.from(
      this.querySelectorAll(".product-item__primary-image")
    )),
      this.delegate.on(
        "change",
        ".product-item-meta__swatch-list .color-swatch__radio",
        this._onColorSwatchChanged.bind(this)
      ),
      this.delegate.on(
        "mouseenter",
        ".product-item-meta__swatch-list .color-swatch__item",
        this._onColorSwatchHovered.bind(this),
        !0
      );
  }
  async _onColorSwatchChanged(e, t) {
    if (
      (Array.from(this.querySelectorAll('[href*="/products"]')).forEach((e) => {
        let i;
        (i =
          "A" === e.tagName
            ? new URL(e.href)
            : new URL(
                e.getAttribute("href"),
                `https://${window.themeVariables.routes.host}`
              )),
          i.searchParams.set("variant", t.getAttribute("data-variant-id")),
          e.setAttribute("href", i.toString());
      }),
      t.hasAttribute("data-variant-featured-media"))
    ) {
      const e = this.primaryImageList.find(
        (e) =>
          e.getAttribute("data-media-id") ===
          t.getAttribute("data-variant-featured-media")
      );
      e.setAttribute("loading", "eager");
      const i = e.complete
        ? Promise.resolve()
        : new Promise((t) => (e.onload = t));
      await i, e.removeAttribute("hidden");
      let n = {};
      (n = Array.from(e.parentElement.classList).some((e) =>
        [
          "aspect-ratio--short",
          "aspect-ratio--tall",
          "aspect-ratio--square",
        ].includes(e)
      )
        ? [
            {
              clipPath: "polygon(0 0, 0 0, 0 100%, 0% 100%)",
              transform: "translate(calc(-50% - 20px), -50%)",
              zIndex: 1,
              offset: 0,
            },
            {
              clipPath: "polygon(0 0, 20% 0, 5% 100%, 0 100%)",
              transform: "translate(calc(-50% - 20px), -50%)",
              zIndex: 1,
              offset: 0.3,
            },
            {
              clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
              transform: "translate(-50%, -50%)",
              zIndex: 1,
              offset: 1,
            },
          ]
        : [
            {
              clipPath: "polygon(0 0, 0 0, 0 100%, 0% 100%)",
              transform: "translateX(-20px)",
              zIndex: 1,
              offset: 0,
            },
            {
              clipPath: "polygon(0 0, 20% 0, 5% 100%, 0 100%)",
              transform: "translateX(-20px)",
              zIndex: 1,
              offset: 0.3,
            },
            {
              clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
              transform: "translateX(0px)",
              zIndex: 1,
              offset: 1,
            },
          ]),
        await e.animate(n, {
          duration: 500,
          easing: "ease-in-out",
        }).finished,
        this.primaryImageList
          .filter(
            (t) =>
              t.classList.contains("product-item__primary-image") && t !== e
          )
          .forEach((e) => e.setAttribute("hidden", ""));
    }
  }
  _onColorSwatchHovered(e, t) {
    const i = t.previousElementSibling;
    i.hasAttribute("data-variant-featured-media") &&
      this.primaryImageList
        .find(
          (e) =>
            e.getAttribute("data-media-id") ===
            i.getAttribute("data-variant-featured-media")
        )
        .setAttribute("loading", "eager");
  }
};
window.customElements.define("product-item", ProductItem);
var ProductFacet = class extends CustomHTMLElement {
  connectedCallback() {
    this.delegate.on("pagination:page-changed", this._rerender.bind(this)),
      this.delegate.on("facet:criteria-changed", this._rerender.bind(this)),
      this.delegate.on("facet:abort-loading", this._abort.bind(this));
  }
  async _rerender(e) {
    history.replaceState({}, "", e.detail.url),
      this._abort(),
      this.showLoadingBar();
    const t = new URL(window.location);
    t.searchParams.set("section_id", this.getAttribute("section-id"));
    try {
      this.abortController = new AbortController();
      const e = await fetch(t.toString(), {
          signal: this.abortController.signal,
        }),
        i = await e.text(),
        n = document.createElement("div");
      (n.innerHTML = i),
        (this.querySelector("#facet-main").innerHTML =
          n.querySelector("#facet-main").innerHTML);
      const s = Array.from(n.querySelectorAll(".product-facet__active-list")),
        a = document.querySelector(".mobile-toolbar__item--filters");
      a && a.classList.toggle("has-filters", s.length > 0);
      const r = n.querySelector("#facet-filters");
      if (r) {
        const e = this.querySelector(
          "#facet-filters .drawer__content"
        ).scrollTop;
        Array.from(
          this.querySelectorAll(
            "#facet-filters-form .collapsible-toggle[aria-controls]"
          )
        ).forEach((e) => {
          const t = r.querySelector(
              `[aria-controls="${e.getAttribute("aria-controls")}"]`
            ),
            i = "true" === e.getAttribute("aria-expanded");
          t.setAttribute("aria-expanded", i ? "true" : "false"),
            t.nextElementSibling.toggleAttribute("open", i),
            (t.nextElementSibling.style.overflow = i ? "visible" : "");
        }),
          (this.querySelector("#facet-filters").innerHTML = r.innerHTML),
          (this.querySelector("#facet-filters .drawer__content").scrollTop = e);
      }
      const o =
        this.querySelector(".product-facet__meta-bar") ||
        this.querySelector(".product-facet__product-list") ||
        this.querySelector(".product-facet__main");
      requestAnimationFrame(() => {
        o.scrollIntoView({
          block: "start",
          behavior: "smooth",
        });
      }),
        this.hideLoadingBar();
    } catch (e) {
      if ("AbortError" === e.name) return;
    }
  }
  _abort() {
    this.abortController && this.abortController.abort();
  }
};
window.customElements.define("product-facet", ProductFacet);
var FacetFilters = class extends DrawerContent {
  connectedCallback() {
    super.connectedCallback(),
      this.delegate.on(
        "change",
        '[name^="filter."]',
        this._onFilterChanged.bind(this)
      ),
      this.rootDelegate.on(
        "click",
        '[data-action="clear-filters"]',
        this._onFiltersCleared.bind(this)
      ),
      this.alwaysVisible &&
        ((this.matchMedia = window.matchMedia(
          window.themeVariables.breakpoints.pocket
        )),
        this.matchMedia.addListener(this._adjustDrawer.bind(this)),
        this._adjustDrawer(this.matchMedia));
  }
  get alwaysVisible() {
    return this.hasAttribute("always-visible");
  }
  _onFiltersCleared(e, t) {
    e.preventDefault(),
      triggerEvent(this, "facet:criteria-changed", {
        url: t.href,
      });
  }
  _onFilterChanged() {
    const e = new FormData(this.querySelector("#facet-filters-form")),
      t = new URLSearchParams(e).toString();
    triggerEvent(this, "facet:criteria-changed", {
      url: `${window.location.pathname}?${t}`,
    });
  }
  _adjustDrawer(e) {
    this.classList.toggle("drawer", e.matches),
      this.classList.toggle("drawer--from-left", e.matches);
  }
};
window.customElements.define("facet-filters", FacetFilters);
var SortByPopover = class extends PopoverContent {
  connectedCallback() {
    super.connectedCallback(),
      this.delegate.on(
        "change",
        '[name="sort_by"]',
        this._onSortChanged.bind(this)
      );
  }
  _onSortChanged(e, t) {
    const i = new URL(location.href);
    i.searchParams.set("sort_by", t.value),
      i.searchParams.delete("page"),
      (this.open = !1),
      this.dispatchEvent(
        new CustomEvent("facet:criteria-changed", {
          bubbles: !0,
          detail: {
            url: i.toString(),
          },
        })
      );
  }
};
window.customElements.define("sort-by-popover", SortByPopover);
var CartCount = class extends CustomHTMLElement {
  connectedCallback() {
    this.rootDelegate.on(
      "cart:updated",
      (e) => (this.innerText = e.detail.cart.item_count)
    ),
      this.rootDelegate.on("cart:refresh", this._updateCartCount.bind(this));
  }
  _updateCartCount(e) {
    e?.detail?.cart
      ? (this.innerText = e.detail.cart.item_count)
      : fetch(Shopify.routes.root + "cart.js").then((e) => {
          e.json().then((e) => {
            this.innerText = e.item_count;
          });
        });
  }
};
window.customElements.define("cart-count", CartCount);
var CartDrawer = class extends DrawerContent {
  connectedCallback() {
    super.connectedCallback(),
      (this.nextReplacementDelay = 0),
      this.rootDelegate.on("cart:refresh", this._rerenderCart.bind(this)),
      this.addEventListener(
        "variant:added",
        () => (this.nextReplacementDelay = 600)
      );
  }
  async _rerenderCart(e) {
    let t = null,
      i = "";
    if (e.detail && e.detail.cart && e.detail.cart.sections)
      (t = e.detail.cart), (i = e.detail.cart.sections["mini-cart"]);
    else {
      const e = await fetch(
        `${window.themeVariables.routes.cartUrl}?section_id=${this.getAttribute(
          "section"
        )}`
      );
      i = await e.text();
    }
    const n = document.createElement("div");
    (n.innerHTML = i),
      setTimeout(async () => {
        const i = this.querySelector(".drawer__content").scrollTop;
        if (t && 0 === t.item_count) {
          const e = new CustomAnimation(
            new ParallelEffect(
              Array.from(
                this.querySelectorAll(".drawer__content, .drawer__footer")
              ).map(
                (e) =>
                  new CustomKeyframeEffect(
                    e,
                    {
                      opacity: [1, 0],
                    },
                    {
                      duration: 250,
                      easing: "ease-in",
                    }
                  )
              )
            )
          );
          e.play(), await e.finished;
        }
        (this.innerHTML = n.querySelector("cart-drawer").innerHTML),
          t && 0 === t.item_count
            ? this.querySelector(".drawer__content").animate(
                {
                  opacity: [0, 1],
                  transform: ["translateY(40px)", "translateY(0)"],
                },
                {
                  duration: 450,
                  easing: "cubic-bezier(0.33, 1, 0.68, 1)",
                }
              )
            : (this.querySelector(".drawer__content").scrollTop = i),
          e?.detail?.openMiniCart && (this.clientWidth, (this.open = !0));
      }, e?.detail?.replacementDelay || this.nextReplacementDelay),
      (this.nextReplacementDelay = 0);
  }
  async attributeChangedCallback(e, t, i) {
    if (
      (super.attributeChangedCallback(e, t, i),
      "open" === e &&
        this.open &&
        ((this.querySelector(".drawer__content").scrollTop = 0),
        !MediaFeatures.prefersReducedMotion()))
    ) {
      const e = Array.from(this.querySelectorAll(".line-item")),
        t = this.querySelector(".mini-cart__recommendations-inner"),
        i = this.querySelector(".drawer__footer"),
        n = [];
      t &&
        window.matchMedia(window.themeVariables.breakpoints.pocket).matches &&
        e.push(t),
        e.forEach((e) => (e.style.opacity = 0)),
        t && (t.style.opacity = 0),
        i && (i.style.opacity = 0),
        n.push(
          new ParallelEffect(
            e.map(
              (e, t) =>
                new CustomKeyframeEffect(
                  e,
                  {
                    opacity: [0, 1],
                    transform: ["translateX(40px)", "translateX(0)"],
                  },
                  {
                    duration: 400,
                    delay: 400 + 120 * t - Math.min(2 * t * t, 120 * t),
                    easing: "cubic-bezier(0.25, 1, 0.5, 1)",
                  }
                )
            )
          )
        ),
        i &&
          n.push(
            new CustomKeyframeEffect(
              i,
              {
                opacity: [0, 1],
                transform: ["translateY(100%)", "translateY(0)"],
              },
              {
                duration: 300,
                delay: 400,
                easing: "cubic-bezier(0.25, 1, 0.5, 1)",
              }
            )
          ),
        t &&
          !window.matchMedia(window.themeVariables.breakpoints.pocket)
            .matches &&
          n.push(
            new CustomKeyframeEffect(
              t,
              {
                opacity: [0, 1],
                transform: ["translateX(100%)", "translateX(0)"],
              },
              {
                duration: 250,
                delay: 400 + Math.max(120 * e.length - 25 * e.length, 25),
                easing: "cubic-bezier(0.25, 1, 0.5, 1)",
              }
            )
          ),
        new CustomAnimation(new ParallelEffect(n)).play();
    }
  }
};
window.customElements.define("cart-drawer", CartDrawer);
var _CartDrawerRecommendations = class e extends HTMLElement {
  async connectedCallback() {
    e.recommendationsCache[this.productId] ||
      (e.recommendationsCache[this.productId] = fetch(
        `${window.themeVariables.routes.productRecommendationsUrl}?product_id=${this.productId}&limit=10&section_id=${this.sectionId}`
      ));
    const t = await e.recommendationsCache[this.productId],
      i = document.createElement("div");
    i.innerHTML = await t.clone().text();
    const n = i.querySelector("cart-drawer-recommendations");
    n && n.hasChildNodes()
      ? (this.innerHTML = n.innerHTML)
      : (this.hidden = !0);
  }
  get productId() {
    return this.getAttribute("product-id");
  }
  get sectionId() {
    return this.getAttribute("section-id");
  }
};
__publicField(_CartDrawerRecommendations, "recommendationsCache", {});
var CartDrawerRecommendations = _CartDrawerRecommendations;
window.customElements.define(
  "cart-drawer-recommendations",
  CartDrawerRecommendations
);
var CartNote = class extends HTMLTextAreaElement {
  connectedCallback() {
    this.addEventListener("change", this._onNoteChanged.bind(this));
  }
  get ownedToggle() {
    return this.hasAttribute("aria-owns")
      ? document.getElementById(this.getAttribute("aria-owns"))
      : null;
  }
  async _onNoteChanged() {
    this.ownedToggle &&
      (this.ownedToggle.innerHTML =
        "" === this.value
          ? window.themeVariables.strings.cartAddOrderNote
          : window.themeVariables.strings.cartEditOrderNote);
    const e = await fetch(`${window.themeVariables.routes.cartUrl}/update.js`, {
        body: JSON.stringify({
          note: this.value,
        }),
        credentials: "same-origin",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      }),
      t = await e.json();
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:updated", {
        bubbles: !0,
        detail: {
          cart: t,
        },
      })
    );
  }
};
window.customElements.define("cart-note", CartNote, {
  extends: "textarea",
});
var FreeShippingBar = class extends HTMLElement {
  connectedCallback() {
    document.documentElement.addEventListener(
      "cart:updated",
      this._onCartUpdated.bind(this)
    );
  }
  get threshold() {
    return parseFloat(this.getAttribute("threshold"));
  }
  _onCartUpdated(e) {
    const t = e.detail.cart.items
      .filter((e) => e.requires_shipping)
      .reduce((e, t) => e + t.final_line_price, 0);
    this.style.setProperty("--progress", Math.min(t / this.threshold, 1));
  }
};
window.customElements.define("free-shipping-bar", FreeShippingBar);
var LineItemQuantity = class extends CustomHTMLElement {
  connectedCallback() {
    this.delegate.on("click", "a", this._onQuantityLinkClicked.bind(this)),
      this.delegate.on("change", "input", this._onQuantityChanged.bind(this));
  }
  _onQuantityLinkClicked(e, t) {
    e.preventDefault(), this._updateFromLink(t.href);
  }
  _onQuantityChanged(e, t) {
    this._updateFromLink(
      `${window.themeVariables.routes.cartChangeUrl}?quantity=${
        t.value
      }&line=${t.getAttribute("data-line")}`
    );
  }
  async _updateFromLink(e) {
    if ("cart" === window.themeVariables.settings.pageType)
      return void (window.location.href = e);
    const t = new URL(e, `https://${window.themeVariables.routes.host}`)
        .searchParams,
      i = t.get("line"),
      n = t.get("id"),
      s = parseInt(t.get("quantity"));
    this.dispatchEvent(
      new CustomEvent("line-item-quantity:change:start", {
        bubbles: !0,
        detail: {
          newLineQuantity: s,
        },
      })
    );
    const a = await fetch(`${window.themeVariables.routes.cartChangeUrl}.js`, {
        body: JSON.stringify({
          line: i,
          id: n,
          quantity: s,
          sections: ["mini-cart"],
        }),
        credentials: "same-origin",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      }),
      r = await a.json();
    this.dispatchEvent(
      new CustomEvent("line-item-quantity:change:end", {
        bubbles: !0,
        detail: {
          cart: r,
          newLineQuantity: s,
        },
      })
    ),
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:updated", {
          bubbles: !0,
          detail: {
            cart: r,
          },
        })
      ),
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: !0,
          detail: {
            cart: r,
            replacementDelay: 0 === s ? 600 : 750,
          },
        })
      ),
      updateCartCount();
  }
};
window.customElements.define("line-item-quantity", LineItemQuantity);
var LineItem = class extends HTMLElement {
  connectedCallback() {
    (this.lineItemLoader = this.querySelector(".line-item__loader")),
      this.addEventListener(
        "line-item-quantity:change:start",
        this._onQuantityStart.bind(this)
      ),
      this.addEventListener(
        "line-item-quantity:change:end",
        this._onQuantityEnd.bind(this)
      );
  }
  _onQuantityStart() {
    this.lineItemLoader &&
      ((this.lineItemLoader.hidden = !1),
      (this.lineItemLoader.firstElementChild.hidden = !1),
      (this.lineItemLoader.lastElementChild.hidden = !0));
  }
  async _onQuantityEnd(e) {
    0 !== e.detail.cart.item_count &&
      this.lineItemLoader &&
      (await this.lineItemLoader.firstElementChild.animate(
        {
          opacity: [1, 0],
          transform: ["translateY(0)", "translateY(-10px)"],
        },
        75
      ).finished,
      (this.lineItemLoader.firstElementChild.hidden = !0),
      0 === e.detail.newLineQuantity
        ? (await this.animate(
            {
              opacity: [1, 0],
              height: [`${this.clientHeight}px`, 0],
            },
            {
              duration: 300,
              easing: "ease",
            }
          ).finished,
          this.remove())
        : ((this.lineItemLoader.lastElementChild.hidden = !1),
          await this.lineItemLoader.lastElementChild.animate(
            {
              opacity: [0, 1],
              transform: ["translateY(10px)", "translateY(0)"],
            },
            {
              duration: 75,
              endDelay: 300,
            }
          ).finished,
          (this.lineItemLoader.hidden = !0)));
  }
};
window.customElements.define("line-item", LineItem);
var CartNotification = class extends CustomHTMLElement {
  connectedCallback() {
    this.rootDelegate.on(
      "cart-notification:show",
      this._onShow.bind(this),
      !this.hasAttribute("global")
    ),
      this.delegate.on("click", '[data-action="close"]', (e) => {
        e.stopPropagation(), (this.hidden = !0);
      }),
      this.addEventListener("mouseenter", this.stopTimer.bind(this)),
      this.addEventListener("mouseleave", this.startTimer.bind(this)),
      window.addEventListener("pagehide", () => (this.hidden = !0));
  }
  set hidden(e) {
    e ? this.stopTimer() : this.startTimer(), this.toggleAttribute("hidden", e);
  }
  get isInsideDrawer() {
    return this.classList.contains("cart-notification--drawer");
  }
  stopTimer() {
    clearTimeout(this._timeout);
  }
  startTimer() {
    this._timeout = setTimeout(() => (this.hidden = !0), 3e3);
  }
  _onShow(e) {
    if (this.isInsideDrawer && !this.closest(".drawer").open) return;
    if (
      this.hasAttribute("global") &&
      "success" === e.detail.status &&
      "drawer" === window.themeVariables.settings.cartType
    )
      return;
    e.stopPropagation();
    let t = "";
    this.isInsideDrawer ||
      (t = `\n        <button class="cart-notification__close tap-area hidden-phone" data-action="close">\n          <span class="visually-hidden">${window.themeVariables.strings.accessibilityClose}</span>\n          <svg focusable="false" width="14" height="14" class="icon icon--close icon--inline" viewBox="0 0 14 14">\n            <path d="M13 13L1 1M13 1L1 13" stroke="currentColor" stroke-width="2" fill="none"></path>\n          </svg>\n        </button>\n      `),
      "success" === e.detail.status
        ? (this.classList.remove("cart-notification--error"),
          setTimeout(function () {
            document.getElementById("mini-cart").open = !0;
          }, 2e3))
        : (this.classList.add("cart-notification--error"),
          (this.innerHTML = `\n        <div class="cart-notification__overflow">\n          <div class="container">\n            <div class="cart-notification__wrapper">\n              <svg focusable="false" width="20" height="20" class="icon icon--cart-notification" viewBox="0 0 20 20">\n                <rect width="20" height="20" rx="10" fill="currentColor"></rect>\n                <path d="M9.6748 13.2798C9.90332 13.0555 10.1763 12.9434 10.4937 12.9434C10.811 12.9434 11.0819 13.0555 11.3062 13.2798C11.5347 13.5041 11.6489 13.7749 11.6489 14.0923C11.6489 14.4097 11.5347 14.6847 11.3062 14.9175C11.0819 15.146 10.811 15.2603 10.4937 15.2603C10.1763 15.2603 9.90332 15.146 9.6748 14.9175C9.45052 14.6847 9.33838 14.4097 9.33838 14.0923C9.33838 13.7749 9.45052 13.5041 9.6748 13.2798ZM9.56689 12.1816V5.19922H11.4141V12.1816H9.56689Z" fill="rgb(var(--error-color))"></path>\n              </svg>\n              \n              <div class="cart-notification__text-wrapper">\n                <span class="cart-notification__heading heading">${e.detail.error}</span>\n              </div>\n              \n              ${t}\n            </div>\n          </div>\n        </div>\n      `)),
      this.clientHeight,
      (this.hidden = !1);
  }
};
window.customElements.define("cart-notification", CartNotification);
var ShippingEstimator = class extends HTMLElement {
  connectedCallback() {
    (this.submitButton = this.querySelector('[type="button"]')),
      this.submitButton.addEventListener(
        "click",
        this._estimateShipping.bind(this)
      );
  }
  async _estimateShipping() {
    const e = this.querySelector('[name="shipping-estimator[zip]"]').value,
      t = this.querySelector('[name="shipping-estimator[country]"]').value,
      i = this.querySelector('[name="shipping-estimator[province]"]').value;
    this.submitButton.setAttribute("aria-busy", "true");
    const n = await fetch(
      `${window.themeVariables.routes.cartUrl}/prepare_shipping_rates.json?shipping_address[zip]=${e}&shipping_address[country]=${t}&shipping_address[province]=${i}`,
      {
        method: "POST",
      }
    );
    if (n.ok) {
      const n = await this._getAsyncShippingRates(e, t, i);
      this._formatShippingRates(n);
    } else {
      const e = await n.json();
      this._formatError(e);
    }
    this.submitButton.removeAttribute("aria-busy");
  }
  async _getAsyncShippingRates(e, t, i) {
    const n = await fetch(
        `${window.themeVariables.routes.cartUrl}/async_shipping_rates.json?shipping_address[zip]=${e}&shipping_address[country]=${t}&shipping_address[province]=${i}`
      ),
      s = await n.text();
    return "null" === s
      ? this._getAsyncShippingRates(e, t, i)
      : JSON.parse(s).shipping_rates;
  }
  _formatShippingRates(e) {
    this.querySelector(".shipping-estimator__results")?.remove();
    let t = "";
    e.forEach((e) => {
      t += `<li>${e.presentment_name}: ${formatMoney(
        100 * parseFloat(e.price)
      )}</li>`;
    });
    const i = `\n      <div class="shipping-estimator__results">\n        <p>${
      0 === e.length
        ? window.themeVariables.strings.shippingEstimatorNoResults
        : 1 === e.length
        ? window.themeVariables.strings.shippingEstimatorOneResult
        : window.themeVariables.strings.shippingEstimatorMultipleResults
    }</p>\n        ${
      "" === t ? "" : `<ul class="unordered-list">${t}</ul>`
    }\n      </div>\n    `;
    this.insertAdjacentHTML("beforeend", i);
  }
  _formatError(e) {
    this.querySelector(".shipping-estimator__results")?.remove();
    let t = "";
    Object.keys(e).forEach((i) => {
      t += `<li>${i} ${e[i]}</li>`;
    });
    const i = `\n      <div class="shipping-estimator__results">\n        <p>${window.themeVariables.strings.shippingEstimatorError}</p>\n        <ul class="unordered-list">${t}</ul>\n      </div>\n    `;
    this.insertAdjacentHTML("beforeend", i);
  }
};
window.customElements.define("shipping-estimator", ShippingEstimator);
var ReviewLink = class extends HTMLAnchorElement {
  constructor() {
    super(), this.addEventListener("click", this._onClick.bind(this));
  }
  _onClick() {
    const e = document.getElementById("shopify-product-reviews");
    e &&
      (window.matchMedia(window.themeVariables.breakpoints.pocket).matches
        ? (e.closest("collapsible-content").open = !0)
        : document
            .querySelector(
              `[aria-controls="${
                e.closest(".product-tabs__tab-item-wrapper").id
              }"]`
            )
            .click());
  }
};
window.customElements.define("review-link", ReviewLink, {
  extends: "a",
});
var ProductStickyForm = class extends HTMLElement {
  connectedCallback() {
    document
      .getElementById(this.getAttribute("form-id"))
      ?.addEventListener("variant:changed", this._onVariantChanged.bind(this)),
      (this.imageElement = this.querySelector(".product-sticky-form__image")),
      (this.priceElement = this.querySelector(".product-sticky-form__price")),
      (this.unitPriceElement = this.querySelector(
        ".product-sticky-form__unit-price"
      )),
      this._setupVisibilityObservers();
  }
  disconnectedCallback() {
    this.intersectionObserver.disconnect();
  }
  set hidden(e) {
    this.toggleAttribute("hidden", e),
      e
        ? document.documentElement.style.removeProperty(
            "--cart-notification-offset"
          )
        : document.documentElement.style.setProperty(
            "--cart-notification-offset",
            `${this.clientHeight}px`
          );
  }
  _onVariantChanged(e) {
    const t = e.detail.variant,
      i = window.themeVariables.settings.currencyCodeEnabled
        ? window.themeVariables.settings.moneyWithCurrencyFormat
        : window.themeVariables.settings.moneyFormat;
    if (!t) return;
    if (
      (this.priceElement &&
        (this.priceElement.innerHTML = formatMoney(t.price, i)),
      this.unitPriceElement &&
        ((this.unitPriceElement.style.display = t.unit_price_measurement
          ? "block"
          : "none"),
        t.unit_price_measurement))
    ) {
      let e = "";
      1 !== t.unit_price_measurement.reference_value &&
        (e = `<span class="unit-price-measurement__reference-value">${t.unit_price_measurement.reference_value}</span>`),
        (this.unitPriceElement.innerHTML = `\n          <div class="unit-price-measurement">\n            <span class="unit-price-measurement__price">${formatMoney(
          t.unit_price
        )}</span>\n            <span class="unit-price-measurement__separator">/</span>\n            ${e}\n            <span class="unit-price-measurement__reference-unit">${
          t.unit_price_measurement.reference_unit
        }</span>\n          </div>\n        `);
    }
    if (!this.imageElement || !t || !t.featured_media) return;
    const n = t.featured_media;
    n.alt && this.imageElement.setAttribute("alt", n.alt),
      this.imageElement.setAttribute("width", n.preview_image.width),
      this.imageElement.setAttribute("height", n.preview_image.height),
      this.imageElement.setAttribute("src", getSizedMediaUrl(n, "165x")),
      this.imageElement.setAttribute(
        "srcset",
        getMediaSrcset(n, [55, 110, 165])
      );
  }
  _setupVisibilityObservers() {
    const e = document.getElementById("MainPaymentContainer"),
      t = document.querySelector(".shopify-section--footer"),
      i = getStickyHeaderOffset();
    (this._isFooterVisible = this._isPaymentContainerPassed = !1),
      (this.intersectionObserver = new IntersectionObserver(
        (n) => {
          n.forEach((n) => {
            if (
              (n.target === t &&
                (this._isFooterVisible = n.intersectionRatio > 0),
              n.target === e)
            ) {
              const t = e.getBoundingClientRect();
              this._isPaymentContainerPassed =
                0 === n.intersectionRatio && t.top + t.height <= i;
            }
          }),
            window.matchMedia(window.themeVariables.breakpoints.pocket).matches
              ? (this.hidden =
                  !this._isPaymentContainerPassed || this._isFooterVisible)
              : (this.hidden = !this._isPaymentContainerPassed);
        },
        {
          rootMargin: `-${i}px 0px 0px 0px`,
        }
      )),
      this.intersectionObserver.observe(e),
      this.intersectionObserver.observe(t);
  }
};
async function updateCartCount() {
  let e = document.querySelector(".wrapper_mini-cart__drawer-footer"),
    t = document.querySelector(
      '.header__icon-wrapper.tap-area[aria-label="Warenkorb"]'
    );
  e ? t.classList.add("black-circle") : t.classList.remove("black-circle");
  let i = await fetch("/cart.json");
  0 == !(await i.json()).item_count
    ? t.classList.add("black-circle")
    : t.classList.remove("black-circle");
}

function updateCartProperties() {
  let productName = [];
  let products = document.querySelectorAll(".starter-set-collection span");
  
  products.forEach((name) => {
    productName.push(name.innerHTML);
  });
  
  Shopify.removeItem = async function (updates) {
    try {
      await $.ajax({
        method: "POST",
        url: "/cart/update.js",
        data: {
          updates: updates,
        },
        dataType: "json",
        success: () => {
          console.log("Cart updated successfully: Against Cart Properties");
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", {
              bubbles: true,
            })
          );
          updateCartCount();
        },
        error: (error) => {
          console.error("Error updating cart:", error);
        },
      });

      propertyItemsRemove(updates);
    } catch (error) {
      // console.error("Error removing item:", error);
    }
  };

  async function propertyItemsRemove() {
    try {
      const cart = await $.getJSON("/cart.js");
      const product_item_array = cart.items;

      for (const name of productName) {
        let titleName = name.toLowerCase();
        // Check if the product is already in the cart
        const isInCart = product_item_array.some(
          (item) => item.title.toLowerCase() === titleName
        );
        let updates = {};
        let matchingProductsFound = false;
        if (!isInCart) {
          // Product not in cart, check for items with the same property name
          for (const item of product_item_array) {
            let itemTitle = item.title.toLowerCase();
            let itemProperties = item.properties;

            if (itemProperties && itemProperties.hasOwnProperty(titleName)) {
              // Remove item from the cart
              updates[item.key] = 0;
              matchingProductsFound = true;
              console.log("matchingProductsFound");
            }
            if (itemProperties && itemProperties.hasOwnProperty(titleName) && !itemProperties.hasOwnProperty('_bundle-identity')) {
              // Remove item from the cart
              updates[item.key] = 0;
              matchingProductsFound = true;
              console.log("matching Products Found With property");
            }
          }
          if (matchingProductsFound) {
            await Shopify.removeItem(updates);
            console.log("Item removed with the same property name");
          }
        } else {
          console.log("Item found in cart, do nothing");
        }
      }
    } catch (error) {
      console.error("Error removing items with the same property name:", error);
    }
  }
  propertyItemsRemove();
}

window.addEventListener("load", function () {
  updateCartProperties();
});

function propertyItemsRemoved(event) {
  event.preventDefault();
  updateCartProperties();

  // Use setTimeout to delay the redirection
  setTimeout(() => {
    // After the delay, manually trigger the click event to perform the redirection
    window.location.href = "/checkout";
  }, 3000);
}

let properties = {};

function clickElement(e) {
  return new Promise((t, i) => {
    const n = document.querySelector(e);
    n
      ? (n.click(), setTimeout(t, 500))
      : (console.warn(`Element with selector '${e}' not found`), t());
  });
}
async function clickElementsSequentially() {
  try {
    await clickElement(".add-upsell"),
      console.log("Clicked .add-upsell"),
      await clickElement(".add-free-product"),
      console.log("Clicked .add-free-product"),
      await clickElement(".add-upsell-2"),
      console.log("Clicked .add-upsell-2");
  } catch (e) {
    console.error("Error:", e.message);
  }
}
/***************/
window.customElements.define("product-sticky-form", ProductStickyForm),
  new InputBindingManager(),
  Shopify.designMode &&
    document.addEventListener("shopify:section:load", () => {
      window.SPR && (window.SPR.initDomEls(), window.SPR.loadProducts());
    }),
  (window.SPRCallbacks = {
    onFormSuccess: (e, t) => {
      document
        .getElementById(`form_${t.id}`)
        .classList.add("spr-form--success");
    },
  }),
  (() => {
    let e = window.visualViewport
        ? window.visualViewport.width
        : document.documentElement.clientWidth,
      t = () => {
        const t = window.visualViewport
            ? window.visualViewport.width
            : document.documentElement.clientWidth,
          i = window.visualViewport
            ? window.visualViewport.height
            : document.documentElement.clientHeight;
        t !== e &&
          requestAnimationFrame(() => {
            document.documentElement.style.setProperty(
              "--window-height",
              i + "px"
            ),
              (e = t);
          });
      };
    t(),
      window.visualViewport
        ? window.visualViewport.addEventListener("resize", t)
        : window.addEventListener("resize", t);
  })(),
  (() => {
    let e = new main_default(document.body);
    e.on(
      "change",
      'input:not([type="checkbox"]):not([type="radio"]), textarea',
      (e, t) => {
        t.classList.toggle("is-filled", "" !== t.value);
      }
    ),
      e.on("change", "select", (e, t) => {
        t.parentNode.classList.toggle("is-filled", "" !== t.value);
      });
  })(),
  document.querySelectorAll(".rte table").forEach((e) => {
    e.outerHTML = '<div class="table-wrapper">' + e.outerHTML + "</div>";
  }),
  document.querySelectorAll(".rte iframe").forEach((e) => {
    (-1 === e.src.indexOf("youtube") &&
      -1 === e.src.indexOf("youtu.be") &&
      -1 === e.src.indexOf("vimeo")) ||
      (e.outerHTML = '<div class="video-wrapper">' + e.outerHTML + "</div>");
  }),
  new main_default(document.documentElement).on(
    "click",
    "[data-smooth-scroll]",
    (e, t) => {
      const i = document.querySelector(t.getAttribute("href"));
      i &&
        (e.preventDefault(),
        i.scrollIntoView({
          behavior: "smooth",
          block: "start",
        }));
    }
  ),
  document.addEventListener("keyup", function (e) {
    "Tab" === e.key &&
      (document.body.classList.remove("no-focus-outline"),
      document.body.classList.add("focus-outline"));
  }),
  updateCartCount(),
  setTimeout(function () {
    -1 !== window.location.href.indexOf("https://nailuxe.de/cart") &&
      (window.location.href = "https://nailuxe.de");
  }, 100),
  window.addEventListener("load", function () {
    updateCartProperties();
  });
